<style >
    .theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea{  
        color: rgb(0 0 0 / 89%);
    }
    .titleogl{
        font-size: 16px;color: #115bb7;font-weight: bold;
    }
    .v-toolbar__title{
        color: #115bb7;font-weight: 500;
    }
    .theme--light.v-input {
        color: rgb(15, 119, 202);
    }
    .theme--light.v-text-field {
        border-color: rgb(0, 0, 0);
    }
    .theme--light.v-label {
        color: rgb(0, 0, 0);
    }
    .theme--light.v-select .v-select__selection--comma .theme--light.v-input input, .theme--light.v-input textarea{
        color: #2f6894e6;
    }
    .v-card__subtitle, .v-card__text{
            letter-spacing: 0;
    }
    .v-application--is-ltr .v-data-footer__select .v-select{
            margin: 2px 0 5px 34px;
    }
    .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child){
            margin-bottom:0px;
    }
    .v-text-field.v-text-field--enclosed .v-text-field__details{
        margin-bottom:0px;
    }
    .v-application .mr-2{
        margin-left: 8px !important;        
    }
    .theme--light.v-data-table tbody tr:last-child td{
        padding: 0 5;
    }
    .v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before{
        opacity: 0.9;
    }
    input[type="file"]{
    position: absolute;
    top: -500px;
  }

  div.file-listing{
    width: 200px;
  }

  span.remove-file{
    color: red;
    cursor: pointer;
    float: right;
  }
  #viewe {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: rgb(214 214 214);
  margin-top: 10px;
  width: 100%;
}
.theme--light.v-data-table tbody tr:last-child td{
    padding: 0.08rem .08rem;
}

/* 1. Fondo y estilo de la cabecera */
.tabla-moderna .v-data-table-header {
    background-color: #f4f6f8 !important; /* Gris/Azul muy claro para separar la cabecera */
}

.tabla-moderna .v-data-table-header th {
    color: #115bb7 !important; /* Tu azul corporativo */
    font-weight: 700 !important;
    font-size: 0.70rem !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #cbd5e1 !important; /* Línea inferior un poco más gruesa */
    padding: 10px 8px !important;
    border-right: none !important; /* Quita las rayas verticales tipo Excel */
}

/* 2. Estilo de las celdas (Datos) */
.tabla-moderna td {
    font-size: 0.70rem !important;
    color: #334155 !important; /* Un gris oscuro elegante, no negro puro */
    font-weight: 500;
    padding: 8px 8px !important; /* Un poco más de aire para que no se vea apretado */
    border-bottom: 1px solid #e2e8f0 !important; /* Línea divisoria muy suave */
    border-right: none !important; /* Quita las rayas verticales tipo Excel */
}

/* 3. Efecto al pasar el mouse sobre la fila (Hover) */
.tabla-moderna tbody tr {
    transition: background-color 0.2s ease;
}

.tabla-moderna tbody tr:hover {
    background-color: #f0f7ff !important; /* Un fondo azul muuuy clarito al pasar el mouse */
    cursor: default;
}

/* Eliminar el borde inferior de la última fila para que encaje perfecto con el border-radius */
.tabla-moderna tbody tr:last-child td {
    border-bottom: none !important;
}

.kpi-card {
    background-color: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 1px 3px rgba(0,0,0,0.02);
    height: 65px; /* Altura compacta para ahorrar espacio */
    transition: box-shadow 0.2s;
}
.kpi-card:hover {
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
}
.kpi-text {
    display: flex;
    flex-direction: column;
}
.kpi-title {
    font-size: 0.58rem;
    color: #64748b;
    font-weight: 700;
    letter-spacing: 0.5px;
    margin-bottom: 2px;
}
.kpi-value {
    font-size: 1.3rem;
    font-weight: 800;
    line-height: 1;
}
.kpi-icon-box {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Colores Dinámicos Elegantes */
.val-dark { color: #0f172a; }
.box-dark { background-color: #f1f5f9; }
.icon-dark { color: #475569 !important; }

.val-orange { color: #d97706; }
.box-orange { background-color: #fef3c7; }
.icon-orange { color: #d97706 !important; }

.val-green { color: #059669; }
.box-green { background-color: #d1fae5; }
.icon-green { color: #059669 !important; }

.val-blue { color: #0284c7; }
.box-blue { background-color: #e0f2fe; }
.icon-blue { color: #0284c7 !important; }
</style>
<template  style="background: #e4e6e9;" >
    <v-container fluid style="height: 100%;">
        <v-layout style="flex-direction: column;">
            <div style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; margin-top: 10px;">
                <v-menu
                    v-model="menuPeriodo"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <span 
                            v-bind="attrs" 
                            v-on="on"
                            style="font-size: 0.85rem; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: 0.5px; cursor: pointer;"
                        >
                            <v-icon small color="#115bb7" class="mr-1" style="margin-bottom: 2px;">date_range</v-icon>
                            Periodo: 
                            <span style="color: #115bb7; text-decoration: underline dotted;">{{ textoPeriodo }}</span>
                            <v-icon small color="#115bb7">arrow_drop_down</v-icon>
                        </span>
                    </template>
                    
                    <v-card>
                        <!-- Propiedad RANGE activa la selección de Inicio y Fin -->
                        <v-date-picker
                            v-model="fechasFiltro"
                            range
                            color="#115bb7"
                        ></v-date-picker>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menuPeriodo = false">Aceptar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </div>
            <v-row class="mb-2 mx-0" style="margin-top: 5px;">
                <!-- 1. Solicitudes Totales -->
                <v-col cols="12" sm="6" md="3" class="px-2 py-1">
                    <div class="kpi-card">
                        <div class="kpi-text">
                            <span class="kpi-title">SOLICITUDES TOTALES</span>
                            <span class="kpi-value val-dark">{{ totalSolicitudes }}</span>
                        </div>
                        <div class="kpi-icon-box box-dark">
                            <v-icon size="20" class="icon-dark">layers</v-icon>
                        </div>
                    </div>
                </v-col>

                <!-- 2. Pendientes de Cotizar -->
                <v-col cols="12" sm="6" md="3" class="px-2 py-1">
                    <div class="kpi-card">
                        <div class="kpi-text">
                            <span class="kpi-title">PENDIENTES DE COTIZAR</span>
                            <span class="kpi-value val-orange">{{ pendientesCotizar }}</span>
                        </div>
                        <div class="kpi-icon-box box-orange">
                            <v-icon size="20" class="icon-orange">schedule</v-icon>
                        </div>
                    </div>
                </v-col>

                            <!-- 3. Cotizaciones Enviadas (Ahora en AZUL) -->
                <v-col cols="12" sm="6" md="3" class="px-2 py-1">
                    <div class="kpi-card">
                        <div class="kpi-text">
                            <span class="kpi-title">COTIZACIONES ENVIADAS</span>
                            <span class="kpi-value val-blue">{{ cotizacionesEnviadas }}</span>
                        </div>
                        <div class="kpi-icon-box box-blue">
                            <v-icon size="20" class="icon-blue">description</v-icon>
                        </div>
                    </div>
                </v-col>

                <!-- 4. Total BS Generadas / Cerradas (Ahora en VERDE) -->
                <v-col cols="12" sm="6" md="3" class="px-2 py-1">
                    <div class="kpi-card">
                        <div class="kpi-text">
                            <span class="kpi-title">TOTAL BSS GENERADAS</span>
                            <span class="kpi-value val-green">{{ totalBsGeneradas }}</span>
                        </div>
                        <div class="kpi-icon-box box-green">
                            <v-icon size="20" class="icon-green">check_circle</v-icon>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <v-row style="margin-bottom: 16px;">
                <v-col>
                    <v-flex>
                        <v-data-table
                        :headers="HeaderBuySellLista"
                        :items="BuySellLista"        
                        :search="search"
                        class="elevation-2 tabla-moderna"
                        style="border-radius: 10px; overflow: hidden; border: 1px solid #e2e8f0;"
                        :loading="loadigtable"
                        loading-text="Loading... Please wait"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'skip_previous',
                            lastIcon: 'skip_next',
                            prevIcon: 'keyboard_arrow_left',
                            nextIcon: 'keyboard_arrow_right'
                        }"
                        >
                        <template v-slot:[`item.status`]="{ item }">
                            <table style="width: 100%;min-width: 110px;" v-if="item.activo == true">
                                <tr>
                                    <td style="border: 0;">
                                        <v-icon v-if="item.recollecion == true" style="font-size: 20px;" :color="getColor(item.recollecionstatus)">local_shipping</v-icon>
                                        <v-icon v-if="item.recollecion == true" style="font-size: 12px;font-weight: 600;" :color="getColor(item.recollecionstatus)">arrow_forward</v-icon>
                                        <v-icon v-if="item.principal == true && item.basis =='AEREO'" style="font-size: 20px;" :color="getColor(item.principalstatus)">flight_takeoff</v-icon>
                                        <v-icon v-if="item.principal == true && item.basis =='FCL' || item.basis =='LCL'" style="font-size: 20px;" :color="getColor(item.principalstatus)">directions_boat</v-icon>
                                        <v-icon v-if="item.principal == true && item.basis =='FTL' || item.basis =='LTL'" style="font-size: 20px;" :color="getColor(item.principalstatus)">local_shipping</v-icon>
                                        <v-icon v-if="item.entrega == true" style="font-size: 12px;font-weight: 600;" :color="getColor(item.entregastatus)">arrow_forward</v-icon>
                                        <v-icon v-if="item.entrega == true" style="font-size: 20px;" :color="getColor(item.entregastatus)">local_shipping</v-icon>
                                        <v-icon v-if="item.viewextra == true" style="font-size: 12px;font-weight: 600;margin-top: -15px;" :color="getColor(item.statusadicional)">add</v-icon>
                                    </td>
                                </tr>
                            </table>
                            <span v-else> <v-icon color="rgb(218,20,6)">cancel</v-icon></span>
                        </template>
                        <template v-slot:[`item.ncustumer`]="{ item }">
                                <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.ncustumer}}</span>
                                <span v-else  style="font-size: 0.675rem;">{{item.ncustumer}}</span>
                        </template>
                        <template v-slot:[`item.tipoOp`]="{ item }">
                                <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.tipoOp}}</span>
                                <span v-else  style="font-size: 0.675rem;">{{item.tipoOp}}</span>
                        </template>
                        <template v-slot:[`item.basis`]="{ item }">
                                <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.basis}}</span>
                                <span v-else  style="font-size: 0.675rem;">{{item.basis}}</span>
                        </template>
                        <template v-slot:[`item.npuertoreceipt`]="{ item }">
                                <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.npuertoreceipt}}</span>
                                <span v-else  style="font-size: 0.675rem;">{{item.npuertoreceipt}}</span>
                        </template>
                        <template v-slot:[`item.npuertoloading`]="{ item }">
                                <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.npuertoloading}}</span>
                                <span v-else  style="font-size: 0.675rem;">{{item.npuertoloading}}</span>
                        </template>
                        <template v-slot:[`item.npuertodischarge`]="{ item }">
                                <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.npuertodischarge}}</span>
                                <span v-else  style="font-size: 0.675rem;">{{item.npuertodischarge}}</span>
                        </template>
                        <template v-slot:[`item.npuertodelivery`]="{ item }">
                                <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.npuertodelivery}}</span>
                                <span v-else  style="font-size: 0.675rem;">{{item.npuertodelivery}}</span>
                        </template>
                        <template v-slot:[`item.nfechacreate`]="{ item }">
                                <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">{{item.nfechacreate}}</span>
                                <span v-else  style="font-size: 0.675rem;">{{item.nfechacreate}}</span>
                        </template>
                        <template v-slot:[`item.npuertoreceipt`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">
                                <span v-if="item.npuertoreceipt === 'SELECT..'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.npuertoreceipt}}</span>
                                </span>
                            </span>
                            <span v-else  style="font-size: 0.675rem;">
                                <span v-if="item.npuertoreceipt === 'SELECT..'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.npuertoreceipt}}</span>
                                </span>
                            </span>
                        </template>
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Solicitud de tarifa</v-toolbar-title>
                                <v-divider
                                    class="mx-4"
                                    inset
                                    vertical
                                ></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>                                
                                <v-spacer></v-spacer> 
                                <v-select style="margin-top: 15px;" v-if="$store.state.usuario.rol == 'ComercialAdmin' || $store.state.usuario.rol == 'Administrador' || $store.state.usuario.rol == 'Marketing'|| $store.state.usuario.rol == 'Finanzas'" label="Ejecutivo" v-model="idejecutivo" dense outlined :items="ejecutivos" v-on:change="buscarejecutivo()"></v-select>
                                <v-btn style="margin-left: 8px;" color="primary" @click="limpiar(),nuevast=true,idejecutivo = 0,listar()">Nueva Solicitud</v-btn>
                               <!-- <v-btn icon @click="listar"><v-icon>refresh</v-icon></v-btn>-->
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">                    
                                        <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                            class="mr-2"
                                            @click="limpiar(),listar()"
                                            style="color: #1583da;font-weight: 600;"
                                            >
                                            refresh
                                        </v-icon>
                                    </template>
                                    <span>Refresh</span>
                                </v-tooltip>
                            </v-toolbar>
                        </template>
                        <template v-slot:[`item.opciones`]="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">                    
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        @click="editItemBS(item)"
                                        style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"
                                        color="#3d5170"
                                        >
                                        edit
                                    </v-icon>
                                </template>                                
                                <span>edit</span>
                            </v-tooltip>   
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">                    
                                    <v-icon
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        @click="cargarInformacion(item)"
                                        style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"
                                        color="#3d5170"
                                        >
                                        visibility
                                    </v-icon>
                                </template>
                                <span>visibility</span>
                            </v-tooltip>                      
                        </template>
                        <template v-slot:[`item.npuertoloading`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">
                                <span v-if="item.npuertoloading === 'SELECT..'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.npuertoloading}}</span>
                                </span>
                            </span>
                            <span v-else  style="font-size: 0.675rem;">
                                <span v-if="item.npuertoloading === 'SELECT..'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.npuertoloading}}</span>
                                </span>
                            </span>
                        </template>
                        <template v-slot:[`item.npuertodischarge`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">
                                <span v-if="item.npuertodischarge === 'SELECT..'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.npuertodischarge}}</span>
                                </span>
                            </span>
                            <span v-else  style="font-size: 0.675rem;">
                                <span v-if="item.npuertodischarge === 'SELECT..'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.npuertodischarge}}</span>
                                </span>
                            </span>
                        </template>
                        <template v-slot:[`item.npuertodelivery`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">
                                <span v-if="item.npuertodelivery === 'SELECT..'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.npuertodelivery}}</span>
                                </span>
                            </span>
                            <span v-else  style="font-size: 0.675rem;">
                                <span v-if="item.npuertodelivery === 'SELECT..'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.npuertodelivery}}</span>
                                </span>
                            </span>
                        </template>
                        <template v-slot:[`item.nfecharespuesta`]="{ item }">
                            <span v-if="item.activo == false" style="color:rgb(218,20,6);font-weight: 600;font-size: 0.675rem;">
                                <span v-if="item.nfecharespuesta === '01/01/1753 12:00 a. m.'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.nfecharespuesta}}</span>
                                </span>
                            </span>
                            <span v-else  style="font-size: 0.675rem;">
                                <span v-if="item.nfecharespuesta === '01/01/1753 12:00 a. m.'">
                                    <span>-</span>
                                </span>
                                <span v-else>
                                    <span>{{item.nfecharespuesta}}</span>
                                </span>
                            </span>
                        </template>
                        <template v-slot:[`item.Ncotizaciones`]="{ item }">
                            <span  >
                                <span v-if="item.Ncotizaciones == ''">
                                    <span style="color:#ff3100;">PENDIENTE</span>
                                </span>
                                <span v-else>
                                    <span>{{item.Ncotizaciones}}</span>
                                </span>
                            </span>
                        </template>                          
                        <template slot="no-data">
                            <v-btn colo="primary" @click="listar">Resetear</v-btn>
                        </template> 
                        <template v-slot:[`item.estadoCotizacion`]="{ item }">
                            <div v-if="item.cotizaciones && item.cotizaciones.length > 0">
                                <v-chip
                                    v-for="(cot, index) in item.cotizaciones"
                                    :key="index"        
                                    :color="cot.asignada ? '#059669' : '#115bb7'" 
                                    text-color="white"
                                    small
                                    class="ma-1"
                                    style="font-weight: bold; font-size: 0.65rem; height: 22px; cursor: pointer;"
                                >
                                    <v-icon left size="14" class="mr-1">description</v-icon>
                                    <!-- Aquí le indicamos a Vue que SOLO imprima la propiedad folio -->
                                    COT-{{ cot.folio }}
                                </v-chip>
                            </div>                            
                            <div v-else>
                                <v-chip 
                                    color="#E65100" 
                                    outlined 
                                    small 
                                    style="font-weight: bold; font-size: 0.65rem; height: 22px; background-color: #FFF3E0;"
                                >
                                    <v-icon left size="14" class="mr-1">schedule</v-icon>
                                    PENDIENTE
                                </v-chip>
                            </div>
                        </template>
                        </v-data-table>
                    </v-flex>
                </v-col>
            </v-row>
            <v-row>
                <v-dialog
                    v-model="dialog3"
                    max-width="950px"
                    style="max-height: 97%;"
                >
                    <v-card> 
                        <v-stepper v-model="e1" >
                            <v-stepper-header style="width: 100%;">
                                <v-stepper-step
                                editable
                                step="1"
                                >
                                    Select Rate
                                </v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step
                                editable
                                step="2"
                                >
                                Quotation
                                </v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step
                                editable
                                step="3"
                                >
                                View
                                </v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step
                                editable
                                step="4"
                                >
                                Send Quotation
                                </v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items>
                                <v-stepper-content step="1" style="padding:14px 14px 6px 14px;">
                                    <v-card style="margin-bottom: 12px;"
                                    >
                                        <v-card-title style="padding:0;">
                                            <span style="color: #057fde;">Information {{editBS.ncotizacion }}</span>
                                            <v-spacer></v-spacer>
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text>
                                            <table style="text-align: center;width: 100%;" >
                                                <tr>
                                                    <td style="border-bottom: 1px solid"><span style=";text-align: center;font-weight: 500;color: black;">Customer Name</span></td>
                                                    <td style="border-bottom: 1px solid"><span style="text-align: center;font-weight: 500;color: black;">Operation Type</span></td>
                                                    <td style="border-bottom: 1px solid"><span style="text-align: center;font-weight: 500;color: black;">Basis</span></td>
                                                    <td style="border-bottom: 1px solid"><span style="text-align: center;font-weight: 500;color: black;">Place of Receipt</span></td>
                                                    <td style="border-bottom: 1px solid"><span style="text-align: center;font-weight: 500;color: black;">POL</span></td>
                                                    <td style="border-bottom: 1px solid"><span style="text-align: center;font-weight: 500;color: black;">POD</span></td>
                                                    <td style="border-bottom: 1px solid"><span style="text-align: center;font-weight: 500;color: black;">Final Destination</span></td>
                                                </tr>
                                                <tr>
                                                    <td style="border-bottom: 1px solid;border-right:1px solid;border-left:1px solid;padding:3px;"><span style="text-align: center;color: #0a497b;font-weight: 500;">{{editBS.ncustumer}}</span></td>
                                                    <td style="border-bottom: 1px solid;border-right:1px solid;padding:3px;"><span style="text-align: center;color: #0a497b;font-weight: 500;">{{editBS.tipoOp}}</span></td>
                                                    <td style="border-bottom: 1px solid;border-right:1px solid;padding:3px;"><span style="text-align: center;color: #0a497b;font-weight: 500;">{{editBS.basis}}</span></td>
                                                    <td style="border-bottom: 1px solid;border-right:1px solid;padding:3px;"><span v-if="editBS.npuertoreceipt === 'SELECT..'">-</span><span style="text-align: center;color: #0a497b;font-weight: 500;" v-else>{{editBS.npuertoreceipt}}</span></td>
                                                    <td style="border-bottom: 1px solid;border-right:1px solid;padding:3px;"><span v-if="editBS.npuertoloading === 'SELECT..'">-</span><span style="text-align: center;color: #0a497b;font-weight: 500;" v-else>{{editBS.npuertoloading}}</span></td>
                                                    <td style="border-bottom: 1px solid;border-right:1px solid;padding:3px;"><span v-if="editBS.npuertodischarge === 'SELECT..'">-</span><span style="text-align: center;color: #0a497b;font-weight: 500;" v-else>{{editBS.npuertodischarge}}</span></td>
                                                    <td style="border-bottom: 1px solid;border-right:1px solid;padding:3px;"><span v-if="editBS.npuertodelivery === 'SELECT..'">-</span><span style="text-align: center;color: #0a497b;font-weight: 500;" v-else>{{editBS.npuertodelivery}}</span></td>
                                                </tr>
                                            </table>
                                            <v-simple-table v-if="editBS.basis == 'LCL' || editBS.basis == 'LTL' || editBS.basis == 'AEREO'">
                                                <thead>
                                                    <tr style="text-align: center;">
                                                        <th>Quantity</th>
                                                        <th>Package</th>
                                                        <th>Large</th>
                                                        <th>Width</th>
                                                        <th>Hight</th>
                                                        <th>Weight</th>
                                                        <th>Volumetric Weight</th>
                                                        <th>Actual Weight</th>
                                                        <th>Stackable</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="det in addpackages" :key="det.num">
                                                        <td  style="text-align:center;font-size: 12px;"> 
                                                            {{det.quantity}}
                                                        </td>
                                                        <td  style="text-align:center;font-size: 12px;">{{det.package}}</td>
                                                        <td  style="text-align:center;font-size: 12px;">{{det.large}}</td>
                                                        <td  style="text-align:center;font-size: 12px;">{{det.width}}</td>
                                                        <td  style="text-align:center;font-size: 12px;">{{det.high}}</td>
                                                        <td  style="text-align:center;font-size: 12px;">{{addCommas(det.weight)}} Kg.</td>
                                                        <td v-if="editBS.basis == 'AEREO'"  style="text-align:center;font-size: 12px;">{{parseFloat(((((det.large * 100) * (det.width * 100)) * (det.high * 100)) / 6000) * det.quantity).toFixed(2)}} KG</td>
                                                        <td v-else  style="text-align:center;font-size: 12px;">{{parseFloat(((det.large * det.width) * det.high)*det.quantity).toFixed(2)}} Ton.</td>
                                                        <td  style="text-align:center;font-size: 12px;">{{addCommas(parseFloat(det.weight * det.quantity).toFixed(2))}} Kg.</td>
                                                        <td  style="text-align:center;">
                                                        <span v-if="det.stackable == true"><span style="font-size: 18px;color: #009688;font-weight: 700;" class="material-icons">done</span></span>
                                                        <span v-else><span style="font-size: 18px;color: red;font-weight: 700;"  class="material-icons">clear</span></span> 
                                                        </td>
                                                    </tr>
                                                    <br>
                                                </tbody>
                                            </v-simple-table>
                                            <v-simple-table v-if="editBS.basis == 'FCL' || editBS.basis =='FTL'">
                                                <thead>
                                                    <tr>
                                                        <th style="text-align:center;font-size: 12px;">Quantity</th>
                                                        <th style="text-align:center;font-size: 12px;">Size</th>
                                                        <th style="text-align:center;font-size: 12px;">Type</th>
                                                        <th style="text-align:center;font-size: 12px;">Weight</th>
                                                        <th style="text-align:center;font-size: 12px;">Total Weight</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="det in containers" :key="det.num">
                                                        <td style="text-align: center;color: black;font-weight: 500;">{{det.quantity}}</td>
                                                        <td style="text-align: center;color: black;font-weight: 500;">{{det.size}}</td>
                                                        <td style="text-align: center;color: black;font-weight: 500;">{{det.type}}</td>
                                                        <td style="text-align: center;color: black;font-weight: 500;">{{addCommas(det.nweight)}}</td>
                                                        <td style="text-align: center;color: black;font-weight: 500;">{{addCommas(det.quantity * det.weight) }} Kg.</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                            <div v-if="principal===true">
                                                <v-list flat>
                                                    <v-subheader style="color: black;font-weight: 600;">Authorized Rates</v-subheader>
                                                    <v-divider></v-divider><br>
                                                    <v-list-item-group
                                                        v-model="selectedItem"
                                                        color="primary"
                                                        multiple
                                                    >
                                                        <v-list-item
                                                        v-for="(item, i) in tarifas"
                                                        :key="i"
                                                        style="margin-bottom: 8px;padding:0;"
                                                        >
                                                        <template v-slot:default="{ active }">
                                                            <table style="width: 100%;text-align:center;border:1px solid;">
                                                                <tr>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Provider</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Size</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Type</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Rate</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Free days origin</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Free days destination</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Validity</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Remarks</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;" v-if="item.freedaysorigin === 25">
                                                                        <span style="text-align: center;padding: 4px;">Sent by</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;" v-else>
                                                                        <span style="text-align: center;padding: 4px;">Sent by</span>
                                                                    </th>
                                                                </tr>
                                                                <tr >
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.nidprovider}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.size}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.type}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.nrate}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.freedaysorigin}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.freedasydestination}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.fechavigencia}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.observaciones}}</span>
                                                                    </td>
                                                                    <td  v-if="item.rol === 'PricingAgente'">
                                                                        <span style="padding: 4px;text-align: center;">Agentes</span>
                                                                    </td>
                                                                    <td  v-if="item.rol === 'PricingTerrestre'">
                                                                        <span style="padding: 4px;text-align: center;">Terrestre</span>
                                                                    </td>
                                                                    <td  v-if="item.rol === 'Pricing'">
                                                                        <span style="padding: 4px;text-align: center;">Pricing</span>
                                                                    </td>
                                                                </tr>
                                                            </table><br>
                                                            <v-list-item-action>
                                                                <v-checkbox
                                                                :input-value="active"
                                                                color="primary accent-4"
                                                                ></v-checkbox>
                                                            </v-list-item-action>
                                                        </template>
                                                        </v-list-item>
                                                    </v-list-item-group>
                                                </v-list>
                                                <v-btn color="primary" @click="Mostrartarifaprincipal()">Continue</v-btn>
                                            </div>
                                            <div v-if="recoleccion === true">
                                                <v-list flat>
                                                    <v-subheader style="color: black;font-weight: 600;">Authorized Pick up rates</v-subheader>
                                                    <v-divider></v-divider><br>
                                                    <v-list-item-group
                                                        v-model="selectedItempickup"
                                                        color="primary"
                                                        multiple
                                                    >
                                                        <v-list-item
                                                        v-for="(item, i) in tarifapickup"
                                                        :key="i"
                                                        style="margin-bottom: 8px;padding:0;"
                                                        >
                                                        <template v-slot:default="{ active }">
                                                            <table style="width: 100%;text-align:center;border:1px solid;">
                                                                <tr>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Provider</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Size</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Type</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Rate</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Free days origin</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Free days destination</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Validity</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;">
                                                                        <span style="text-align: center;padding: 4px;">Remarks</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;" v-if="item.freedaysorigin === 25">
                                                                        <span style="text-align: center;padding: 4px;">Sent by</span>
                                                                    </th>
                                                                    <th style="border-bottom: 1px solid;" v-else>
                                                                        <span style="text-align: center;padding: 4px;">Sent by</span>
                                                                    </th>
                                                                </tr>
                                                                <tr >
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.nidprovider}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.size}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.type}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.nrate}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.freedaysorigin}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.freedasydestination}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.fechavigencia}}</span>
                                                                    </td>
                                                                    <td >
                                                                        <span style="padding: 4px;text-align: center;">{{item.observaciones}}</span>
                                                                    </td>
                                                                    <!--<td style="display: flex;flex-direction: column;">
                                                                        <span style="text-align: center;padding: 4px;">Route</span>
                                                                        <span style="padding: 4px;text-align: center;">Directo</span>
                                                                    </td>-->
                                                                    <td  v-if="item.rol === 'PricingAgente'">
                                                                        <span style="padding: 4px;text-align: center;">Agentes</span>
                                                                    </td>
                                                                    <td  v-if="item.rol === 'PricingTerrestre'">
                                                                        <span style="padding: 4px;text-align: center;">Terrestre</span>
                                                                    </td>
                                                                    <td  v-if="item.rol === 'Pricing'">
                                                                        <span style="padding: 4px;text-align: center;">Pricing</span>
                                                                    </td>
                                                                </tr>
                                                            </table><br>
                                                            <v-list-item-action>
                                                                <v-checkbox
                                                                :input-value="active"
                                                                color="primary accent-4"
                                                                ></v-checkbox>
                                                            </v-list-item-action>
                                                        </template>
                                                        </v-list-item>
                                                    </v-list-item-group>
                                                </v-list>
                                                <v-btn color="primary" @click="Mostrartarifarecoleccion()">continue</v-btn>
                                                <v-btn style="margin-left:8px;" color="error" @click="Mostrartarifarecoleccion()">cancel</v-btn>
                                            </div>
                                            <div v-if="delivery === true">
                                                <v-list flat>
                                                    <v-subheader style="color: black;font-weight: 600;">Authorized Delivery Rates</v-subheader>
                                                    <v-divider></v-divider><br>
                                                    <v-list-item-group
                                                        v-model="selectedItemdelivery"
                                                        color="primary"
                                                        multiple
                                                    >
                                                        <v-list-item
                                                        v-for="(item, i) in tarifadeliver"
                                                        :key="i"
                                                        style="margin-bottom: 8px;padding:0;"
                                                        >
                                                        <template v-slot:default="{ active }">
                                                                <table style="width: 100%;text-align:center;border:1px solid;">
                                                                    <tr>
                                                                        <th style="border-bottom: 1px solid;">
                                                                            <span style="text-align: center;padding: 4px;">Provider</span>
                                                                        </th>
                                                                        <th style="border-bottom: 1px solid;">
                                                                            <span style="text-align: center;padding: 4px;">Size</span>
                                                                        </th>
                                                                        <th style="border-bottom: 1px solid;">
                                                                            <span style="text-align: center;padding: 4px;">Type</span>
                                                                        </th>
                                                                        <th style="border-bottom: 1px solid;">
                                                                            <span style="text-align: center;padding: 4px;">Rate</span>
                                                                        </th>
                                                                        <th style="border-bottom: 1px solid;">
                                                                            <span style="text-align: center;padding: 4px;">Free days origin</span>
                                                                        </th>
                                                                        <th style="border-bottom: 1px solid;">
                                                                            <span style="text-align: center;padding: 4px;">Free days destination</span>
                                                                        </th>
                                                                        <th style="border-bottom: 1px solid;">
                                                                            <span style="text-align: center;padding: 4px;">Validity</span>
                                                                        </th>
                                                                        <th style="border-bottom: 1px solid;">
                                                                            <span style="text-align: center;padding: 4px;">Remarks</span>
                                                                        </th>
                                                                        <th style="border-bottom: 1px solid;" v-if="item.freedaysorigin === 25">
                                                                            <span style="text-align: center;padding: 4px;">Sent by</span>
                                                                        </th>
                                                                        <th style="border-bottom: 1px solid;" v-else>
                                                                            <span style="text-align: center;padding: 4px;">Sent by</span>
                                                                        </th>
                                                                    </tr>
                                                                    <tr >
                                                                        <td >
                                                                            <span style="padding: 4px;text-align: center;">{{item.nidprovider}}</span>
                                                                        </td>
                                                                        <td >
                                                                            <span style="padding: 4px;text-align: center;">{{item.size}}</span>
                                                                        </td>
                                                                        <td >
                                                                            <span style="padding: 4px;text-align: center;">{{item.type}}</span>
                                                                        </td>
                                                                        <td >
                                                                            <span style="padding: 4px;text-align: center;">{{item.nrate}}</span>
                                                                        </td>
                                                                        <td >
                                                                            <span style="padding: 4px;text-align: center;">{{item.freedaysorigin}}</span>
                                                                        </td>
                                                                        <td >
                                                                            <span style="padding: 4px;text-align: center;">{{item.freedasydestination}}</span>
                                                                        </td>
                                                                        <td >
                                                                            <span style="padding: 4px;text-align: center;">{{item.fechavigencia}}</span>
                                                                        </td>
                                                                        <td >
                                                                            <span style="padding: 4px;text-align: center;">{{item.observaciones}}</span>
                                                                        </td>
                                                                        <td  v-if="item.rol === 'PricingAgente'">
                                                                            <span style="padding: 4px;text-align: center;">Agentes</span>
                                                                        </td>
                                                                        <td  v-if="item.rol === 'PricingTerrestre'">
                                                                            <span style="padding: 4px;text-align: center;">Terrestre</span>
                                                                        </td>
                                                                        <td  v-if="item.rol === 'Pricing'">
                                                                            <span style="padding: 4px;text-align: center;">Pricing</span>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                                <v-list-item-action>
                                                                <v-checkbox
                                                                :input-value="active"
                                                                color="primary accent-4"
                                                                ></v-checkbox>
                                                            </v-list-item-action>
                                                        </template>
                                                        </v-list-item>
                                                    </v-list-item-group>
                                                </v-list>
                                                <v-btn color="primary" @click="Mostrartarifadelivery()">continue</v-btn>
                                                <v-btn style="margin-left:8px;" color="error" @click="Mostrartarifadelivery()">cancel</v-btn>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-stepper-content>
                                <v-stepper-content step="2">
                                    <v-card
                                    >
                                        <div style="margin-bottom: 20px;">
                                            <header style="width: 100%">
                                                <table style="width: 100%;">
                                                    <tr>
                                                        <td>
                                                            <img style="width: 280px;" src="../assets/logo1.png" alt="">  
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="text-align: end;font-size: 14px;font-weight: 600;">CDMX, a {{fechaHoy}}</td>
                                                    </tr>
                                                </table>
                                            </header>
                                            <section>
                                                <table style="width: 100%;">
                                                    <tr>
                                                        <td style="font-size: 14px;font-weight: 600;">{{editBS.ncustumer}}</td>
                                                    </tr>
                                                    <tr>
                                                        <td style="font-size: 14px;font-weight: 600;">Atención:</td>
                                                        <td style="display: flex;">
                                                            <v-btn icon @click="viewContacto()">
                                                                <v-icon style="color: #455A64;">person_add</v-icon>
                                                            </v-btn>
                                                            <v-combobox
                                                                v-model="contactoscot"
                                                                :items="contactospresente"
                                                                :search-input.sync="searcho"
                                                                hide-selected                                          
                                                                label="Contactos"
                                                                multiple
                                                                persistent-hint
                                                                small-chips
                                                                style="margin-left: 8px;"
                                                                outlined
                                                                dense
                                                            >
                                                                <template v-slot:no-data>
                                                                    <v-list-item>
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                        No se encuentran mas contactos"<strong>{{ searcho }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-combobox>
                                                        </td>
                                                    </tr>
                                                    <!--<tr>
                                                        <td colspan="2">
                                                            <v-textarea
                                                            v-model="cuerpo"
                                                            counter
                                                            maxlength="1500"
                                                            solo
                                                            name="input-7-4"
                                                            ></v-textarea>
                                                        </td>
                                                    </tr>-->
                                                    <tr>
                                                        <td colspan="2">
                                                            <div id="app" style="border: 1px solid;width: 99%;">
                                                                <ckeditor style="color:black;" :editor="editor" @ready="onReady" v-model="bodyCot"></ckeditor>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Modalidad: </span>
                                                            <v-text-field
                                                            style="margin-left: 8px;"
                                                            v-model="modalidadtext2"
                                                            solo
                                                            dense
                                                            ></v-text-field></td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Movimiento:</span>
                                                            <v-text-field
                                                            style="margin-left: 8px;"
                                                            v-model="Movimientotext"
                                                            solo
                                                            dense
                                                            ></v-text-field></td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Producto:</span>
                                                            <v-text-field
                                                            style="margin-left: 8px;"
                                                            v-model="productotext"
                                                            solo
                                                            dense
                                                            ></v-text-field>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Origen:</span>
                                                            <v-text-field
                                                            style="margin-left: 8px;"
                                                            v-model="origentext"
                                                            solo
                                                            dense
                                                            ></v-text-field>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Destino:</span>
                                                            <v-text-field
                                                            style="margin-left: 8px;"
                                                            v-model="destinotext"
                                                            solo
                                                            dense
                                                            ></v-text-field>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Servicio:</span>
                                                            <v-text-field
                                                            style="margin-left: 8px;"
                                                            v-model="serviciotext"
                                                            solo
                                                            dense
                                                            ></v-text-field>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Via:</span>
                                                            <v-text-field
                                                            style="margin-left: 8px;"
                                                            v-model="viatext"
                                                            solo
                                                            dense
                                                            ></v-text-field>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Transbordo:</span>
                                                            <v-text-field
                                                            style="margin-left: 8px;"
                                                            v-model="transbordo"
                                                            solo
                                                            dense
                                                            ></v-text-field>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">T.T.:</span>
                                                            <v-text-field
                                                            style="margin-left: 8px;"
                                                            v-model="tttext"
                                                            solo
                                                            dense
                                                            ></v-text-field>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2">
                                                            <v-card style="padding: 15px;width: 95%;" v-if="recolecciont===true">
                                                                <v-card-title style="color: #063aaf;font-weight: 500;">Pick up Rate</v-card-title>
                                                                <v-divider></v-divider>
                                                                <tr style="display: flex;margin-top: 8px;">
                                                                    <v-simple-table style="width: 100%;text-align: center;width: 100%;color: black;font-weight: 500;">
                                                                        <thead>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Provider</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Quantity</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">size</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Type</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Rate</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Free days origin</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Free days destination</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Additional Charges</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Observations</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Vigencia</td>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="det in pickupselect" :key="det.num">
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.nidprovider}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.quantity}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.size}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.type}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.nrate}}</td> 
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.freedaysorigin}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.freedasydestination}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.tarifaAd}}</td> 
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.observaciones}}</td> 
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.fechavigencia}}</td> 
                                                                            </tr>
                                                                        </tbody>
                                                                    </v-simple-table>
                                                                </tr>
                                                            </v-card><br>
                                                            <v-card style="padding: 15px;width: 95%;" v-if="principalt===true">
                                                                <v-card-title style="color: #063aaf;font-weight: 500;">Principal Rate</v-card-title>
                                                                <tr style="display: flex;">
                                                                    <v-simple-table style="width: 100%;text-align: center;width: 100%;color: black;font-weight: 500;">
                                                                        <thead>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Provider</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Quantity</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">size</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Type</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Rate</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Free days origin</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Free days destination</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Additional Charges</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Observations</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Vigencia</td>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="det in principalselect" :key="det.num">
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.nidprovider}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.quantity}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.size}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.type}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.nrate}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.freedaysorigin}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.freedasydestination}}</td> 
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.tarifaAd}}</td> 
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.observaciones}}</td> 
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.fechavigencia}}</td> 
                                                                            </tr>
                                                                        </tbody>
                                                                    </v-simple-table>
                                                                </tr>
                                                            </v-card><br>
                                                            <v-card style="padding: 15px;width: 95%;" v-if="deliveryt===true">
                                                                <v-card-title style="color: #063aaf;font-weight: 500;">Delivery Rate</v-card-title>
                                                                <tr style="display: flex;margin-top: 8px;">
                                                                    <v-simple-table style="width: 100%;text-align: center;width: 100%;color: black;font-weight: 500;">
                                                                        <thead>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Provider</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Quantity</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">size</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Type</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Rate</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Free days origin</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Free days destination</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Additional Charges</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Observations</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;">Vigencia</td>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr v-for="det in deliveryselect" :key="det.num">
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.nidprovider}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.quantity}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.size}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.type}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.nrate}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.freedaysorigin}}</td>
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.freedasydestination}}</td> 
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.tarifaAd}}</td> 
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.observaciones}}</td> 
                                                                                <td style="border-bottom: 1px solid #bdbdbd;">{{det.fechavigencia}}</td> 
                                                                            </tr>
                                                                        </tbody>
                                                                    </v-simple-table>
                                                                </tr>
                                                            </v-card><br>
                                                            <v-card style="padding: 15px;width: 95%;" v-if="viewadicional === true || viewcustom === true">
                                                                <v-card-title style="color: #063aaf;font-weight: 500;">Aditional Charge</v-card-title>
                                                                <tr style="display: flex;margin-top: 8px;" v-if="viewadicional === true">
                                                                    <table style="width: 100%;color: black;font-weight: 500;">
                                                                        <tr style="text-align: center;">
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">Aditional Charge</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">Provider</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">Currency</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">Rate</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;width: 30px;">+ Iva</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">Remarks</td>
                                                                        </tr>
                                                                        <tr v-for="det in adicionalfees" :key="det.num" >
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">{{det.charge}}</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">{{det.provider}}</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">{{det.moneda}}</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">{{addCommas(det.rate)}}</td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;" v-if="det.iva === true"><span style="font-size: 18px;color: #009688;font-weight: 700;" class="material-icons">done</span></td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;" v-if="det.iva === false"><span style="font-size: 18px;color: red;font-weight: 700;"  class="material-icons">clear</span></td>
                                                                            <td style="border-bottom: 1px solid #bdbdbd;text-align: center;font-size: 12px;">{{det.remarks}}</td>
                                                                        </tr>
                                                                    </table>
                                                                </tr>
                                                                <tr style="display: flex;margin-top: 8px;" v-if="viewcustom === true">
                                                                    <table style="border: 2px solid #1583da69;padding: 8px;border-radius: 3px;border-collapse: collapse;">
                                                                        <tr>
                                                                            <td colspan="8">
                                                                                <v-card-title style="color: #063aaf;font-weight: 500;padding: 8px;">Customs </v-card-title>
                                                                            </td>
                                                                        </tr>
                                                                        <tr style="text-align: center;">
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 6px;color: rgb(5,63,140);font-weight: 600;">Aditional Charge</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 6px;color: rgb(5,63,140);font-weight: 600;">Concept</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 6px;color: rgb(5,63,140);font-weight: 600;">Provider</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 6px;color: rgb(5,63,140);font-weight: 600;">Currency</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 6px;color: rgb(5,63,140);font-weight: 600;">Rate</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 6px;color: rgb(5,63,140);font-weight: 600;">Per</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 6px;color: rgb(5,63,140);font-weight: 600;"><span style="font-size: 14px;">+ </span>Iva</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 6px;color: rgb(5,63,140);font-weight: 600;">Remarks</td>
                                                                        </tr>
                                                                        <tr v-for="det in customs" :key="det.num">
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 8px;font-weight: 600;">{{det.charge}}</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 8px;font-weight: 600;">{{det.concept}}</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 8px;font-weight: 600;">{{det.provider}}</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 8px;font-weight: 600;">{{det.moneda}}</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 8px;font-weight: 600;">{{addCommas(det.rate)}}</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 8px;font-weight: 600;">{{det.per}}</td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 8px;font-weight: 600;" v-if="det.iva === true"><span style="font-size: 18px;color: #009688;font-weight: 700;" class="material-icons">done</span></td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 8px;font-weight: 600;" v-if="det.iva === false"><span style="font-size: 18px;color: red;font-weight: 700;"  class="material-icons">clear</span></td>
                                                                            <td style="border: 1px solid #bdbdbd;text-align: center;font-size: 12px;padding: 8px;font-weight: 600;">{{det.remarks}}</td>
                                                                        </tr>
                                                                    </table>
                                                                </tr>
                                                            </v-card><br>
                                                            <tr>
                                                                <td colspan="4">
                                                                    <v-switch    
                                                                    v-model="incseguromercancia"
                                                                    :label="`${incseguromercancia} incluye seguro.`"
                                                                    color="primary"
                                                                    false-value="NO"
                                                                    true-value="SI"
                                                                    style="max-width: 180px;"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4">
                                                                    <v-switch    
                                                                    v-model="contizacioningles"
                                                                    :label="`${contizacioningles} `"
                                                                    color="primary"
                                                                    false-value="ESPAÑOL"
                                                                    true-value="INGLES"
                                                                    style="max-width: 180px;"
                                                                    @click="cargarremarks"
                                                                    />
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4">
                                                                    <table style="border: 1px solid #CFD8DC;padding: 8px;border-radius: 8px;">
                                                                        <tr>
                                                                            <td><v-text-field label="Concepto" v-model="chargeconcepto" outlined dense></v-text-field></td>
                                                                            <td><v-select item-text="text" return-object item-value="value" label="Costo por" v-on:change="activarcantidad" v-model="chargecostopor" dense outlined style="margin-left: 5px;" :items="preciocostopor"></v-select></td>
                                                                            <td><v-text-field type="number" label="Cantidad" :disabled="activarc" v-model="chargecantidad" outlined dense></v-text-field></td>
                                                                            <td><v-text-field type="number" label="Costo Unitario" v-model="chargecostounitario" outlined dense></v-text-field></td>
                                                                        </tr>
                                                                        <tr style="display: flex;">
                                                                            <td><v-select item-text="text" return-object item-value="value" label="moneda" v-model="chargemoneda" dense outlined style="margin-left: 5px;" :items="monedas"></v-select></td>
                                                                            <td style="margin-left:3px;">
                                                                                <v-checkbox style="margin-top: 0px;"
                                                                                v-model="chargeiva"
                                                                                label="Iva"
                                                                                color="info"
                                                                                value:1
                                                                                hide-details
                                                                                dense
                                                                                :disabled = disabledIva
                                                                                ></v-checkbox>
                                                                            </td>
                                                                            <td><v-btn color="primary" style="margin-left: 5px;" @click="agregarcosto">Add</v-btn></td>
                                                                        </tr>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <v-checkbox
                                                                        v-model="MostrarTotal"
                                                                        value:1                                                                        
                                                                        label="Mostrar Total"
                                                                        style="width:150px;"
                                                                        hide-details
                                                                        dense
                                                                    ></v-checkbox>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td colspan="4">
                                                                    <v-simple-table style="margin-bottom: 12px;">
                                                                        <thead>
                                                                            <tr>
                                                                                <th>OPCIONES</th>
                                                                                <th>CONCEPTO</th>
                                                                                <th>COSTO POR:</th>
                                                                                <th>CANTIDAD</th>
                                                                                <th>COSTO UNITARIO</th>
                                                                                <th>MONEDA</th>
                                                                                <th>SUB TOTAL</th>
                                                                                <th>IVA</th>
                                                                                <th>TOTAL</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <template v-for="det in Costos">
                                                                                <tr v-if="det.activo == true">
                                                                                    <td style="text-align: center;">
                                                                                        <v-tooltip top>
                                                                                            <template v-slot:activator="{ on, attrs }">                    
                                                                                                <v-icon
                                                                                                    v-bind="attrs"
                                                                                                    v-on="on"
                                                                                                    small
                                                                                                    class="mr-2"
                                                                                                    @click="editItemcostos(det)"
                                                                                                    style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                                    color="#3d5170"
                                                                                                    >
                                                                                                    edit
                                                                                                </v-icon>
                                                                                            </template>
                                                                                            <span>Edit</span>
                                                                                        </v-tooltip>
                                                                                        <v-tooltip top>
                                                                                            <template v-slot:activator="{ on, attrs }">                    
                                                                                                <v-icon
                                                                                                    v-bind="attrs"
                                                                                                    v-on="on"
                                                                                                    small
                                                                                                    class="mr-2"
                                                                                                    @click="deleteICosto(det)"
                                                                                                    style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                                    color="#3d5170"
                                                                                                    >
                                                                                                    delete
                                                                                                </v-icon>
                                                                                            </template>
                                                                                            <span>Delete</span>
                                                                                        </v-tooltip>
                                                                                    </td>
                                                                                    <td style="text-align: center;">{{det.concepto}}</td>
                                                                                    <td style="text-align: center;">{{det.costopor}}</td>
                                                                                    <td style="text-align: center;">{{det.cantidad}}</td>
                                                                                    <td style="text-align: center;">{{det.ncostounitario}}</td>
                                                                                    <td style="text-align: center;">{{det.moneda}}</td>
                                                                                    <td style="text-align: center;">{{det.nsubtotal}}</td>
                                                                                    <td style="text-align: center;">{{det.nniva}}</td>
                                                                                    <td style="text-align: center;">{{det.ntotal}}</td>
                                                                                </tr>
                                                                            </template>
                                                                            <tr v-if="activousd == true && MostrarTotal == 1">
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td style="text-align: center;">Total USD</td>
                                                                                <td style="text-align: center;">{{nsubtotalusd}}</td>
                                                                                <td style="text-align: center;">{{nivausd}}</td>
                                                                                <td style="text-align: center;">{{ntotalusd}}</td>
                                                                            </tr>
                                                                            <tr v-if="activomxn == true && MostrarTotal == 1">
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td style="text-align: center;">Total MXN</td>
                                                                                <td style="text-align: center;">{{nsubtotalmxn}}</td>
                                                                                <td style="text-align: center;">{{nivamxn}}</td>
                                                                                <td style="text-align: center;">{{ntotalmxn}}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </v-simple-table>
                                                                </td>
                                                            </tr>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style="display: flex;align-items: center;">
                                                            <span>Vigencia:</span>
                                                            <v-menu
                                                                v-model="menu2"
                                                                :close-on-content-click="false"
                                                                max-width="290"
                                                                dense
                                                                >
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field
                                                                    :value="computedDateFormatrecei"
                                                                    clearable
                                                                    readonly
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    @click:clear="dateval = null"
                                                                    dense
                                                                    :rules="[v => !!v || 'Date pick up is required']"
                                                                    ></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    v-model="dateval"
                                                                    @change="menu2 = false"
                                                                    :min="nowDate"
                                                                    :max="vigenciatarifa"
                                                                ></v-date-picker>
                                                            </v-menu> 
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="2">
                                                            <tr style="display: flex;">
                                                                
                                                                <td style="width: 100%;">
                                                                    <v-textarea
                                                                        outlined
                                                                        counter="600"
                                                                        name="input-5-4"
                                                                        label="Remarks"
                                                                        :rules="maxcaracteresremarks"
                                                                        v-model="remarksc"
                                                                        dense
                                                                        auto-grow
                                                                    ></v-textarea>
                                                                    <v-select
                                                                    item-text="text" return-object item-value="value"
                                                                    :items="RemarksCotizacion"
                                                                    placeholder="List Remarks"
                                                                    v-model="remarklist"
                                                                    solo
                                                                    dense
                                                                    v-on:change="mostrarfree"
                                                                    style="min-height: 55px;"
                                                                    ></v-select>
                                                                    
                                                                </td>
                                                                <td >
                                                                    <v-btn @click="agregarremarks()" style="margin-left: 8px;" color="primary">Add</v-btn>
                                                                </td>
                                                            </tr>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="remarksview == true">
                                                        <td colspan="2">
                                                            <v-simple-table v-model="remk" style="margin-bottom: 12px;">
                                                                <thead>
                                                                    <tr>
                                                                        <th>OPCIONES</th>
                                                                        <th>REMARKS</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="det in remarkstextc" :key="det.num">
                                                                        <template v-if="det.activo == true">
                                                                            <td style="text-align: center;">
                                                                                <v-tooltip top>
                                                                                    <template v-slot:activator="{ on, attrs }">                    
                                                                                        <v-icon
                                                                                            v-bind="attrs"
                                                                                            v-on="on"
                                                                                            small
                                                                                            class="mr-2"
                                                                                            @click="editRemarks(det)"
                                                                                            style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                            color="#3d5170"
                                                                                            >
                                                                                            edit
                                                                                        </v-icon>
                                                                                    </template>
                                                                                    <span>Edit</span>
                                                                                </v-tooltip>
                                                                                <v-tooltip top>
                                                                                    <template v-slot:activator="{ on, attrs }">                    
                                                                                        <v-icon
                                                                                            v-bind="attrs"
                                                                                            v-on="on"
                                                                                            small
                                                                                            class="mr-2"
                                                                                            @click="deleteRemarks(det)"
                                                                                            style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                            color="#3d5170"
                                                                                            >
                                                                                            delete
                                                                                        </v-icon>
                                                                                    </template>
                                                                                    <span>Delete</span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                            <td>{{det.text}}</td>
                                                                        </template>
                                                                    </tr>
                                                                </tbody>
                                                            </v-simple-table>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </section>
                                        </div>
                                    </v-card>
                                    <v-btn 
                                    color="primary"
                                    @click="GuardarCotizacion()"
                                    style="margin-right: 8px;"
                                    >
                                        Guardar Cotización
                                    </v-btn>
                                    <v-btn
                                    color="primary"
                                    @click="crearCotizacion()"
                                    >
                                        Continue
                                    </v-btn>
                                    <v-btn text @click="e1 = 1" color="error">
                                        Cancel
                                    </v-btn>
                                    <v-dialog
                                        v-model="dialogcot"
                                        hide-overlay
                                        persistent
                                        width="300"
                                        >
                                            <v-card
                                                color="primary"
                                                dark
                                            >
                                                <v-card-text><br>
                                                    Please stand by
                                                    <v-progress-linear
                                                        indeterminate
                                                        color="white"
                                                        class="mb-0"
                                                    ></v-progress-linear>
                                                </v-card-text>
                                            </v-card>
                                        </v-dialog>
                                </v-stepper-content>
                                <v-stepper-content step="3" style="padding: 4px 4px 6px 4px;">
                                    <v-card
                                    >
                                        <v-card-text style="padding:0" v-model="cartap"><!--Carta de presentacion-->
                                            <v-spacer></v-spacer>
                                        <v-row>
                                            <v-col>
                                                <div id="viewercot">
                                                        <PDFJSViewer style="width: 100%;" :path="`${path}`" :fileName="`${namecot}`"/>
                                                    </div>
                                            </v-col>
                                        </v-row>
                                        </v-card-text>
                                    </v-card><br>
                                    <v-btn
                                    color="primary"
                                    @click="e1 = 4"
                                    >
                                        Continue
                                    </v-btn>
                                    <v-btn text @click="ListarInformacionCot(),e1 = 2" color="error">
                                        Cancel
                                    </v-btn>
                                </v-stepper-content>
                                <v-stepper-content step="4" style="padding: 4px 4px 6px 4px;">
                                    <v-card
                                    >
                                        <v-card-text style="padding: 0 20px;" v-model="cartap"><!--Carta de presentacion-->
                                            <v-spacer></v-spacer>
                                            <v-row style="padding: 0;height: 80px;">
                                                <v-col sm="2" md="2" lg="2" xl="2" style="flex-flow: row-reverse;display: flex;align-items: center;">
                                                <span>Para:</span>
                                                </v-col>
                                                <v-col sm="10" md="10" lg="10" xl="10" style="align-content: center;padding: 0;text-align: center;display: flex;align-items: center;margin-top: 20px;" >
                                                <v-combobox
                                                        v-model="contactoscp"
                                                        :items="contactosprospecto"
                                                        :search-input.sync="searcho"
                                                        hide-selected                                          
                                                        label="Contactos"
                                                        multiple
                                                        persistent-hint
                                                        small-chips
                                                        style="margin-left: 8px;"
                                                        outlined
                                                        dense
                                                    >
                                                        <template v-slot:no-data>
                                                            <v-list-item>
                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                No se encuentran mas contactos"<strong>{{ searcho }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                </v-col>
                                            </v-row>
                                            <v-row style="padding: 0;height: 50px;">
                                                <v-col sm="2" md="2" lg="2" xl="2" style="flex-flow: row-reverse;display: flex;padding: 10px;">
                                                <span>Asunto:</span>
                                                </v-col>
                                                <v-col sm="10" md="10" lg="10" xl="10" style="padding: 10px;color: black;align-content: center;padding: 0;display: flex;align-items: center;">
                                                    <v-text-field v-model="cpasunto" label="asunto" single-line outlined dense></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <div id="app" style="border: 1px solid;">
                                                        <ckeditor style="color:black;" :editor="editor" @ready="onReady" v-model="editorcp"></ckeditor>
                                                    </div>
                                                </v-col>
                                            </v-row><br>
                                            <v-row style="border-top: 1px solid rgb(207, 216, 220);direction: rtl;"><br>
                                                <v-btn style="margin-top: 8px" text @click="">Cancelar</v-btn>
                                                <v-btn style="margin-top: 8px" color="primary" @click="enviarcorreocp()">Enviar</v-btn>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper> 
                    </v-card>
                    <v-dialog v-model="dialog6" max-width="850px">
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-card class="mx-auto">
                                            <v-list-item two-line>
                                            <v-list-item-content>                                                        
                                                <v-toolbar flat color="white">
                                                    <v-toolbar-title>Contactos</v-toolbar-title>
                                                    <v-divider
                                                    class="mx-4"
                                                    inset
                                                    vertical
                                                    ></v-divider>
                                                    <v-spacer></v-spacer>                                                                    
                                                </v-toolbar>                                                              
                                                <v-list-item-subtitle>* Campos obligatorios</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-card-text style="padding-top: 0; padding-bottom: 0;">                                                    
                                            <v-row aling="center">
                                                <v-col md="6">
                                                    <v-text-field v-model="editcontact.nombre" label="*Nombre contacto"></v-text-field>
                                                </v-col>
                                                <v-col sm="6" md="3">
                                                    <v-text-field v-model="editcontact.puesto" label="Puesto"></v-text-field>
                                                </v-col>
                                                <v-col sm="6" md="3">
                                                    <v-text-field v-model="editcontact.telefono" label="Teléfono"></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editcontact.celular" label="Celular"></v-text-field>                                                            
                                                </v-col>
                                                <v-col >
                                                    <v-text-field v-model="editcontact.correo" label="*Correo"></v-text-field>
                                                </v-col>                                                        
                                            </v-row>    
                                            <v-row>
                                                <v-col style="display: flex;flex-direction: row-reverse;margin-bottom: 10px;">
                                                    <v-btn small color="primary" @click="agregarcontacto" dark>Agregar</v-btn>
                                                </v-col>
                                            </v-row>                                                 
                                            <v-row>
                                                <v-col  style="padding-bottom: 10px;">
                                                    <v-data-table
                                                    :headers="headersc"
                                                    :items="contactos"
                                                    sort-by="calories"
                                                    class="elevation-1"
                                                    >
                                                    <template v-slot:[`item.activo`]="{ item }">  
                                                        <div v-if="item.activo">
                                                            <span class="blue--text">Activo</span>                
                                                        </div>
                                                        <div v-else>
                                                            <span class="red--text">Inactivo</span>                
                                                        </div>                  
                                                    </template>
                                                    <template v-slot:[`item.opciones`]="{ item }">
                                                                <v-icon
                                                                small
                                                                class="mr-2"
                                                                @click="editItemc(item)"
                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                color="#3d5170"
                                                                >
                                                                edit
                                                                </v-icon>
                                                                <template v-if="item.activo">
                                                                    <v-icon
                                                                        small
                                                                        class="mr-2"
                                                                        @click="activarDesactivarMostrar(2,item)"
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        delete
                                                                        </v-icon>                               
                                                                </template>                                                             
                                                    </template>     
                                                        <template v-slot:no-data>
                                                        </template>
                                                    </v-data-table>                                                            
                                                </v-col>
                                            </v-row>                                                    
                                        </v-card-text>                                                
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-dialog>
                </v-dialog>
            </v-row>
            <v-row>
                <v-col>
                    <v-dialog v-model="confirmacionsolicitud" 
                    transition="dialog-bottom-transition"
                    max-width="80%">
                    <template >
                        <v-card>
                            <v-toolbar color="primary" style="font-size: 25px;" dark>Confirmar Información </v-toolbar>
                            <v-card-text><br>
                                <div>
                                    <table style="width: 100%;  border-collapse: collapse;">
                                        <tr>
                                            <td colspan="2" style="text-align: center;font-weight: 600;color: black;font-size: 18px;padding: 0 0 15px 0;"><span>Solicitud de Tarifa Para: </span> {{nagente}} <span v-if="nlocal !=''"> y </span> {{nlocal}}<br></td>
                                        </tr>
                                        <tr>
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;"></td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{noperacion}}</td>
                                        </tr>
                                        <tr>
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">MODALIDAD DE TRANSPORTE:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nmodalidad}}</td>
                                        </tr>
                                        <tr>
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">TIPO DE EMBARQUE:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ntipoembarque}}</td>
                                        </tr>
                                        <tr v-if="ntipoembarque === 'FCL' || ntipoembarque === 'FTL'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">EQUIPO SOLICITADO:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 5px 5px 5px 5px;">
                                                <v-data-table
                                                    :headers="headersinfc"
                                                    :items="containers"
                                                    hide-default-footer
                                                    class="elevation-1" 
                                                    >
                                                    <template slot="item" slot-scope="containers">
                                                        <tr v-if="containers.item.activo == true">
                                                            <td style="text-align: center">{{containers.item.quantity}}</td>
                                                            <td style="text-align: center">{{containers.item.size}}</td>
                                                            <td style="text-align: center">{{containers.item.type}}</td>
                                                            <td style="text-align: center">{{containers.item.nweight}}</td>
                                                            <td style="text-align: center">{{containers.item.totalweight}}</td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>  
                                            </td>
                                        </tr>
                                        <tr v-else>
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">DESCRICION DE LA CARGA:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 5px 5px 5px 5px;">
                                                <v-data-table
                                                    :headers="headerpackageinf"
                                                    :items="addpackages"
                                                    hide-default-footer
                                                    class="elevation-1" 
                                                    >
                                                        <template slot="item" slot-scope="addpackages">
                                                        <tr v-if="addpackages.item.activo == true">
                                                            <td style="text-align: center">{{addpackages.item.quantity}}</td>
                                                            <td style="text-align: center">{{addpackages.item.package}}</td>
                                                            <td style="text-align: center">{{addpackages.item.nlarge}}</td>
                                                            <td style="text-align: center">{{addpackages.item.nwidth}}</td>
                                                            <td style="text-align: center">{{addpackages.item.nhigh}}</td>
                                                            <td style="text-align: center">{{addpackages.item.nweight}}</td>
                                                            <td style="text-align: center">{{addpackages.item.volumetricweight}}</td>
                                                            <td style="text-align: center">{{addpackages.item.actualweight}}</td>
                                                            <td style="text-align: center">{{addpackages.item.Notes}}</td>
                                                            <td style="text-align: center">
                                                                <div v-if="addpackages.item.nstackable === 'yes'" style="text-align: center;">
                                                                    <v-icon
                                                                        small
                                                                        class="mr-2"
                                                                        style="padding: 4px;border: 1px solid rgb(29, 175, 128);border-radius: 3px;font-weight: 700;"
                                                                        color="rgb(29 175 128)"
                                                                        >
                                                                        check
                                                                    </v-icon>
                                                                </div>
                                                                <div v-else style="text-align: center;">
                                                                    <v-icon
                                                                        small
                                                                        class="mr-2"
                                                                        style="padding: 4px;border: 1px solid #d80808;border-radius: 3px;font-weight: 700;"
                                                                        color="#d80808"
                                                                        >
                                                                        clear
                                                                    </v-icon>            
                                                                </div>                  
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">INLAND:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ninland}}</td>
                                        </tr>
                                        <tr v-if="nrecoleccion !=''">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">RECOLECCION:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nrecoleccion}}</td>
                                        </tr>
                                        <tr v-if="npickup != 'SELECT..'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">PLACE OF RECEIPT/ PICK UP:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{npickup}}</td>
                                        </tr>
                                        <tr v-if="ntipoembarque === 'FCL' || ntipoembarque === 'LCL' || ntipoembarque === 'AEREO'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">POL / AOL:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{npol}}</td>
                                        </tr>
                                        <tr v-if="ntipoembarque === 'FCL' || ntipoembarque === 'LCL' || ntipoembarque === 'AEREO'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">POD / AOD:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{npod}}</td>
                                        </tr>
                                        <tr v-if="ndelivery != 'SELECT..'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">DELIVERY:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ndelivery}}</td>
                                        </tr>
                                        <tr v-if="nentrega != ''">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;"> ENTREGA:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nentrega}}</td>
                                        </tr>
                                        <tr>
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">MERCANCIA<br>(Descripción general de la carga):</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nmercancia}}</td>
                                        </tr>
                                        <tr v-if="nfoodgrade != ''">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">FOODGRADE:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nfoodgrade}}</td>
                                        </tr>
                                        <tr v-if="ncustoms === 'SI'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">DESPACHO ADUANAL:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ncustoms}}</td>
                                        </tr>
                                        <tr v-if="ninsurance === 'SI'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">SEGURO DE CARGA:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ninsurance}}</td>
                                        </tr>
                                        <tr v-if="nvgm === 'SI'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">VGM:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nvgm}}</td>
                                        </tr>
                                        <tr v-if="nmaneuvers === 'SI'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">MANEUVERS:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nmaneuvers}}</td>
                                        </tr>
                                        <tr v-if="ncustody === 'SI'">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">CUSTODY:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{ncustody}}</td>
                                        </tr>
                                        <tr v-if="harz">
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">HAZARDOUS:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 5px 5px 5px 5px;">
                                                <v-data-table
                                                :headers="headersCinf"
                                                :items="containerFile"      
                                                hide-default-footer                                     
                                                class="elevation-1"
                                                dense
                                                > 
                                                    <template slot="item" slot-scope="containers">
                                                        <tr v-if="containers.item.activo == true">
                                                            <td style="text-align: center;max-width: 250px;padding: 8px;">{{containers.item.class1}}</td>
                                                            <td style="text-align: center;max-width: 250px;padding: 8px;">{{containers.item.un}}</td>
                                                            <td style="text-align: center;padding: 8px;">
                                                                <v-tooltip top>
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                    <a
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        @click="ViewFiles(containers.item.file)"
                                                                        color="rgb(41 111 183)">
                                                                        {{containers.item.file}}
                                                                        <v-icon
                                                                        small
                                                                        style="padding: 4px;font-size:20px;"
                                                                        color="rgb(41 111 183)"
                                                                        >
                                                                            visibility
                                                                        </v-icon>
                                                                    </a>
                                                                    </template>
                                                                    <span>View</span>
                                                                </v-tooltip>
                                                            </td>
                                                        </tr>
                                                    </template> 
                                                    <template v-slot:no-data>
                                                        <v-btn dense color="primary" @click="listar">Reset</v-btn>
                                                    </template>
                                                </v-data-table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="border: 1px solid;background: rgb(179,211,236);color: black;font-weight: 400;padding: 2px 2px 0px 5px;">OBSERVACIONES:</td>
                                            <td style="border: 1px solid;color: black;font-weight: 400;padding: 2px 2px 0px 5px;">{{nobservaciones}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </v-card-text>
                            <v-card-actions class="justify-end">
                            <v-btn color="error"
                                @click="confirmacionsolicitud = false"
                            >Close</v-btn>
                            <v-btn color="primary" @click="guardar"> Enviar</v-btn>
                            </v-card-actions>
                        </v-card>
                        </template>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-row v-if="nuevast === true">
                <v-col>
                    <v-card class="mx-auto" width="100%" elevation="10">
                        <v-list-item two-line>
                            <v-list-item-content>                                                        
                                <v-toolbar flat color="white">
                                    <v-toolbar-title v-if="editBS.activo == true">Solicitud de Tarifa N° <span>:{{editBS.ncotizacion}}</span></v-toolbar-title>
                                    <v-toolbar-title v-else style="color:rgb(218,20,6);"><v-icon color="rgb(218,20,6)">cancel</v-icon> Solicitud de Tarifa N° <span>:{{editBS.ncotizacion}} </span></v-toolbar-title>
                                    <v-spacer></v-spacer> 
                                    <v-btn color="primary" @click="clonarsolicitud()" v-if="editBS.ncotizacion != ''">Clonar</v-btn>
                                    <!--<v-btn color="primary">Buscar</v-btn>-->
                                    <!--<v-btn @click="crearCotizacion()">Cotizacion</v-btn>    
                                     <a :href="{urllik}">descargar</a>-->
                                </v-toolbar>                                                              
                                <v-list-item-subtitle>* Campos obligatorios</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>                
                        <v-card-text>
                            <v-row style="align-items: center;margin-top:8px;" >                                
                                <v-col sm="4" md="2" lg="2" >
                                    <v-select  outlined dense v-model="editBS.idbasis" v-on:change="activar" label="* Basis" :items="basis">
                                    </v-select>
                                </v-col>
                                <v-col sm="4" md="2" lg="2">
                                    <v-select outlined dense v-model="editBS.idtipoOp" v-on:change="activar" label="* Operation type" :items="TipoOperacion"></v-select>
                                </v-col>
                                <v-col sm="4" md="2" lg="2" v-if="impaal">
                                    <v-row>
                                        <v-col>
                                            <v-btn-toggle
                                                v-model="optionsbuttonagent"
                                                tile
                                                color="#055a7f"
                                                dense
                                                group
                                                multiple>
                                                <v-btn value="agent" >
                                                    Agent 
                                                </v-btn>  
                                                <v-btn value="local" v-if="activevgm === false"><!--solo aparecera en exportacion-->
                                                    Local 
                                                </v-btn>                                                                           
                                            </v-btn-toggle>
                                        </v-col>                                        
                                    </v-row>
                                </v-col>
                                <v-col md="6" lg="6" xl="6"  v-if="ftl === false">
                                    <v-row >
                                        <v-col style="display: flex;" md="12" lg="12" xl="12" >
                                            <v-btn-toggle
                                                v-model="editBS.indland"
                                                tile
                                                color="blue"
                                                group
                                                dense
                                                style="border: 1px solid;margin-bottom: 12px;margin-right: 8px;"
                                                >
                                                <v-btn value="inland" @click="mostrarinland()">
                                                    Inland
                                                </v-btn>                                    
                                            </v-btn-toggle>
                                            <div v-if="indl" style="padding-left: 5px;">
                                                <v-row>
                                                    <v-col>
                                                        <v-select outlined dense v-model="editBS.idinland" label="Inland" :items="inlands"></v-select>
                                                    </v-col>
                                                    <v-col>
                                                        <v-select outlined dense v-model="editBS.dentrofbl" label="* Dentro o fuera de BL" :items="bl"></v-select>
                                                    </v-col>
                                                </v-row>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-col>                        
                            </v-row>
                            <v-row style="margin-bottom: 6px;">
                                <v-col>
                                    <v-btn-toggle
                                    v-model="optionsbutton"
                                    tile
                                    color="#055a7f"
                                    style="border: 1px solid;"
                                    dense
                                    group
                                    multiple>
                                        <v-btn value="customs">
                                            Customs 
                                        </v-btn>  
                                        <v-btn value="vgm" v-if="activevgm === false" ><!--solo aparecera en exportacion-->
                                            VGM 
                                        </v-btn>
                                        <v-btn value="insurance" >
                                            INSURANCE
                                        </v-btn>
                                         <v-btn value="custody" v-if="custody">
                                            CUSTODY
                                        </v-btn>
                                        <v-btn value="maneuvers" v-if="maneuvers === false">
                                            MANEUVERS
                                        </v-btn>
                                    </v-btn-toggle>
                                <v-spacer></v-spacer>
                                </v-col>
                            </v-row>
                            <v-row style="margin-top: 16px;">
                                <v-col md="6" lg="4" xl="4">
                                    <v-select outlined dense label="* Customer Name" v-model="editBS.idcustumer" :items="prospectossn"></v-select>
                                </v-col>                                
                            </v-row>
                            <v-row >                        
                                <v-col md="3" lg="3" xl="3">
                                    <v-text-field outlined dense v-model="editBS.comodity" label="Commodity"></v-text-field>
                                </v-col>
                                <v-col md="3" lg="3" xl="3" v-if="viewfood===false">
                                    <v-text-field outlined v-model="editBS.foodgrade" dense label="Food Grade"></v-text-field>
                                </v-col>                                
                            </v-row>    
                            <v-row>
                                <v-col md="12" lg="12" xl="12"  style="display:flex;align-items: baseline;">
                                    <v-btn-toggle
                                    v-model="editBS.btnhazardous"
                                    tile
                                    color="#ce1507"
                                    style="margin-bottom: 12px;margin-right: 8px;border: 1px solid;"
                                    group     
                                    dense                                
                                    >
                                        <v-btn  @click="mostrarhazardous" value="hazardous" >
                                            Hazardous 
                                        </v-btn>                                                                             
                                    </v-btn-toggle>
                                    <div v-if="harz">
                                        <v-row style="align-items: center;">
                                            <v-col md="3" lg="3" xl="3">
                                                <v-text-field outlined dense v-model="editcontainerFile.class1" label="class"></v-text-field>
                                            </v-col>
                                            <v-col md="3" lg="3" xl="3">
                                                <v-text-field outlined dense v-model="editcontainerFile.un" label="UN"></v-text-field>
                                            </v-col >
                                            <v-col md="5" lg="5" xl="5" style="display: flex;">
                                                    <template>
                                                        <v-file-input
                                                        v-model="files"
                                                        dense
                                                        color="red"
                                                        accept='.pdf'
                                                        label="File input"
                                                        prepend-icon="mdi-paperclip"
                                                        outlined
                                                        v-on:change="Onfileselected"
                                                        >
                                                        <template v-slot:selection="{ index, text }">
                                                            <v-chip
                                                                v-if="index < 2"
                                                                color="red"
                                                                dark
                                                                label
                                                                small
                                                            >
                                                                {{ text }}
                                                            </v-chip>
                                                        </template>
                                                        </v-file-input>
                                                    </template>
                                                <v-btn style="margin-left: 8px;" color="primary" @click="agregarFile">ADD</v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col style="width:80%;margin-bottom:25px;">
                                            <v-data-table
                                                :headers="headersC"
                                                :items="containerFile"                                            
                                                class="elevation-1"
                                                dense
                                                > 
                                                <template slot="item" slot-scope="containers">
                                                    <tr v-if="containers.item.activo == true">
                                                        <td style="text-align: center;max-width: 20px;">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">                    
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        small
                                                                        class="mr-2"
                                                                        @click="editfiles(containers.item)"
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        edit
                                                                    </v-icon>
                                                                </template>
                                                                <span>Edit</span>
                                                            </v-tooltip>
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">                    
                                                                    <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        small
                                                                        class="mr-2"
                                                                        @click="deleteItemFile(containers.item)"
                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                        color="#3d5170"
                                                                        >
                                                                        delete
                                                                    </v-icon>
                                                                </template>
                                                                <span>Delete</span>
                                                            </v-tooltip>
                                                        </td>
                                                        <td style="text-align: center;max-width: 250px;padding: 8px;">{{containers.item.class1}}</td>
                                                        <td style="text-align: center;max-width: 250px;padding: 8px;">{{containers.item.un}}</td>
                                                        <td style="text-align: center;padding: 8px;">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                <a
                                                                    v-bind="attrs"
                                                                    v-on="on"
                                                                    @click="ViewFiles(containers.item.file)"
                                                                    color="rgb(41 111 183)">
                                                                    {{containers.item.file}}
                                                                    <v-icon
                                                                    small
                                                                    style="padding: 4px;font-size:20px;"
                                                                    color="rgb(41 111 183)"
                                                                    >
                                                                        visibility
                                                                    </v-icon>
                                                                </a>
                                                                </template>
                                                                <span>View</span>
                                                            </v-tooltip>
                                                        </td>
                                                    </tr>
                                                </template> 
                                                <template v-slot:no-data>
                                                    <v-btn dense color="primary" @click="listar">Reset</v-btn>
                                                </template>
                                            </v-data-table>
                                            </v-col>
                                        </v-row>                                           
                                    </div>
                                </v-col>
                            </v-row>                          
                            <v-row style="flex-direction: column;">
                                <v-col>
                                    <v-row v-if="inland" style="display: flex;align-items: center;">
                                        <v-col md="6" lg="4" xl="4" >
                                            <v-select outlined dense v-model="editBS.idportreceipt" :label="Nportreceipt" :items="ports">
                                            </v-select>
                                        </v-col>
                                        <v-col style="display: flex;">
                                            <v-btn
                                                color="#1e79e9"
                                                dark
                                                @click="dialogd=true"
                                                icon
                                                >
                                                <span class="material-icons">location_on</span>
                                            </v-btn>
                                            <v-textarea outlined name="input-7-4" label="Receipt address" v-model="addressreceipt" dense></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-col>                        
                                <v-col md="6" lg="4" xl="4" v-if="ftl === false">
                                    <v-select outlined dense v-model="editBS.idportloading" :label="Nportloading" :items="ports" v-on:change="notificationpuertosbase"></v-select>
                                </v-col>
                                <v-col md="6" lg="4" xl="4" v-if="ftl === false">
                                    <v-select outlined dense v-model="editBS.idportdischarge" :label="Nportdischarge" :items="ports"></v-select>
                                </v-col>
                                <v-col>
                                    <v-row v-if="inland" style="display: flex;align-items: center;">
                                        <v-col md="6" lg="4" xl="4">
                                            <v-select outlined dense v-model="editBS.idportdelivery" :label="Nportdelivery" :items="ports"></v-select>
                                        </v-col>
                                        <v-col style="display: flex;">
                                            <v-btn
                                                color="#1e79e9"
                                                dark
                                                @click="dialogr=true"
                                                icon
                                                >
                                                <span class="material-icons">location_on</span>
                                            </v-btn>
                                            <v-textarea outlined name="input-7-4" label="Delivery address" v-model="addressdelivery" dense></v-textarea>
                                        </v-col>                                       
                                    </v-row>
                                </v-col>                        
                            </v-row>
                            <v-row v-if="daysview === false">
                                <v-col>                            
                                    <span class="titleogl">Free days of demurrage</span>
                                </v-col>
                            </v-row>
                            <v-row v-if="daysview === false" style="margin-top:16px;">                        
                                <v-col sm="2" md="2" lg="2">
                                    <v-text-field type="number" dense v-model="editBS.freedaysorigin" outlined label="Origin"></v-text-field>
                                </v-col>
                                <v-col sm="2" md="2" lg="2">
                                    <v-text-field type="number" dense v-model="editBS.freedaysdest" outlined label="Destination"></v-text-field>
                                </v-col>                               
                            </v-row>
                            <v-row>
                                <v-col md="5">
                                    <v-textarea
                                        outlined
                                        name="input-7-4"
                                        label="Remarks"
                                        v-model="editBS.remarks"
                                        dense
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <v-row style="align-items: center;">                                                    
                                <v-col md="9"> 
                                    <v-card elevation="3" style="padding-bottom: 0;" dense> 
                                        <v-card-text v-if="CONTAINER === true"><!--Container-->
                                            <v-row style="display: flex;align-items: center;">
                                                <v-col sm="7" md="7">
                                                    <span class="titleogl">{{titlec}}</span>
                                                </v-col>
                                                <v-col sm="3" md="3">
                                                    <v-select item-text="text" return-object item-value="value" v-model="editcontainer.peso" label="Unidad Peso" :items="Masa"></v-select>
                                                </v-col>
                                                <v-col sm="2" md="2" style="text-align: center;">
                                                    <v-btn color="primary" @click="agregar">ADD</v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row style="align-items: center;margin-top:8px;">
                                                <v-col sm="2" md="2">
                                                    <v-text-field type="number" dense v-model="editcontainer.quantity" label="Quantity"></v-text-field>
                                                </v-col>
                                                <v-col sm="3" md="3">
                                                    <v-select dense return-object item-text="text" item-value="value" label="* Container Size" v-model="editcontainer.idsize" :items="tamanoc"></v-select>
                                                </v-col>
                                                <v-col sm="3" md="3">
                                                    <v-select dense return-object item-text="text" item-value="value" label="* Container Type" v-model="editcontainer.idtype" :items="tipoc">                                                                
                                                    </v-select>
                                                </v-col>
                                                <v-col sm="4" md="4">
                                                    <v-text-field type="number" dense v-model="editcontainer.weight" :label="'Weight in ' + editcontainer.peso.text "></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                <v-data-table
                                                    :headers="headers"
                                                    :items="containers"
                                                    class="elevation-1" 
                                                    >
                                                    <template slot="item" slot-scope="containers">
                                                            <tr v-if="containers.item.activo == true">
                                                                <td style="text-align: center">
                                                                    <v-tooltip top>
                                                                        <template v-slot:activator="{ on, attrs }">                    
                                                                            <v-icon
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                small
                                                                                class="mr-2"
                                                                                @click="editItem(containers.item)"
                                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                color="#3d5170"
                                                                                >
                                                                                edit
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Edit</span>
                                                                    </v-tooltip>
                                                                    <v-tooltip top>
                                                                        <template v-slot:activator="{ on, attrs }">                    
                                                                            <v-icon
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                small
                                                                                class="mr-2"
                                                                                @click="deleteItemc(containers.item)"
                                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                color="#3d5170"
                                                                                >
                                                                                delete
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Delete</span>
                                                                    </v-tooltip>
                                                                </td>
                                                                <td style="text-align: center">{{containers.item.quantity}}</td>
                                                                <td style="text-align: center">{{containers.item.size}}</td>
                                                                <td style="text-align: center">{{containers.item.type}}</td>
                                                                <td style="text-align: center">{{containers.item.nweight}}</td>
                                                                <td style="text-align: center">{{containers.item.totalweight}}</td>
                                                            </tr>
                                                    </template>
                                                        <template slot="no-data">
                                                            <v-btn colo="primary" >Resetear</v-btn>
                                                        </template> 
                                                </v-data-table>  
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                        <v-card-text dense v-if="PACKAGES === true" ><!--PACKAGES-->
                                            <v-row style="align-items: center;">
                                                <v-col>
                                                    <span class="titleogl" >PACKAGES</span>
                                                </v-col>
                                                <v-col>
                                                    <v-select item-text="text" return-object item-value="value" v-model="editpackage.longitud" label="Unidad Longitud" :items="Longitud"></v-select>
                                                </v-col>
                                                <v-col>
                                                    <v-select item-text="text" return-object item-value="value" v-model="editpackage.peso" label="Unidad Peso" :items="Masa"></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row style="align-items: center;" >
                                                <v-col md="3">
                                                    <v-text-field type="number" dense v-model="editpackage.quantity" label="Quantity "></v-text-field>
                                                </v-col>
                                                <v-col md="4">
                                                    <v-select item-text="text" return-object item-value="value" v-model="editpackage.idpackage" v-on:change="mostrarotro" dense label="Type of packages" :items="selectpackage"></v-select>
                                                </v-col>  
                                                <v-col md="5" v-if="packageotro === true">
                                                    <v-text-field dense v-model="editpackage.otropackage" label="Type of Package"></v-text-field>
                                                </v-col>                                  
                                            </v-row>
                                            <v-row style="align-items: center;">
                                                <v-col md="2" style="padding-right: 0;color: #186184;font-weight: 600;font-size: 14px;">
                                                    <span>Measures </span>
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editpackage.large" type="number" dense label="Lenth"></v-text-field><!--+ editpackage.idpackage.text-->
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editpackage.width" type="number" dense label="Width"></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-text-field v-model="editpackage.high" type="number" dense label="Height"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row style="align-items: center;" >
                                                <v-col md="2" style="padding-right: 0;color: #186184;font-weight: 600;font-size: 14px;">
                                                    <span>Stackable </span>
                                                </v-col>
                                                <v-col md="3">
                                                    <v-btn-toggle
                                                    v-model="editpackage.stackable"
                                                    tile
                                                    color="blue"
                                                    group
                                                    dense
                                                    >
                                                        <v-btn value="yes">
                                                            Yes
                                                        </v-btn>
                                                        <v-btn value="no">
                                                            No
                                                        </v-btn>                                            
                                                    </v-btn-toggle>
                                                </v-col>
                                                <v-col md="7">
                                                    <v-text-field v-model="editpackage.weight" type="number" dense :label="'Weight in ' + editpackage.peso.text"></v-text-field>
                                                </v-col>
                                                <v-col>
                                                    <v-textarea
                                                        v-model="editpackage.Notes"
                                                        outlined
                                                        name="input-7-4"
                                                        label="Remarks"
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col style="text-align: end;">
                                                    <v-btn color="primary" @click="agregarpackage">ADD</v-btn>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                <v-data-table
                                                        :headers="headerpackage"
                                                        :items="addpackages"
                                                        class="elevation-1" 
                                                        >
                                                         <template slot="item" slot-scope="addpackages">
                                                            <tr v-if="addpackages.item.activo == true">
                                                                <td style="text-align: center">
                                                                    <v-tooltip top>
                                                                        <template v-slot:activator="{ on, attrs }">                    
                                                                            <v-icon
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                small
                                                                                class="mr-2"
                                                                                @click="editItempackage(addpackages.item)"
                                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                color="#3d5170"
                                                                                >
                                                                                edit
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Edit</span>
                                                                    </v-tooltip>
                                                                    <v-tooltip top>
                                                                        <template v-slot:activator="{ on, attrs }">                    
                                                                            <v-icon
                                                                                v-bind="attrs"
                                                                                v-on="on"
                                                                                small
                                                                                class="mr-2"
                                                                                @click="deleteItempackage(addpackages.item)"
                                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                color="#3d5170"
                                                                                >
                                                                                delete
                                                                            </v-icon>
                                                                        </template>
                                                                        <span>Delete</span>
                                                                    </v-tooltip>
                                                                </td>
                                                                <td style="text-align: center">{{addpackages.item.quantity}}</td>
                                                                <td style="text-align: center">{{addpackages.item.package}}</td>
                                                                <td style="text-align: center">{{parseFloat(addpackages.item.nlarge).toFixed(2)}} Mts.</td>
                                                                <td style="text-align: center">{{parseFloat(addpackages.item.nwidth).toFixed(2)}} Mts.</td>
                                                                <td style="text-align: center">{{parseFloat(addpackages.item.nhigh).toFixed(2)}} Mts.</td>
                                                                <td style="text-align: center">{{addpackages.item.nweight}} </td>
                                                                <td style="text-align: center">{{addpackages.item.volumetricweight}} </td>
                                                                <td style="text-align: center">{{addpackages.item.actualweight}}</td>
                                                                <td style="text-align: center">
                                                                    <div v-if="addpackages.item.nstackable === 'yes'" style="text-align: center;">
                                                                        <v-icon
                                                                            small
                                                                            class="mr-2"
                                                                            style="padding: 4px;border: 1px solid rgb(29, 175, 128);border-radius: 3px;font-weight: 700;"
                                                                            color="rgb(29 175 128)"
                                                                            >
                                                                            check
                                                                        </v-icon>
                                                                    </div>
                                                                    <div v-else style="text-align: center;">
                                                                        <v-icon
                                                                            small
                                                                            class="mr-2"
                                                                            style="padding: 4px;border: 1px solid #d80808;border-radius: 3px;font-weight: 700;"
                                                                            color="#d80808"
                                                                            >
                                                                            clear
                                                                        </v-icon>            
                                                                    </div>                  
                                                                </td>
                                                            </tr>
                                                        </template>
                                                            <template slot="no-data">
                                                                <v-btn colo="primary" >Resetear</v-btn>
                                                            </template> 
                                                    </v-data-table>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col style="display: flex;justify-content: center;">
                                                    <table>
                                                        <tr style="display: flex;">
                                                            <td style="width: 180px;text-align: center;font-weight: 600;color: black;display: flex;"><span style="width: 100%;color:#115bb7;">VOLUMETRIC WEIGHT</span></td>
                                                            <td style="width: 180px;text-align: center;font-weight: 600;color: black;display: flex;"><span style="width: 100%;color:#115bb7;">TOTAL WEIGHT</span></td>
                                                        </tr>
                                                        <tr style="display: flex;">
                                                            <td style="width: 180px;text-align: center;font-weight: 600;color: black;display: flex;"><span style="width: 100%;">{{parseFloat(volumenwn).toFixed(2)}}</span></td>
                                                            <td style="width: 180px;text-align: center;font-weight: 600;color: black;display: flex;"><span style="width: 100%;">{{parseFloat(totalwn).toFixed(2)}}</span></td>
                                                        </tr>
                                                    </table>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>                                                           
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-flex xs12 sm12 md12 lg12 xl12>
                                        <v-data-table
                                        :headers="headerst"
                                        :items="tarifas"
                                        class="elevation-1" 
                                        v-if="verNuevo"
                                        >
                                        <template v-slot:[`item.activo`]="{ item }">
                                        <div v-if="item.activo">
                                        <span class="blue--text">Aceptado</span>          
                                        </div>
                                        <div v-else>
                                        <span class="red--text">{{item.activo}}</span>
                                        </div>
                                        </template>
                                        <template v-slot:[`item.opciones`]="{ item }">
                                            <v-icon
                                            small
                                            class="mr-2"
                                            @click="tarifa(item)"
                                            >
                                            tab
                                            </v-icon>
                                            <v-icon
                                            small
                                            class="mr-2"
                                            @click="datosExtras(item)"
                                            >
                                            open_in_new
                                            </v-icon>                                            
                                        </template>
                                            <template slot="no-data">
                                                <v-btn colo="primary" @click="buscarCodigo()">Resetear</v-btn>
                                            </template> 
                                        </v-data-table> 
                                    <v-dialog
                                            v-model="dialogtaf"
                                            fullscreen
                                            hide-overlay
                                            transition="dialog-bottom-transition"
                                            scrollable
                                            >
                                        <v-card tile>
                                            <v-toolbar
                                            flat
                                            dark
                                            color="primary"
                                        >
                                            <v-btn
                                            icon
                                            dark
                                            @click="dialogtaf = false"
                                            >
                                                x
                                            </v-btn>
                                            <v-toolbar-title dark><span style="color:white;">Tarifa</span></v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-toolbar-items>
                                                <v-btn
                                                    dark
                                                    text
                                                    @click="dialogtaf = false"
                                                >
                                                    Save
                                                </v-btn>
                                            </v-toolbar-items>                                            
                                        </v-toolbar>                                        
                                        <v-card-text>
                                            <v-row style="margin-top: 30px;">
                                                <v-col>                                                                                                        
                                                    <v-label ><span style="font-size: 20px;font-weight: 600;">Proveedor:</span></v-label>
                                                </v-col>
                                                <v-col><v-label ><span style="font-size: 20px;font-weight: 600;">POL:</span> </v-label>
                                                </v-col>
                                                <v-col><v-label><span style="font-size: 20px;font-weight: 600;">POD:</span></v-label>
                                                </v-col>                                                
                                                    <v-col><v-label><span style="font-size: 20px;font-weight: 600;">FRECUENCIA:</span></v-label>
                                                </v-col>                                                
                                            </v-row> 
                                            <v-row >
                                                <v-col>                                                                                                        
                                                    <v-label><span style="font-size: 20px;color: #054f8e;font-weight: 600;"> {{editTarifa.nombreprov}}</span></v-label>
                                                </v-col>
                                                <v-col><v-label><span style="font-size: 20px;color: #054f8e;font-weight: 600;"> {{editTarifa.pol}}</span></v-label>
                                                </v-col>
                                                <v-col><v-label><span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.pod}}</span></v-label>
                                                </v-col>                                                
                                                    <v-col><v-label><span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.frecuencia}}</span></v-label>
                                                </v-col>                                                
                                            </v-row>   
                                            <v-row style="margin-top: 20px;">                                                
                                                    <v-col md="3" lg="3"><v-label><span style="font-size: 20px;font-weight: 600;">TIEMPO DE TRANSITO:</span> </v-label>
                                                </v-col>                                                 
                                                    <v-col md="3" lg="3"><v-label><span style="font-size: 20px;font-weight: 600;">SERVICIO:</span> </v-label>
                                                </v-col>
                                            </v-row>  
                                            <v-row>                                                
                                                    <v-col md="3" lg="3"><v-label> <span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.tt}}</span></v-label>
                                                </v-col>                                                 
                                                    <v-col md="3" lg="3"><v-label> <span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.serviciodirecto}}</span></v-label>
                                                </v-col>
                                            </v-row>   
                                            <v-row style="margin-top: 20px;">
                                                <v-col><v-label><span style="font-size: 20px;font-weight: 600;">CURRENCY:</span> </v-label></v-col>
                                                <v-col><v-label><span style="font-size: 20px;font-weight: 600;">20' DC: </span></v-label></v-col>
                                                <v-col><v-label><span style="font-size: 20px;font-weight: 600;">40' DC:</span> </v-label></v-col>
                                                <v-col><v-label><span style="font-size: 20px;font-weight: 600;">40' HC: </span></v-label></v-col>
                                                <v-col><v-label><span style="font-size: 20px;font-weight: 600;">40' HC REEFER: </span></v-label></v-col>
                                            </v-row>
                                             <v-row>
                                                <v-col><v-label><span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.abreviatura}}</span></v-label></v-col>
                                                <v-col><v-label><span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.dC20}}</span></v-label></v-col>
                                                <v-col><v-label> <span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.dC40}}</span></v-label></v-col>
                                                <v-col><v-label> <span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.hC40}}</span></v-label></v-col>
                                                <v-col><v-label> <span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.hcF40}}</span></v-label></v-col>
                                            </v-row>
                                            <v-row style="margin-top: 20px;">
                                                <v-col md="3" lg="3"><v-label ><span style="font-size: 20px;font-weight: 600;">SELLO:</span></v-label></v-col>
                                                <v-col md="3" lg="3"><v-label ><span style="font-size: 20px;font-weight: 600;">IMO:</span></v-label></v-col>
                                                <v-col md="3" lg="3"><v-label ><span style="font-size: 20px;font-weight: 600;">ACODICIONAMIENTO: </span></v-label></v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col md="3" lg="3"><v-label> <span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.sello}}</span></v-label></v-col>
                                                <v-col md="3" lg="3"><v-label><span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.imocargo}}</span></v-label></v-col>
                                                <v-col md="3" lg="3"> <v-label> <span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.acondicionamiento}}</span></v-label></v-col>
                                            </v-row>
                                            <v-row style="margin-top:20px;">
                                                <v-col md="3" lg="3"><v-label><span style="font-size: 20px;font-weight: 600;">DIAS LIBRES EN ORIGEN:</span></v-label></v-col>
                                                <v-col md="3" lg="3"><v-label><span style="font-size: 20px;font-weight: 600;">DIAS LIBRES EN DESTINO: </span></v-label></v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col md="3" lg="3"><v-label><span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.diaslibres_origen}}</span></v-label></v-col>
                                                <v-col md="3" lg="3"><v-label><span style="font-size: 20px;color: #054f8e;font-weight: 600;">{{editTarifa.hcF40}}</span></v-label></v-col>
                                            </v-row>
                                            <v-row style="margin-top:20px;">
                                                <v-col md="2" lg="2">
                                                    <v-btn color="error">Cancelar</v-btn>
                                                </v-col>
                                                <v-col md="2" lg="2">
                                                    <v-btn color="primary">Cotizar</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>                                        
                                        </v-card>
                                    </v-dialog>
                                    </v-flex>
                                </v-col>
                            </v-row>                           
                            <v-row style="margin-top:8px;">
                                <!--<v-col md="2" lg="2">
                                    <v-btn color="primary" @click="buscarTarifa()">View Rates</v-btn>
                                </v-col>-->
                                 <v-col md="12" lg="12" v-if="!idejecutivo">
                                    <v-btn color="primary" @click="verificarinformacion()">Request Rates</v-btn>
                                    <v-btn v-if="editBS.activo == true" color="error" style="margin-left: 12px;" @click="Cancelar()">Cancel</v-btn>
                                    <v-btn v-if="editBS.activo == false && this.$store.state.usuario.rol === 'Administrador'" color="#43A047" dark style="margin-left: 12px;" @click="reactivar()">Activar</v-btn>
                                </v-col>                                          
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-dialog v-model="dialogd" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                     <span style="color:#0770c3;" class="title font-weight-bold">Dirección</span>
                    </v-card-title>
                    <v-card-text>
                        <span style="color:red;">* </span><span style="color: #000304d4;font-weight: 500;">Campos obligatorios</span>
                        <v-container>
                            <v-row style="display: flex;flex-direction: column;">
                                <v-col>
                                    <span style="color:red;font-size: 15px;">* </span><span style="color: #000304d4;font-weight: 500;">País:</span><v-select return-object item-text="text" item-value="value" v-model="pais" outlined dense :items="paises"></v-select>
                                </v-col>
                                <v-col>
                                    <span style="color:red;font-size: 15px;">* </span><span style="color: #000304d4;font-weight: 500;">Código Postal:</span><v-text-field v-model="cp" outlined dense @blur="cargar"></v-text-field>
                                </v-col>
                                <v-col>
                                    <span style="color:red;font-size: 15px;">* </span><span style="color: #000304d4;font-weight: 500;">Población:</span><v-select return-object item-text="text" item-value="value" v-model="CodigoPostal" :items="Codigos" v-on:change="completar" outlined dense></v-select>
                                </v-col>
                                <v-col>
                                    <span style="color:red;font-size: 15px;">* </span><span style="color: #000304d4;font-weight: 500;">Provincia/municipio:</span><v-text-field disabled v-model="municipio" outlined dense></v-text-field>
                                </v-col>
                                <v-col>
                                    <span style="color: #000304d4;font-weight: 500;">Dirección:</span><v-text-field v-model="direccion" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row style="flex-direction: row-reverse;">
                                <v-btn color="error darken-1" text @click="dialogd = false">Close</v-btn>
                                <v-btn color="blue darken-1" text @click="completardireccion()">Save</v-btn>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                </v-dialog>
            </v-row>
            <v-row justify="center">
                <v-dialog v-model="dialogr" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                     <span style="color:#0770c3;" class="title font-weight-bold">Dirección</span>
                    </v-card-title>
                    <v-card-text>
                        <span style="color:red;">* </span><span style="color: #000304d4;font-weight: 500;">Campos obligatorios</span>
                        <v-container>
                            <v-row style="display: flex;flex-direction: column;">
                                <v-col>
                                    <span style="color:red;font-size: 15px;">* </span><span style="color: #000304d4;font-weight: 500;">País:</span><v-select return-object item-text="text" item-value="value" v-model="paisr" outlined dense :items="paises"></v-select>
                                </v-col>
                                <v-col>
                                    <span style="color:red;font-size: 15px;">* </span><span style="color: #000304d4;font-weight: 500;">Código Postal:</span><v-text-field v-model="cpr" outlined dense @blur="cargar"></v-text-field>
                                </v-col>
                                <v-col>
                                    <span style="color:red;font-size: 15px;">* </span><span style="color: #000304d4;font-weight: 500;">Población:</span><v-select return-object item-text="text" item-value="value" v-model="CodigoPostalr" :items="Codigosr" v-on:change="completard" outlined dense></v-select>
                                </v-col>
                                <v-col>
                                    <span style="color:red;font-size: 15px;">* </span><span style="color: #000304d4;font-weight: 500;">Provincia/Municipio:</span><v-text-field disabled v-model="municipior" outlined dense></v-text-field>
                                </v-col>
                                <v-col>
                                    <span style="color: #000304d4;font-weight: 500;">Dirección:</span><v-text-field v-model="direccionr" outlined dense></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row style="flex-direction: row-reverse;">
                                <v-btn color="error darken-1" text @click="dialogr = false">Close</v-btn>
                                <v-btn color="blue darken-1" text @click="completardireccionr()">Save</v-btn>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                </v-dialog>
                <v-dialog
                    v-model="dialoview"
                    width="800px"
                    >
                    <v-card>
                        <div id="viewer">
                            <PDFJSViewer style="width: 100%;" :path="`${path}`" :fileName="`${namefile}`"/>
                        </div>
                    </v-card>
                </v-dialog>
            </v-row>
            <v-dialog
                v-model="dialodload"
                hide-overlay
                persistent
                width="300"
            >
                <v-card 
                color="primary"
                dark
                >
                    <v-card-text><br>
                        Please stand by
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>                    
                    </v-card-text>
                </v-card>
            </v-dialog>   
            <v-dialog  v-model="adModalAlert" max-width="400px">
                <v-card>
                    <v-card-title style="justify-content: center;color: red;" ><v-icon style="margin-right: 8px;color: red;font-size: 30px">error_outline </v-icon> {{ mensajealerta}}</v-card-title>
                    <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green darken-1" text="text" @click="adModalAlert=false">
                                Aceptar
                            </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogconfirmsolicitud" max-width="400px">
                <v-card-title>

                </v-card-title>
                <v-card-text>

                </v-card-text>
            </v-dialog>
            <v-dialog 
            max-width="400"
            v-model="alertpuertosbase">
                <v-card>
                    <v-toolbar
                    color="#e70f0f"
                    style="font-weight: 500;"
                    dark
                    >
                        SE CONSIDERA COMO PUERTOS BASE
                    </v-toolbar>
                    <v-card-text>
                        
                        <v-list>
                            <template v-for="(item, index) in portsbase">
                                <v-list-item
                                    :key="item.text"
                                >
                                    <v-list-item-action>
                                        <v-icon color="primary">location_on</v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider :key="index"></v-divider>
                            </template>
                        </v-list>
                        <span style="font-weight: 600;font-size: 16px;color: #cd0404;">Solo llegando a Manzanillo y Lázaro Cardenas.</span>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="#e70f0f"
                            @click="alertpuertosbase = false"
                        >
                            Aceptar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-snackbar
                v-model="snackbar"
                color="cyan darken-2" 
                top
                timeout="6000"
                >
                {{ mensaje }}
                <v-btn
                    dark
                    text
                    @click="snackbar = false"
                >
                    Close
                </v-btn>            
             </v-snackbar>
        </v-layout>
    </v-container>
</template>
<script>
import axios from 'axios'
import Vue from 'vue';
import PDFJSViewer from './PDFJSViewer'
//import smoothscroll from 'smoothscroll-polyfill'
import jsPDF from 'jspdf'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

export default {    
    name: 'app',
    components: {
        PDFJSViewer
    },
    data(){
        const hoy = new Date();
        const anio = hoy.getFullYear();
        const mes = String(hoy.getMonth() + 1).padStart(2, '0');
        const ultimoDia = new Date(anio, hoy.getMonth() + 1, 0).getDate();

        return{
            menuPeriodo: false,
            fechasFiltro: [`${anio}-${mes}-01`, `${anio}-${mes}-${ultimoDia}`],
            maxcaracteresremarks: [v => v.length <= 450 || 'Max 450 characters'],
            incseguromercancia:'NO',
            contizacioningles:'ESPAÑOL',
            modalidadtex:'',
            alertpuertosbase:false,
            confirmacionsolicitud:false,
            bodyCot:'',
            transbordo:'',
            loadigtable:true,
            nowDate: new Date().toISOString().slice(0,10),
            dateval: '',
            dialogcot:false,
            dialogconfirmsolicitud:false,
            MostrarTotal:0,
            dialodload:false,
            dialog6:false,
            loading:false,
            dialogcontactos:false,
            panel:[],
            nuevast:false,
            mensajealerta:'',
            adModalAlert:false,
            totalwn:0,
            volumenwn:0,
            viatext:'',
            principal:true,
            recoleccion:false,
            delivery:false,
            selectedItem3:'',
            headermk: [
                { text: 'Remarks', value: 'text', sortable: false ,align:'center'},
            ],
            contactosprospecto:[],
            contactoscot:'',
            cartap:'',
            date: '',
            menu2:false,
            editorcp:'',
            editorcotizacion:'',
            editor: DecoupledEditor,
            modalidadtext2:'',
            Movimientotext:'',
            productotext:'',
            origentext:'',
            destinotext:'',
            serviciotext:'',
            tttext:'',
            cuerpo:'Me permito enviarle nuestra cotización',
            modalidadtext:'',
            fechaHoy:'',
            e1: 1,
            steps: 3,
            dialoview:false,
            namefile: '', //change which pdf file loads
            path: 'SISTEMAOPTIMAGL/lib/pdfjs-2.5.207-dist/web/viewer.html',
            alert: false,
            namecot: '', //change which pdf file loads
            dialogd:false,
            dialogr:false,
            viewfood:false,
            daysview:false,
            Nportreceipt:'Place of receipt / Pick Up',
            maneuvers:false,
            titlec:'',          
            packageotro:false,
            dialogtaf:false,
            snackbar:false,
            mensaje:'',     
            editedbuysell:{
                idinstance:0,
                instance:'',
                idcharge:0,
                charge:'',
                idprovider:0,
                priovider:'',
                idmoneda:0,
                moneda:'',
                idtipocambio:1,
                rate:'',
                iva:'NA',
                idiva:0,
                idper:'Prepaid',
                per:'',
                payment:'shipment',
                quantity:'',
                idtamano:0,
                tamanoc:'',
                idcontenedor:0,
                tipoc:'',
                notas:'',
                prepaid:0,
                collect:0,
                total:0,
            },
            tamanoc:[],
            tipoc:[],
            headerContainer:[
                {text:'Quantity',value:'quantity',align:'center',sortable:false},
                {text:'Container Size',value:'containersiza',align:'center',sortable:false},
                {text:'Container Type',value:'containertype',align:'center',sortable:false}
            ],
            quantitycontainer:[],
            headersbs:[
                {text:'Opciones',value:'opciones',align:'center',sortable:false},
                {text:'Type',value:'buysell',align:'center',sortable:false},
                {text:'Provider',value:'provider',align:'center',sortable:false},
                {text:'Description',value:'charge',align:'center',sortable:false},
                {text:'Per',value:'per',align:'center',sortable:false},
                {text:'Currency',value:'moneda',align:'center',sortable:false},
                {text:'Prepaid',value:'prepaid',align:'center',sortable:false},
                {text:'Collect',value:'collect',align:'center',sortable:false},
                {text:'Notes',value:'notas',align:'center',sortable:false},
                {text:'Container Size',value:'tamanoc',align:'center',sortable:false},
                {text:'Container Type',value:'tipoc',align:'center',sortable:false},
                {text:'Rate exchange',value:'rate',align:'center',sortable:false},
                {text:'IVA',value:'iva',align:'center',sortable:false},
                {text:'TOTAL',value:'total',align:'center',sortable:false},
            ],
            on:'',
            attrs:'',
            btnhazardous:'',            
            basis:[],
            TipoOperacion:[],            
            inlands:[],
            idinland:'',
            modalidad:[],            
            optionsbutton:[],
            optionsbuttonagent:[],
            editBS:{
                idmodalidad:0,
                idbasis:0,
                idtipoOp:0,
                idinland:0,    
                clas:'',
                un:'',
                customs:true,
                vgm:false,                
                idcustumer:0,
                btcredit:[],
                creditDays:0,
                comodity:'',
                fahscode:'',
                btnhazardous:[],
                hazardous:'',
                idprovider:0,
                qt:'',
                idportreceipt:{text:'SELECT..',value:26},
                idportloading:{text:'SELECT..',value:26},
                idportdischarge:{text:'SELECT..',value:26},
                idportdelivery:{text:'SELECT..',value:26},
                freedaysorigin:'',
                freedaysdest:'',
                idvessel:0,
                voyage:'',              
                fechaeta:null,
                fechaetd:null,
                remarks:'',
                idagent:0,
                foodgrade:'',
                dentrofbl:0,
            },            
            inlandop:'',
            credit:false,
            harz:false,
            indl:false,
            headers: [
                { text: 'Opciones', value: 'opciones', sortable: false,align:'center' },        
                { text: 'Quantity', value: 'quantity',align:'center',sortable:false },
                { text: 'Size', value: 'size',align:'center' ,sortable:false},
                { text: 'Type', value: 'type',align:'center' ,sortable:false},
                { text: 'Weight', value: 'nweight',align:'center' ,sortable:false},
                { text: 'Total Weight', value: 'totalweight',align:'center' ,sortable:false},
            ],
            headersinfc: [    
                { text: 'Quantity', value: 'quantity',align:'center',sortable:false },
                { text: 'Size', value: 'size',align:'center' ,sortable:false},
                { text: 'Type', value: 'type',align:'center' ,sortable:false},
                { text: 'Weight', value: 'nweight',align:'center' ,sortable:false},
                { text: 'Total Weight', value: 'totalweight',align:'center' ,sortable:false},
            ],
            containers:[],
            editcontainer:{
                quantity:'',
                peso:{text:'Kilo',value:1},             
                size:'',
                idunidadmasa:'',
                idsize:0,
                type:'',
                idtype:0,
                weight:'',
                nweight:'',
                remarks:'',
                idcontainer:0,
            },
            editpackage:{
                longitud:{text:'Metro',value:1},
                peso:{text:'Kilo',value:1},
                stackable:0,
                nstackable:'',
                weight:'',
                nweight:'',
                high:'',
                width:'',
                large:'',
                nhigh:'',
                nwidth:'',
                nlarge:'',
                idpackage:0,
                quantity:'',
                otropackage:'',
                package:'',
                idlongitud:0,
                Notes:''
            },
            headerpackage:[
                {text:'Options',value:'opciones',align:'center',sortable:false},
                {text:'Quantity',value:'quantity',align:'center',sortable:false},
                {text:'Package',value:'package',align:'center',sortable:false},
                {text:'Lenth',value:'nlarge',align:'center',sortable:false},
                {text:'Width',value:'nwidth',align:'center',sortable:false},
                {text:'Height',value:'nhigh',align:'center',sortable:false},
                {text:'Weight',value:'nweight',align:'center',sortable:false},
                {text:'Volumetric weight',value:'volumetricweight',align:'center',sortable:false},
                {text:'Actual weight',value:'actualweight',align:'center',sortable:false},
                {text:'Stackable',value:'nstackable',align:'center',sortable:false},
            ],
            headerpackageinf:[
                {text:'Quantity',value:'quantity',align:'center',sortable:false},
                {text:'Package',value:'package',align:'center',sortable:false},
                {text:'Lenth',value:'nlarge',align:'center',sortable:false},
                {text:'Width',value:'nwidth',align:'center',sortable:false},
                {text:'Height',value:'nhigh',align:'center',sortable:false},
                {text:'Weight',value:'nweight',align:'center',sortable:false},
                {text:'Volumetric weight',value:'volumetricweight',align:'center',sortable:false},
                {text:'Actual weight',value:'actualweight',align:'center',sortable:false},
                {text:'Remarks',value:'notes',align:'center',sortable:false},
                {text:'Stackable',value:'nstackable',align:'center',sortable:false},
            ],
            addpackages:[],
            editedIndexpack:-1,
            editedIndexunit:-1,
            text:'',
            CONTAINER:false,
            PACKAGES:false,
            UNITS:false,
            transferftl:'',
            ftl:false,
            ltl:false,
            titleprov:'PICK UP',
            Nportloading:'POL',
            Nportdischarge:'POD',
            Nportdelivery:'FINAL DESTINATION',
            activevgm:false,
            activecust:false,
            inland:false,
            ftldate:true,
            lclview:false,
            aereo:false,
            optionsbutton:[],
            ports:[],
            portsbase:[],          
            search:'',
            HeaderBuySellLista:[
                {text:'OPCIONES',value:'opciones',align:'center', sortable: false},
                {text:'TARIFF N°',value:'ncotizacion',align:'center', sortable: false},
                {text:'EXECUTIVE',value:'nusuario',align:'center', sortable: false}, 
                {text:'CUSTOMER NAME',value:'ncustumer',align:'center', sortable: false},
                {text:'OPERATION TYPE',value:'tipoOp',align:'center', sortable: false},
                {text:'BASIS',value:'basis',align:'center', sortable: false},
                {text:'PLACE OF RECEIPT',value:'npuertoreceipt',align:'center', sortable: false},
                {text:'POL',value:'npuertoloading',align:'center', sortable: false},
                {text:'POD',value:'npuertodischarge',align:'center', sortable: false},
                {text:'FINAL DESTINATION',value:'npuertodelivery',align:'center', sortable: false},
                {text:'CRATE',value:'nfechacreate',align:'center', sortable: false},
                {text:'RESPONSE DAY',value:'nfecharespuesta',align:'center', sortable: false},
                {text:'QUOTE STATUS',value:'estadoCotizacion',align:'center', sortable: false}, 
                {text:'STATUS',value:'status',align:'center', sortable: false},
            ],
            impaal:false,
            tarifas:[],
            editTarifa:{
                nombreprov:'',
                pol:'',
                pod:'',
                pod:'',
                tt:'',
                serviciodirecto:'',
                abreviatura:'',
                dC20:'',
                hC40:'',
                hcF40:'',
                diaslibres_origen:'',
                diaslibre_destino:'',
                sello:'',
                imocargo:'',
                acondicionamiento:'',
            },
            headerst: [                
                { text: 'Opciones', value: 'opciones', sortable: false,align:'center' },
                { text: 'Proveedor', value: 'nombreprov',align:'center' },
                { text: 'POL', value: 'pol',align:'center' },
                { text: 'POD', value: 'pod',align:'center' },              
                { text: 'Moneda', value: 'abreviatura', sortable: false,align:'center'  },
                { text: '20DC', value: 'dC20', sortable: false,align:'center'  },
                { text: '20HC', value: 'hC20', sortable: false,align:'center'  },
                { text: '40DC', value: 'dC40', sortable: false,align:'center'  },
                { text: '40HC', value: 'hC40', sortable: false,align:'center'  },              
                { text: '40DC REEFER', value: 'dcF40', sortable: false,align:'center'  },
                { text: '40HC REEFER', value: 'hcF40', sortable: false,align:'center'  },
            ],
            verNuevo:false,
            editedIndexbtarifa:-1,
            custody:false,
            editedIndexcon:-1,
            selectpackage:[],
            customer:[],
            BuySellLista:[],
            Longitud:[],
            Masa:[],
            dialog3:false,
            paises:[
                {text:'Andorra',value:"AD"},
                {text:'Argentina',value:"AR"},
                {text:'Australia',value:"AU"},
                {text:'Austria',value:"AT"},
                {text:'Belgium',value:"BE"},
                {text:'Bolivia',value:"BO"},
                {text:'Brazil',value:"BR"},
                {text:'Bulgaria',value:"BG"},
                {text:'Canada',value:"CA"},
                {text:'Chile',value:"CL"},
                {text:'China',value:"CN"},
                {text:'Colombia',value:"CO"},
                {text:'Costa Rica',value:"CR"},
                {text:'Cuba',value:"CU"},
                {text:'Cyprus',value:"CY"},
                {text:'Czech Republic',value:"CZ"},
                {text:'Denmark',value:"DK"},
                {text:'Dominican Republic',value:"DO"},
                {text:'Ecuador',value:"EC"},
                {text:'El Salvador',value:"SV"},
                {text:'Equatorial Guinea',value:"GQ"},
                {text:'Estonia',value:"EE"},
                {text:'Finland',value:"FI"},
                {text:'France',value:"FR"},
                {text:'France, Metropolitan',value:"FX"},
                {text:'Germany',value:"DE"},
                {text:'Gibraltar',value:"GI"},
                {text:'Greece',value:"GR"},
                {text:'Greenland',value:"GL"},
                {text:'Guatemala',value:"GT"},
                {text:'Guinea',value:"GN"},
                {text:'Guinea-bissau',value:"GW"},
                {text:'Guyana',value:"GY"},
                {text:'Haiti',value:"HT"},
                {text:'Honduras',value:"HN"},
                {text:'Hong Kong',value:"HK"},
                {text:'Hungary',value:"HU"},
                {text:'Iceland',value:"IS"},
                {text:'Ireland',value:"IE"},
                {text:'Italy',value:"IT"},
                {text:'Jamaica',value:"JM"},
                {text:'Japan',value:"JP"},
                {text:'Latvia',value:"LV"},
                {text:'Lebanon',value:"LB"},
                {text:'Libyan Arab Jamahiriya',value:"LY"},
                {text:'Liechtenstein',value:"LI"},
                {text:'Lithuania',value:"LT"},
                {text:'Luxembourg',value:"LU"},
                {text:'Macedonia',value:"MK"},
                {text:'Madagascar',value:"MG"},
                {text:'Maldives',value:"MV"},
                {text:'Mali',value:"ML"},
                {text:'Malta',value:"MT"},
                {text:'Marshall Islands',value:"MH"},
                {text:'Martinique',value:"MQ"},
                {text:'Mauritania',value:"MR"},
                {text:'Mauritius',value:"MU"},
                {text:'Mexico',value:"MX"},
                {text:'Monaco',value:"MC"},
                {text:'Montserrat',value:"MS"},
                {text:'Morocco',value:"MA"},
                {text:'Mozambique',value:"MZ"},
                {text:'Myanmar',value:"MM"},
                {text:'Namibia',value:"NA"},
                {text:'Nepal',value:"NP"},
                {text:'Netherlands',value:"NL"},
                {text:'Netherlands Antilles',value:"AN"},
                {text:'New Caledonia',value:"NC"},
                {text:'New Zealand',value:"NZ"},
                {text:'Nicaragua',value:"NI"},
                {text:'Niger',value:"NE"},
                {text:'Nigeria',value:"NG"},
                {text:'Northern Mariana Islands',value:"MP"},
                {text:'Norway',value:"NO"},
                {text:'Pakistan',value:"PK"},
                {text:'Panama',value:"PA"},
                {text:'Paraguay',value:"PY"},
                {text:'Peru',value:"PE"},
                {text:'Philippines',value:"PH"},
                {text:'Poland',value:"PL"},
                {text:'Portugal',value:"PT"},
                {text:'Puerto Rico',value:"PR"},
                {text:'Romania',value:"RO"},
                {text:'Russian',value:"RU"},
                {text:'Saint Lucia',value:"LC"},
                {text:'Saint Vincent and the Grenadines',value:"VC"},
                {text:'Samoa',value:"WS"},
                {text:'San Marino',value:"SM"},
                {text:'Saudi Arabia',value:"SA"},
                {text:'Seychelles',value:"SC"},
                {text:'Sierra Leone',value:"SL"},
                {text:'Singapore',value:"SG"},
                {text:'Slovakia (Slovak Republic)',value:"SK"},
                {text:'Slovenia',value:"SI"},
                {text:'Solomon Islands',value:"SB"},
                {text:'Somalia',value:"SO"},
                {text:'South Africa',value:"ZA"},
                {text:'España',value:"ES"},
                {text:'Sri Lanka',value:"LK"},
                {text:'St. Pierre and Miquelon',value:"PM"},
                {text:'Swaziland',value:"SZ"},
                {text:'Sweden',value:"SE"},
                {text:'Switzerland',value:"CH"},
                {text:'Taiwan',value:"TW"},
                {text:'Thailand',value:"TH"},
                {text:'Tunisia',value:"TN"},
                {text:'Turkey',value:"TR"},
                {text:'Ukraine',value:"UA"},
                {text:'United Kingdom',value:"GB"},
                {text:'United States',value:"US"},
                {text:'Uruguay',value:"UY"},
                {text:'Vatican City State (Holy See)',value:"VA"},
                {text:'Venezuela',value:"VE"},
                {text:'Virgin Islands (British)',value:"VG"},
                {text:'Virgin Islands (U.S.)',value:"VI"},
                {text:'Yugoslavia',value:"YU"},
            ],
            pais:'',
            cp:'',
            CodigoPostal:'',
            cop:[],
            copr:[],
            Codigos:[],
            Codigosr:[],
            addressreceipt:'',
            direccion:'',
            municipio:'',
            estado:'',
            addressdelivery:'',
            direccionr:'',
            municipior:'',
            estador:'',
            paisr:'',
            cpr:'',
            CodigoPostalr:'',
            observaciones:'',
            /*files*/
            files:null,
            containerFile:[],
            headersC: [
                { text: 'Opciones', value: 'opciones', sortable: false,align:'center',width:100 },
                { text: 'Class', value: 'class1', sortable: false,align:'center',width:150 },
                { text: 'Un', value: 'un', sortable: false,align:'center',width:150 },
                { text: 'File', value: 'file', sortable: false,align:'center',width:150},
            ],
            headersCinf: [
                { text: 'Class', value: 'class1', sortable: false,align:'center',width:150 },
                { text: 'Un', value: 'un', sortable: false,align:'center',width:150 },
                { text: 'File', value: 'file', sortable: false,align:'center',width:150},
            ],
            bl:[
                {text:'Dentro de BL',value:1},
                {text:'Fuera de BL',value:2},
                {text:'Dentro y Fuera de BL',value:3}
            ],
            preciocostopor:[],
            editcontainerFile:{
                class1:'',
                un:'',
                file:'',
                fileurl:'',
                activo:false,
            },
            editedIndexF:-1,
            selectedFile:null,
            selectedItem:[],
            RemarksCotizacion:[],
            remarkstextc:[],
            remarklist:'',
            remarksc:' ',
            remarksview:false,
            aditionalfees:'',
            monedas:[],
            Costos:[],
            OpcionCostos:[],
            concepto:'',
            costo:'',
            moneda:'',
            urllik:'',
            remk:'',
            //dateval:'',
            país:'',
            searcho:'',
            contactoscp:'',
            cpasunto:'',
            /*****************CHARGE**********************/
            chargeconcepto:'',
            chargecostopor:'',
            chargecantidad:'',
            chargecostounitario:0,
            chargemoneda:'',
            chargeiva:0,
            subtotalusd:0,
            ivausd:0,
            totalusd:0,
            nsubtotalusd:0,
            nivausd:0,
            ntotalusd:0,
            activousd:false,
            subtotalmxn:0,
            ivamxn:0,
            totalmxn:0,
            nsubtotalmxn:0,
            nnsubtotalmxn:0,
            nivamxn:0,
            nnivamxn:0,
            nntotalmxn:0,
            activomxn:false,
            Observations:'',
            tarifapickup:[],
            tarifadeliver:[],
            selectedItempickup:[],
            selectedItemdelivery:[],
            /***********************************/
            recoleccionview:false,
            principalview:false,
            deliveryview:false,
            principalselect:[],
            pickupselect:[],
            deliveryselect:[],
            principalt:false,
            recolecciont:false,
            deliveryt:false,
            adicionalfees:[],
            prospectossn:[],
            editedIndexCosto:-1,
            nombrec:'',
            activarc:false,
            contactospresente:[],
            numidscotizacion:0,
            folio:'',
            editedIndexScot:-1,
            editedIndex:-1,
            /***********************/
            editcontact:{
                    idcontacto:'',
                    nombre:'',
                    puesto:'',
                    telefono:'',
                    celular:'',
                    correo:'',            
            },
            contactos:[],
            headersc: [
                { text: 'OPCIONES', value: 'opciones', sortable: false },        
                { text: 'NOMBRE', value: 'nombre' },
                { text: 'PUESTO', value: 'puesto' },
                { text: 'TELÉFONO', value: 'telefono' },
                { text: 'CELULAR', value: 'celular' },
                { text: 'CORREO', value: 'correo', sortable: false },
                { text: 'ESTADO', value: 'activo' },
            ],
            cotguardada:false,
            generarcot:false,
            tarifasseleccionadas:[],
            vigenciat:null,
            editedIndexRemarks:-1,
            title:'',
            opcioncosto:0,
            valida:0,
            validaMensaje:[],
            vigenciatarifa:'',
            fechav:'',
            /**************************/
            noperacion:'',
            nmodalidad:'',
            ntipoembarque:'',
            nrecoleccion:'',
            npickup:'',
            ndelivery:'',
            npol:'',
            npod:'',
            nentrega:'',
            nfoodgrade:'',
            nmercancia:'',
            ndespacho:'',
            valorcarga:'',
            nobservaciones:'',
            ncustoms:'NO',
            nvgm:'NO',
            ninsurance:'NO',
            ncustody:'NO',
            nmaneuvers:'NO',
            ninland:'',
            nagente:'',
            nlocal:'',
            customs:[],
            viewadicional:false,
            viewcustom:false,
            idcotizacion:0,
            CotizacionesDatos:[],
            lclviewremarks: false,
            notificaAgente:false,
            notificaPricing:false,
            notificaLocal:false,
            disabledIva:false,
            remarkenabled:0,
            /*************/
            idejecutivo:0,
            ejecutivos:[],
        }        
    },
    watch: {
      steps (val) {
        if (this.e1 > val) {
          this.e1 = val
        }
      },
    },
    computed: {
        computedDateFormatrecei () { 
            return this.formatDate(this.dateval)
        },
        textoPeriodo() {
            if (!this.fechasFiltro || this.fechasFiltro.length === 0) return 'Todo el histórico';
            
            // Ordenamos las fechas por si el usuario eligió primero la final y luego la inicial
            let fechasOrdenadas = [...this.fechasFiltro].sort(); 
            
            const formato = (fechaStr) => {
                const [y, m, d] = fechaStr.split('-');
                return `${d}/${m}/${y}`;
            };

            if (fechasOrdenadas.length === 1) return formato(fechasOrdenadas[0]);
            return `${formato(fechasOrdenadas[0])} - ${formato(fechasOrdenadas[1])}`;
        },

        // 2. Filtra la data basándose en el RANGO elegido
        datosFiltrados() {
            if (!this.BuySellLista) return [];
            if (!this.fechasFiltro || this.fechasFiltro.length === 0) return this.BuySellLista;

            let fechasOrdenadas = [...this.fechasFiltro].sort();
            // Convertimos a Date (añadiendo horas para abarcar el día completo)
            let inicio = new Date(fechasOrdenadas[0] + 'T00:00:00');
            let fin = fechasOrdenadas.length === 2 
                ? new Date(fechasOrdenadas[1] + 'T23:59:59') 
                : new Date(fechasOrdenadas[0] + 'T23:59:59');

            return this.BuySellLista.filter(item => {
                if (!item.fechacreate) return false;
                let fechaRegistro = new Date(item.fechacreate);
                return fechaRegistro >= inicio && fechaRegistro <= fin;
            });
        },
        totalSolicitudes() {
        return this.datosFiltrados.length;
    },
    pendientesCotizar() {
        return this.datosFiltrados.filter(item => !item.cotizaciones || item.cotizaciones.length === 0).length;
    },
    cotizacionesEnviadas() {
        return this.datosFiltrados.filter(item => item.cotizaciones && item.cotizaciones.length > 0).length;
    },
    totalBsGeneradas() {
        if(!this.datosFiltrados) return 0;
        let count = 0;
        this.datosFiltrados.forEach(item => {
            if (item.cotizaciones && item.cotizaciones.length > 0) {
                let asignadas = item.cotizaciones.filter(cot => 
                    cot.asignada === true || 
                    cot.asignada === 1 || 
                    String(cot.asignada).toLowerCase() === 'true'
                ).length;
                count += asignadas;
            }
        });
        return count;
    }
    },
    async created(){
        this.select();
        await this.listar();
        this.fechahoy();
        this.cargarremarks();
    },
    methods:{
        Mostrartarifaprincipal(){
            if(this.selectedItem.length >= 1){
                this.vigenciatarifa = '';
                this.principalselect = [];
                //var modalidad;
                var primero = false;
                /*if(this.editBS.basis == 'FTL' || this.editBS.basis == 'LTL'){
                    modalidad = 'Terrestre';
                }
                if(this.editBS.basis == 'FCL' || this.editBS.basis == 'LCL'){
                    modalidad = 'Maritima';
                }
                if(this.editBS.basis == 'AEREO'){
                    modalidad = 'AEREA';
                }
                this.modalidadtext2 = modalidad;
                this.Movimientotext = this.editBS.tipoOp;
                this.origentext = this.editBS.npuertoloading;
                this.destinotext = this.editBS.npuertodischarge;
                this.productotext = this.editBS.comodity;*/
                var i;
                var j;
                for(i = 0; i <= this.tarifas.length; i++){
                    for(j = 0; j <= this.selectedItem.length; j++){
                        if(i == this.selectedItem[j]){
                            var f1 = new Date(this.tarifas[i].fechavigencia)
                            var f2 = new Date(this.dateval)
                            if(primero == false){
                                this.dateval = this.tarifas[i].fechavigencia;
                                this.vigenciat = this.tarifas[i].vigencia;
                                primero = true; 
                            }
                            if(f1 < f2){
                                this.dateval = this.tarifas[i].fechavigencia;
                                this.vigenciat = this.tarifas[i].vigencia;
                            }else{
                                this.vigenciatarifa = this.tarifas[i].fechavigencia;
                            }
                            this.principalselect.push({
                                num:i,
                                descripcion:this.tarifas[i].descripcion,
                                observaciones:this.tarifas[i].observaciones,
                                size:this.tarifas[i].size,
                                type:this.tarifas[i].type,
                                nrate:this.tarifas[i].nrate,
                                fechavigencia:this.tarifas[i].fechavigencia,
                                tarifaAd:this.tarifas[i].tarifaAd,
                                quantity:this.tarifas[i].quantity,
                                freedasydestination:this.tarifas[i].freedasydestination,
                                freedaysorigin:this.tarifas[i].freedaysorigin,
                                rate:this.tarifas[i].rate,
                                nidprovider:this.tarifas[i].nidprovider,
                            });
                            this.tarifasseleccionadas.push({
                                num:i,
                                idtarifa:this.tarifas[i].idlistarifarate,
                                tarifaprincipal:true,
                                pickup:false,
                                delivery:false,
                                activo:true
                            });
                        }
                    }
                }
                if(this.editBS.idbasis == 3 || this.editBS.idbasis == 4){
                    this.pickupselect = this.tarifapickup[this.selectedItempickup];
                    this.deliveryselect = this.tarifadeliver[this.selectedItemdelivery];
                    this.modalidadtext2 = this.modalidadtex + ' ' + this.editBS.basis;
                    this.Movimientotext = this.editBS.tipoOp;
                    this.origentext = this.editBS.npuertoreceipt;
                    this.destinotext = this.editBS.npuertodelivery;
                    this.productotext = this.editBS.comodity;
                    this.principalt = true;
                    this.e1 = 2;
                }else{
                    this.principal = false;
                    this.principalt = true;
                    if(this.recoleccionview == true){
                        this.recoleccion = true;
                    }else{
                        if(this.deliveryview == true){
                            this.delivery = true;
                        }
                    }
                    if(this.deliveryview == false && this.recoleccionview == false){
                        this.e1 = 2;
                    }
                }          
            }else{
                window.alert('Selecciona una tarifa');
            }
        },
        Mostrartarifarecoleccion(){
            var i;
            var j;
            this.pickupselect = [];
            if(this.selectedItempickup.length >= 1){
                for(i = 0; i <= this.tarifapickup.length; i++){
                    for(j = 0; j <= this.selectedItempickup.length; j++){
                        if(i == this.selectedItempickup[j]){
                            var f1 = new Date(this.tarifapickup[i].fechavigencia)
                            var f2 = new Date(this.dateval)
                            if(f1 < f2){
                                this.dateval = this.tarifapickup[i].fechavigencia;
                                this.vigenciat = this.tarifapickup[i].vigencia;
                            }else{
                                this.vigenciatarifa = this.tarifapickup[i].fechavigencia;
                            }
                            this.pickupselect.push({
                                num:i,
                                descripcion:this.tarifapickup[i].descripcion,
                                observaciones:this.tarifapickup[i].observaciones,
                                size:this.tarifapickup[i].size,
                                type:this.tarifapickup[i].type,
                                nrate:this.tarifapickup[i].nrate,
                                fechavigencia:this.tarifapickup[i].fechavigencia,
                                tarifaAd:this.tarifapickup[i].tarifaAd,
                                quantity:this.tarifapickup[i].quantity,
                                freedasydestination:this.tarifapickup[i].freedasydestination,
                                freedaysorigin:this.tarifapickup[i].freedaysorigin,
                                rate:this.tarifapickup[i].rate,
                                nidprovider:this.tarifapickup[i].nidprovider,
                            });
                            this.tarifasseleccionadas.push({
                                num:i,
                                idtarifa:this.tarifapickup[i].idlistarifarate,
                                tarifaprincipal:false,
                                pickup:true,
                                delivery:false,
                                activo:true
                            });
                        }
                    }
                }
                this.recoleccion = false;
                this.recolecciont = true;
                if(this.deliveryview == true){
                    this.delivery = true;
                }else{
                    this.e1 = 2;
                }
                
            }else{
                window.alert('Selecciona una tarifa');
            }
        },
        Mostrartarifadelivery(){
            this.deliveryselect = [];
            var i;
            var j;
            if(this.selectedItemdelivery.length >= 1){
                for(i = 0; i <= this.tarifadeliver.length; i++){
                    for(j = 0; j <= this.selectedItemdelivery.length; j++){
                        if(i == this.selectedItemdelivery[j]){
                            var f1 = new Date(this.tarifadeliver[i].fechavigencia)
                            var f2 = new Date(this.dateval)
                            if(f1 < f2){
                                this.dateval = this.tarifadeliver[i].fechavigencia;
                                this.vigenciat = this.tarifadeliver[i].vigencia;
                            }else{
                                this.vigenciatarifa = this.tarifadeliver[i].fechavigencia;
                            }
                            this.deliveryselect.push({
                                num:i,
                                descripcion:this.tarifadeliver[i].descripcion,
                                observaciones:this.tarifadeliver[i].observaciones,
                                size:this.tarifadeliver[i].size,
                                type:this.tarifadeliver[i].type,
                                nrate:this.tarifadeliver[i].nrate,
                                fechavigencia:this.tarifadeliver[i].fechavigencia,
                                tarifaAd:this.tarifadeliver[i].tarifaAd,
                                quantity:this.tarifadeliver[i].quantity,
                                rate:this.tarifadeliver[i].rate,
                                freedasydestination:this.tarifadeliver[i].freedasydestination,
                                freedaysorigin:this.tarifadeliver[i].freedaysorigin,
                                nidprovider:this.tarifadeliver[i].nidprovider,
                            });
                            this.tarifasseleccionadas.push({
                                num:i,
                                idtarifa:this.tarifadeliver[i].idlistarifarate,
                                tarifaprincipal:false,
                                pickup:false,
                                delivery:true,
                                activo:true
                            });
                        }
                    }
                }
                this.delivery = true;
                this.e1 = 2;
                this.deliveryt = true;
            }else{
                window.alert('Selecciona una tarifa');
            }
        },
        listarContacto(id){
            var ContactosP = [];
            this.contactos = [];
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.contactosprospecto = [];
            me.contactospresente = [];
            axios.get('api/Contactos/ListarContacto/' + id,configuracion).then(function(response){            
            //axios.get('api/Contactos/Listar/',configuracion).then(function(response){            
            ContactosP=response.data;
            me.contactos = response.data;
            ContactosP.map(function(x){
              me.contactosprospecto.push({text:x.nombre+" <" + x.correo+ ">",value:x.idcontacto,correo:x.correo})
              me.contactospresente.push({text:x.nombre,value:x.idcontacto})
            });
            }).catch(function(error){
                console.log(error);
            });
        },
        onReady( editor )  {
          // Insert the toolbar before the editable area.
              editor.ui.getEditableElement().parentElement.insertBefore(
              editor.ui.view.toolbar.element,
              editor.ui.getEditableElement()
          );
        },
        agregarremarks(){
                var rtext = '';
                var idremarktext = '';
                var rvalue = 0;

                if(this.editedIndexRemarks > -1){
                    if(this.remarklist.text == undefined){
                        if(this.remarkstextc[this.editedIndexRemarks].idremark == 16){
                            rtext = this.remarksc;
                        }else{
                            rtext = this.remarksc + " " + this.remarkstextc[this.editedIndexRemarks].idremarktext;
                        }
                        idremarktext = this.remarkstextc[this.editedIndexRemarks].idremarktext
                        rvalue = this.remarkstextc[this.editedIndexRemarks].idremark;
                    }else{
                        if(this.remarklist.value == 16){
                            rtext = this.remarksc;
                        }else{
                            rtext = this.remarksc + " " + this.remarklist.text;
                        }
                        idremarktext = this.remarklist.text;
                        rvalue = this.remarklist.value;
                    } 
                    Object.assign(this.remarkstextc[this.editedIndexRemarks],{
                        text: rtext,
                        idremarktext:idremarktext,
                        observacion:this.remarksc,
                        idremark:rvalue,
                        activo:true
                    });
                    this.editedIndexRemarks = -1;
                }else{
                    if(this.remarksc != '' || this.remarklist.text != undefined){
                        if(this.remarklist.text != undefined){
                            rtext =  this.remarklist.text;
                            rvalue = this.remarklist.value;
                        }
                        this.remarkstextc.push({
                            text: this.remarksc + " " + rtext,
                            idremarktext:rtext,
                            observacion: this.remarksc,
                            idremark:rvalue,
                            activo:true
                        });
                        
                    }else{
                        window.alert('Agrgar un Comentario')
                    }
                }
            this.remarksc = ' ';
            this.remarklist = '';
            this.remarksview = true;
        },
        editRemarks(item){
            this.editedIndexRemarks = this.remarkstextc.indexOf(item)
            this.remarklist = item.idremark;
            this.remarksc = item.observacion;
        },
        deleteRemarks(item){
            const index = this.remarkstextc.indexOf(item)
            var resp = confirm('Are you sure you want to delete this remark?');
            if(resp == true){
                this.remarkstextc[index].activo = false;
            }
        },
        agregarcosto(){
            var niva = 0;
            var subtotal = 0;
            var total = 0;
            if(this.chargecostopor.value == undefined){
                if(this.chargecostopor == 1 || this.chargecostopor == 3 || this.chargecostopor == 4){
                    subtotal = this.chargecostounitario * this.chargecantidad;
                }
                if(this.chargecostopor == 2 || this.chargecostopor == 5){
                    subtotal = Number(this.chargecostounitario);
                }
            }else{
                if(this.chargecostopor.value == 1 || this.chargecostopor.value == 3 || this.chargecostopor.value == 4){ 
                    subtotal = this.chargecostounitario * this.chargecantidad;
                }
                if(this.chargecostopor.value == 2 || this.chargecostopor.value == 5){
                    subtotal = Number(this.chargecostounitario);
                    this.chargecantidad = 1;
                }
            }            
            var iva = false;
            if(this.chargeiva == 1){
                niva = subtotal * 0.16;
                iva = 1;
            }else{
                iva = false;
            }
            total = (niva + subtotal);
            if(this.chargeconcepto != '' || this.chargecantidad != ''){
                if(this.editedIndexCosto > -1){
                    var chargecostopor = '';
                    var idcostopor = '';
                    var moneda = '';
                    var idmoneda = '';
                    if(this.chargecostopor.text == undefined){
                        chargecostopor = this.Costos[this.editedIndexCosto].costopor;    
                        idcostopor =this.Costos[this.editedIndexCosto].idcostopor;    
                    }else{
                        chargecostopor =this.chargecostopor.text;
                        idcostopor = this.chargecostopor.value;
                    }
                    if(this.chargemoneda.text == undefined){
                        moneda = this.Costos[this.editedIndexCosto].moneda;
                        idmoneda = this.Costos[this.editedIndexCosto].idmoneda;
                    }else{
                        moneda = this.chargemoneda.text;
                        idmoneda = this.chargemoneda.value;
                    }
                    if(this.chargemoneda == 1 || this.chargemoneda.text == 'USD'){
                        this.subtotalusd = this.subtotalusd + subtotal;
                        this.ivausd = this.ivausd + niva;
                        this.totalusd = this.totalusd + total;
                        this.nsubtotalusd = this.addCommas(parseFloat(this.subtotalusd).toFixed(2));
                        this.nivausd = this.addCommas(parseFloat(this.ivausd).toFixed(2))
                        this.ntotalusd = this.addCommas(parseFloat(this.totalusd).toFixed(2))
                        this.activousd = true;
                    }
                    if(this.chargemoneda == 2 || this.chargemoneda.text == 'MXN'){
                        this.subtotalmxn = this.subtotalmxn + subtotal;
                        this.ivamxn = this.ivamxn + niva;
                        this.totalmxn = this.totalmxn + total;
                        this.nsubtotalmxn = this.addCommas(parseFloat(this.subtotalmxn).toFixed(2));
                        this.nivamxn = this.addCommas(parseFloat(this.ivamxn).toFixed(2));
                        this.ntotalmxn = this.addCommas(parseFloat(this.totalmxn).toFixed(2));
                        this.activomxn = true;
                    }
                    Object.assign(this.Costos[this.editedIndexCosto],{
                        idcostopor:idcostopor,
                        concepto: this.chargeconcepto,
                        costopor:chargecostopor,
                        cantidad:this.chargecantidad,
                        costounitario:Number(this.chargecostounitario),
                        ncostounitario:this.addCommas(this.chargecostounitario),
                        idmoneda:idmoneda,
                        moneda:moneda,  
                        iva:iva,
                        ivas:this.chargeiva,
                        niva:niva,
                        nniva:this.addCommas(parseFloat(niva).toFixed(2)),
                        subtotal:subtotal,
                        nsubtotal:this.addCommas(parseFloat(subtotal).toFixed(2)),
                        total:total,
                        ntotal:this.addCommas(parseFloat(total).toFixed(2)),
                        activo:true
                    });
                    this.editedIndexCosto = -1;
                    this.limpiarcostos(); 
                }else{
                    if(this.chargemoneda.text == 'USD'){
                        this.subtotalusd = this.subtotalusd + subtotal;
                        this.ivausd = this.ivausd + niva;
                        this.totalusd = this.totalusd + total;
                        this.nsubtotalusd = this.addCommas(parseFloat(this.subtotalusd).toFixed(2));
                        this.nivausd = this.addCommas(parseFloat(this.ivausd).toFixed(2))
                        this.ntotalusd = this.addCommas(parseFloat(this.totalusd).toFixed(2))
                        this.activousd = true;
                    }
                    if(this.chargemoneda.text == 'MXN'){
                        this.subtotalmxn = this.subtotalmxn + subtotal;
                        this.ivamxn = this.ivamxn + niva;
                        this.totalmxn = this.totalmxn + total;
                        this.nsubtotalmxn = this.addCommas(parseFloat(this.subtotalmxn).toFixed(2));
                        this.nivamxn = this.addCommas(parseFloat(this.ivamxn).toFixed(2));
                        this.ntotalmxn = this.addCommas(parseFloat(this.totalmxn).toFixed(2));
                        this.activomxn = true;
                    }
                    if(this.chargecostopor.value != undefined){
                        this.Costos.push({ 
                            idcostopor:this.chargecostopor.value,
                            concepto: this.chargeconcepto,
                            costopor:this.chargecostopor.text,
                            cantidad:this.chargecantidad,
                            costounitario:this.chargecostounitario,
                            ncostounitario:this.addCommas(this.chargecostounitario),
                            idmoneda:this.chargemoneda.value,
                            moneda:this.chargemoneda.text,  
                            iva:iva,
                            ivas:this.chargeiva,
                            niva:niva,
                            nniva:this.addCommas(parseFloat(niva).toFixed(2)),
                            subtotal:subtotal,
                            nsubtotal:this.addCommas(parseFloat(subtotal).toFixed(2)),
                            total:total,
                            ntotal:this.addCommas(parseFloat(total).toFixed(2)),
                            activo:true
                        });
                        this.limpiarcostos();
                    } else{
                        window.alert('Selecciona una opcion de costo');        
                    }
                }
            }else{
                window.alert('Favor de agregar un concepto o cantidad');
            }
        },
        limpiarcostos(){
            this.chargeconcepto = '';
            this.chargecostopor = '';
            this.chargecantidad = '';
            this.chargecostounitario = 0;
            this.chargemoneda = '';
            this.chargeiva = '';
            this.editedIndexCosto = -1;
        },
        editItemcostos(item){
            if(item.idmoneda == 2){
                this.subtotalmxn = Number(this.subtotalmxn) - Number(item.subtotal);
                this.ivamxn = Number(this.ivamxn) - Number(item.niva);
                this.totalmxn = Number(this.totalmxn) - Number(item.total);
                this.nsubtotalmxn = this.addCommas(parseFloat(this.subtotalmxn).toFixed(2));
                this.nivamxn = this.addCommas(parseFloat(this.ivamxn).toFixed(2));
                this.ntotalmxn = this.addCommas(parseFloat(this.totalmxn).toFixed(2));
                if(this.totalmxn == 0){
                    this.activomxn = false;
                }
            }
            if(item.idmoneda == 1){
                this.subtotalusd = Number(this.subtotalusd) - Number(item.subtotal);
                this.ivausd = Number(this.ivausd) - Number(item.niva);
                this.totalusd = Number(this.totalusd) - Number(item.total);
                this.nsubtotalusd = this.addCommas(parseFloat(this.subtotalusd).toFixed(2));
                this.nivausd = this.addCommas(parseFloat(this.ivausd).toFixed(2))
                this.ntotalusd = this.addCommas(parseFloat(this.totalusd).toFixed(2))
                if(this.totalusd == 0){
                    this.activousd = false;
                }
            }
            this.editedIndexCosto = this.Costos.indexOf(item)
            this.chargeconcepto = item.concepto;
            this.chargecostopor = item.idcostopor;
            this.chargecantidad = item.cantidad;
            this.chargecostounitario = item.costounitario;
            this.chargemoneda = item.idmoneda;
            this.chargeiva = item.iva;
        },
        Mostrartotal(){
            if(this.MostrarTotal == 0){
                this.MostrarTotal = 1;
                this.Costos.push();
            }else{
                this.MostrarTotal = 0;
                this.Costos.push();
            }
        },
        deleteICosto(item) {
            const index = this.Costos.indexOf(item)
            var resp = confirm('Are you sure you want to delete this rate?');
            if(resp == true){
                if(item.idmoneda == 2){
                    this.subtotalmxn = Number(this.subtotalmxn) - Number(item.subtotal);
                    this.ivamxn = Number(this.ivamxn) - Number(item.niva);
                    this.totalmxn = Number(this.totalmxn) - Number(item.total);
                    this.nsubtotalmxn = this.addCommas(parseFloat(this.subtotalmxn).toFixed(2));
                    this.nivamxn = this.addCommas(parseFloat(this.ivamxn).toFixed(2));
                    this.ntotalmxn = this.addCommas(parseFloat(this.totalmxn).toFixed(2));
                    if(this.totalmxn == 0){
                        this.activomxn = false;
                    }
                }
                if(item.idmoneda == 1){
                    this.subtotalusd = Number(this.subtotalusd) - Number(item.subtotal);
                    this.ivausd = Number(this.ivausd) - Number(item.niva);
                    this.totalusd = Number(this.totalusd) - Number(item.total);
                    this.nsubtotalusd = this.addCommas(parseFloat(this.subtotalusd).toFixed(2));
                    this.nivausd = this.addCommas(parseFloat(this.ivausd).toFixed(2))
                    this.ntotalusd = this.addCommas(parseFloat(this.totalusd).toFixed(2))
                    if(this.totalusd == 0){
                        this.activousd = false;
                    }
                }
                this.Costos[index].activo = false;
            }
        },
        /*----------------Colors---------------*/
        getColor(status) {
            if (status == false) return 'rgb(218,20,6)'
            else if(status == true) return '#4caf50'
        },
        getname(status){
            if (status == 'Pendiente') return 'Pendiente'
            else if (status == 'Negociación') return 'Negociación'
            else if(status == 'Enviado') return 'Recibido'
        },
        /*----------------Files---------------*/
        ViewFiles(name){
            var user = this.$store.state.usuario.nombre + " " + this.$store.state.usuario.apellido;
            if(this.editBS.ncotizacion == undefined){
                this.namefile = name;
            }else{
                this.namefile = this.editBS.idcustumer + "/" + this.editBS.ncotizacion + "/" + name;
            }
            this.dialoview = true;
        },
        Onfileselected(event){
            this.selectedFile = event
        },
        agregarFile(){           
            if (this.editedIndexF > -1) {
                Object.assign(this.containerFile[this.editedIndexF],{
                    class1:this.editcontainerFile.class1,
                    un:this.editcontainerFile.un,
                    file:this.selectedFile.name,
                    fileurl:this.selectedFile,
                    activo:true
                })
                this.LimpiarFiles();
            } else {
            this.containerFile.push({
                    class1:this.editcontainerFile.class1,
                    un:this.editcontainerFile.un,
                    file:this.selectedFile.name,
                    fileurl:this.selectedFile,
                    activo:true
                })
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                const fd = new FormData();
                fd.append('pdf',this.selectedFile, this.selectedFile.name)
                axios.post( 'api/Scotizaciones/SubirArchivosTemp',fd,configuracion).then(function(){
                    console.log('Correcto!');
                })
                .catch(function(error){
                    console.log('Error!');
                    console.log(error)
                });

                this.LimpiarFiles();
            }
        },
        LimpiarFiles(){
            this.editcontainerFile.class1 = '';
            this.editcontainerFile.un = '';
            this.selectedFile = ''
            this.files = null;
        },
        editfiles(item){
            this.editedIndexF = this.containerFile.indexOf(item)
            Object.assign(this.editcontainerFile,{
                class1:item.class1,
                un:item.un,
                file:item.file,
                fileurl:item.fileurl,
                activo:item.active,
            })
            this.files = item.fileurl;
            this.selectedFile = item.fileurl;
        },
        deleteItemFile (item) {
           const index = this.containerFile.indexOf(item)
           var eliminar=[];
           var resp = confirm('Are you sure you want to delete this hazardous?');
           if(resp == true){
                this.containerFile[index].activo = false;
           }
        },
        ListarFile(ids){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var listarfile = [];
            me.containerFile = [];
            axios.get('api/HazardousFiles/ListarHazardous/' + ids,configuracion).then(function(response){                
                listarfile = response.data;
                listarfile.map(function(x){
                    me.containerFile.push({
                        idhazardousfiles:x.idhazardousfiles,
                        class1:x.class1,
                        un:x.un,
                        file:x.file,
                        fileurl:'',
                        activo:true
                    })
                })
            }).catch(function(error){
                console.log(error);
            });
        },
      /*------------------------------------------*/
        informacioncotizacion(){
            this.e1 = 2;
            this.aditionalfees = this.tarifas[this.selectedItem].tarifaAd;
            this.pickupselect = this.tarifapickup[this.selectedItempickup];
            this.deliveryselect = this.tarifadeliver[this.selectedItemdelivery];
            this.principalselect = this.tarifas[this.selectedItem];
            //var modalidad;
            if(this.editBS.basis == 'FCL' || this.editBS.basis == 'LCL'){
                if(this.$store.state.usuario.rol == 'PricingAgente' || this.$store.state.usuario.rol === 'ComercialAgente'){
                    this.modalidadtex = 'MARITIME';
                }else{
                    this.modalidadtex = 'MARITIMO';
                }
            }
            this.modalidadtext2 = this.modalidadtex + ' ' + this.editBS.basis;
            this.Movimientotext = this.editBS.tipoOp;
            this.origentext = this.editBS.npuertoloading;
            this.destinotext = this.editBS.npuertodischarge;
            this.productotext = this.editBS.comodity;
            this.dateval = this.tarifas[this.selectedItem].fechavigencia;
        },
      /*-----------------------------------------*/
        postalCodeLookup() {
            var country = document.getElementById('country').value;
            
            if (geonamesPostalCodeCountries.toString().search(country) == -1) {
                return; // selected country not supported by geonames
            }
            // display 'loading' in suggest box
            document.getElementById('suggestBoxElement').style.visibility = 'visible';
            document.getElementById('suggestBoxElement').innerHTML = '<img src="/images/progress_arrow.gif" border="0"><small><i>Cargando...</i></small>';

            var postalcode = document.getElementById('postcode').value;

            request = 'http://www.geonames.org/postalCodeLookupJSON?postalcode=' + postalcode  + '&country=' + country  + '&callback=getLocation';

            // Create a new script object
            aObj = new JSONscriptRequest(request);
            //alert("JSONrequest: "+aObj);
            // Build the script tag
            aObj.buildScriptTag();
            // Execute (add) the script tag
            aObj.addScriptTag();

        },
        buscarTarifa(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};            
            axios.get('api/Tarifas/Mostrar/'+me.editBS.idportloading+"/"+me.editBS.idportdischarge,configuracion).then(function(response){
             me.tarifas=response.data;
            }).catch(function(error){
              console.log(error);              
            });
            me.verNuevo = true;
        },
        tarifa(item){                 
            this.editedIndexbtarifa = this.tarifas.indexOf(item)               
            this.editTarifa = Object.assign({}, item) 
            this.dialogtaf = true;
            //this.dateval = this.editBS;
        },
        listar(){
            let me=this;
            me.loadigtable = true;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.BuySellLista = [];
            var buy = [];
            var SolicitusLista = [];

            axios.get('api/Scotizaciones/ListarScotizacionusuarios/'+ me.$store.state.usuario.idusuario,configuracion).then(function(response){
                
                // 1. Eliminamos los duplicados usando el idscotizacion como referencia única
                buy = response.data.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.idscotizacion === value.idscotizacion
                    ))
                );

                for(var i = 0; i < buy.length; i++){
                    var principal = false;
                    var principalstatus = false;
                    var recollecion = false;
                    var recollecionstatus = false;
                    var entrega = false;
                    var entregastatus = false;
                    var viewextra = false;
                    var statusadicional = false;
                    var notificaAgente = false;
                    var notificaPricing = false;
                    var notificaLocal = false;

                    if(buy[i].principalratePricing == true || buy[i].principalrateLocal == true || buy[i].principalrateAgents == true){
                        principal = true;
                        if(buy[i].statusPrincipalRatePricing == true || buy[i].statusPrincipalRateLocal == true || buy[i].statusPrincipalRateAgents == true){
                            principalstatus = true;
                        }
                    }
                    if(buy[i].pickupLocal == true || buy[i].pickupAgents == true || buy[i].pickupPricing == true){
                        recollecion = true;
                        if(buy[i].statusPickupPricing == true || buy[i].statusPickupLocal == true || buy[i].statusPickupAgents == true){
                            recollecionstatus = true;
                        }
                    }
                    if(buy[i].deliveryAgents == true || buy[i].deliveryLocal == true || buy[i].deliveryPricing == true){
                        entrega = true;
                        if(buy[i].statusDeliveryLocal == true || buy[i].statusDeliveryAgents == true || buy[i].statusDeliveriPricing == true){
                            entregastatus = true;
                        }
                    }
                    if(buy[i].maneuvers == true || buy[i].vgm == true || buy[i].insurance == true || buy[i].custody == true || buy[i].custom == true){
                        viewextra = true;
                        statusadicional = buy[i].statusAdicional;
                    }

                    if(buy[i].principalrateAgents == true || buy[i].pickupAgents == true || buy[i].deliveryAgents == true){
                        notificaAgente = true;
                    }
                    if(buy[i].pickupPricing == true || buy[i].principalratePricing == true || buy[i].deliveryPricing == true){
                        notificaPricing = true;
                    }
                    if(buy[i].pickupLocal == true || buy[i].principalrateLocal == true || buy[i].deliveryLocal == true){
                        notificaLocal = true;
                    }

                    // Extraemos los folios y los separamos por comas de forma rápida
                    var nc = '';
                    if (buy[i].listadoCotizaciones && buy[i].listadoCotizaciones.length > 0) {
                        nc = buy[i].listadoCotizaciones.map(c => c.folio || c.ncotizacion).filter(Boolean).join(', ');
                    }

                    SolicitusLista.push({
                        agente:buy[i].agente,
                        basis:buy[i].basis,
                        clas:buy[i].clas,
                        comodity:buy[i].comodity,
                        custody:buy[i].custody,
                        custom:buy[i].custom,
                        delivery:buy[i].delivery,
                        dentrofbl:buy[i].dentrofbl,
                        direcciondeliverypcompleta:buy[i].direcciondeliverypcompleta,
                        direccionreceipcompleta:buy[i].direccionreceipcompleta,
                        fechacreate:buy[i].fechacreate,
                        fechaedit:buy[i].fechaedit,
                        fecharespuesta:buy[i].fecharespuesta,
                        filehazardous:buy[i].filehazardous,
                        foodgrade:buy[i].foodgrade,
                        freedaysdest:buy[i].freedaysdest,
                        freedaysorigin:buy[i].freedaysorigin,
                        hazardous:buy[i].hazardous,
                        idbasis:buy[i].idbasis,
                        idcustumer:buy[i].idcustumer,
                        idinland:buy[i].idinland,
                        idlistatarifa:buy[i].idlistatarifa,
                        idportdelivery:buy[i].idportdelivery,
                        idportdischarge:buy[i].idportdischarge,
                        idportloading:buy[i].idportloading,
                        idportreceipt:buy[i].idportreceipt,
                        idscotizacion:buy[i].idscotizacion,
                        idtipoOp:buy[i].idtipoOp,
                        idusuario:buy[i].idusuario,
                        insurance:buy[i].insurance,
                        local:buy[i].local,
                        maneuvers:buy[i].maneuvers,
                        ncotizacion:buy[i].ncotizacion,
                        ncustumer:buy[i].ncustumer,
                        nfechacreate:buy[i].nfechacreate,
                        nfechaedit:buy[i].nfechaedit,
                        nfecharespuesta:buy[i].nfecharespuesta,
                        npuertodelivery:buy[i].npuertodelivery,
                        npuertodischarge:buy[i].npuertodischarge,
                        npuertoloading:buy[i].npuertoloading,
                        npuertoreceipt:buy[i].npuertoreceipt,
                        nusuario:buy[i].nusuario,
                        pickup:buy[i].pickup,
                        pricing:buy[i].pricing,
                        remarks:buy[i].remarks,
                        status:buy[i].status,
                        tarifaadicional:buy[i].tarifaadicional,
                        tarifaprincipal:buy[i].tarifaprincipal,
                        tipoOp:buy[i].tipoOp,
                        un:buy[i].un,
                        vgm:buy[i].vgm,
                        entrega:entrega,
                        recollecion:recollecion,
                        principal:principal,
                        recollecionstatus:recollecionstatus,
                        entregastatus:entregastatus,
                        principalstatus:principalstatus,
                        statusadicional:statusadicional,
                        viewextra:viewextra,
                        notificaAgente:notificaAgente,
                        notificaPricing:notificaPricing,
                        notificaLocal: notificaLocal,
                        cotizaciones: buy[i].listadoCotizaciones,
                        Ncotizaciones: nc,
                        activo:buy[i].activo,
                    });
                }
                
                me.BuySellLista = SolicitusLista;
                me.loadigtable = false;
            }).catch(function(error){
                console.log(error);
                me.loadigtable = false;
            });
        },

        buscarejecutivo(){
            let me=this;
            me.loadigtable = true;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.BuySellLista = [];
            var buy = [];
            var SolicitusLista = [];

            axios.get('api/Scotizaciones/ListarScotizacionusuarios/'+ me.idejecutivo,configuracion).then(function(response){
                
                // 1. Eliminamos los duplicados usando el idscotizacion como referencia única
                buy = response.data.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.idscotizacion === value.idscotizacion
                    ))
                );

                for(var i = 0; i < buy.length; i++){
                    var principal = false;
                    var principalstatus = false;
                    var recollecion = false;
                    var recollecionstatus = false;
                    var entrega = false;
                    var entregastatus = false;
                    var viewextra = false;
                    var statusadicional = false;
                    var notificaAgente = false;
                    var notificaPricing = false;
                    var notificaLocal = false;

                    if(buy[i].principalratePricing == true || buy[i].principalrateLocal == true || buy[i].principalrateAgents == true){
                        principal = true;
                        if(buy[i].statusPrincipalRatePricing == true || buy[i].statusPrincipalRateLocal == true || buy[i].statusPrincipalRateAgents == true){
                            principalstatus = true;
                        }
                    }
                    if(buy[i].pickupLocal == true || buy[i].pickupAgents == true || buy[i].pickupPricing == true){
                        recollecion = true;
                        if(buy[i].statusPickupPricing == true || buy[i].statusPickupLocal == true || buy[i].statusPickupAgents == true){
                            recollecionstatus = true;
                        }
                    }
                    if(buy[i].deliveryAgents == true || buy[i].deliveryLocal == true || buy[i].deliveryPricing == true){
                        entrega = true;
                        if(buy[i].statusDeliveryLocal == true || buy[i].statusDeliveryAgents == true || buy[i].statusDeliveriPricing == true){
                            entregastatus = true;
                        }
                    }
                    if(buy[i].maneuvers == true || buy[i].vgm == true || buy[i].insurance == true || buy[i].custody == true || buy[i].custom == true){
                        viewextra = true;
                        statusadicional = buy[i].statusAdicional;
                    }

                    if(buy[i].principalrateAgents == true || buy[i].pickupAgents == true || buy[i].deliveryAgents == true){
                        notificaAgente = true;
                    }
                    if(buy[i].pickupPricing == true || buy[i].principalratePricing == true || buy[i].deliveryPricing == true){
                        notificaPricing = true;
                    }
                    if(buy[i].pickupLocal == true || buy[i].principalrateLocal == true || buy[i].deliveryLocal == true){
                        notificaLocal = true;
                    }
                    
                    // Extraemos los folios y los separamos por comas de forma rápida
                    var nc = '';
                    if (buy[i].listadoCotizaciones && buy[i].listadoCotizaciones.length > 0) {
                        nc = buy[i].listadoCotizaciones.map(c => c.folio || c.ncotizacion).filter(Boolean).join(', ');
                    }

                    SolicitusLista.push({
                        agente:buy[i].agente,
                        basis:buy[i].basis,
                        clas:buy[i].clas,
                        comodity:buy[i].comodity,
                        custody:buy[i].custody,
                        custom:buy[i].custom,
                        delivery:buy[i].delivery,
                        dentrofbl:buy[i].dentrofbl,
                        direcciondeliverypcompleta:buy[i].direcciondeliverypcompleta,
                        direccionreceipcompleta:buy[i].direccionreceipcompleta,
                        fechacreate:buy[i].fechacreate,
                        fechaedit:buy[i].fechaedit,
                        fecharespuesta:buy[i].fecharespuesta,
                        filehazardous:buy[i].filehazardous,
                        foodgrade:buy[i].foodgrade,
                        freedaysdest:buy[i].freedaysdest,
                        freedaysorigin:buy[i].freedaysorigin,
                        hazardous:buy[i].hazardous,
                        idbasis:buy[i].idbasis,
                        idcustumer:buy[i].idcustumer,
                        idinland:buy[i].idinland,
                        idlistatarifa:buy[i].idlistatarifa,
                        idportdelivery:buy[i].idportdelivery,
                        idportdischarge:buy[i].idportdischarge,
                        idportloading:buy[i].idportloading,
                        idportreceipt:buy[i].idportreceipt,
                        idscotizacion:buy[i].idscotizacion,
                        idtipoOp:buy[i].idtipoOp,
                        idusuario:buy[i].idusuario,
                        insurance:buy[i].insurance,
                        local:buy[i].local,
                        maneuvers:buy[i].maneuvers,
                        ncotizacion:buy[i].ncotizacion,
                        ncustumer:buy[i].ncustumer,
                        nfechacreate:buy[i].nfechacreate,
                        nfechaedit:buy[i].nfechaedit,
                        nfecharespuesta:buy[i].nfecharespuesta,
                        npuertodelivery:buy[i].npuertodelivery,
                        npuertodischarge:buy[i].npuertodischarge,
                        npuertoloading:buy[i].npuertoloading,
                        npuertoreceipt:buy[i].npuertoreceipt,
                        nusuario:buy[i].nusuario,
                        pickup:buy[i].pickup,
                        pricing:buy[i].pricing,
                        remarks:buy[i].remarks,
                        status:buy[i].status,
                        tarifaadicional:buy[i].tarifaadicional,
                        tarifaprincipal:buy[i].tarifaprincipal,
                        tipoOp:buy[i].tipoOp,
                        un:buy[i].un,
                        vgm:buy[i].vgm,
                        entrega:entrega,
                        recollecion:recollecion,
                        principal:principal,
                        recollecionstatus:recollecionstatus,
                        entregastatus:entregastatus,
                        principalstatus:principalstatus,
                        statusadicional:statusadicional,
                        viewextra:viewextra,
                        notificaAgente:notificaAgente,
                        notificaPricing:notificaPricing,
                        notificaLocal: notificaLocal,
                        cotizaciones: buy[i].listadoCotizaciones,
                        Ncotizaciones: nc,
                        activo:buy[i].activo,
                    });
                }
                
                me.BuySellLista = SolicitusLista;
                me.loadigtable = false;
                me.limpiar();
                me.nuevast = false;
            }).catch(function(error){
                console.log(error);
                me.loadigtable = false;
            });
        },
        select(){ 
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var basiss = [];                
            var tipoOp = [];
            var inlandArray = [];
            var modalidadArray = [];
            var customerArray = [];
            var monedasArray = [];
            var tamanocArray = [];
            var tipocArray = [];
            var portArray = [];
            var portArrayB = [];
            var packageArray = [];
            var longitudArray = []; 
            var masaArray = [];
            var prospectos = [];
            var preciocostoporArray = [];
            var usuariosarray = [];

            axios.get('api/Usuarios/SelectReportSC',configuracion).then(function(response){
                usuariosarray=response.data;
                usuariosarray.map(function(x){
                    me.ejecutivos.push({text:x.nombre,value:x.idusuario});
                });            
            }).catch(function(error){
                console.log(error);
            });
            console.log(me.$store.state.usuario.rol)

            if(me.$store.state.usuario.rol == 'ComercialAdmin'){
                console.log('1')
                axios.get('api/Asignaciones/ListarTProspectos/',configuracion).then(function(response){
                prospectos = response.data
                prospectos.map(function(x){
                    me.prospectossn.push({text:x.nombrep,value:x.idprospecto})
                });
                }).catch(function(error){
                    console.log(error);
                }); 
            }
            else{
                console.log('2')
                axios.get('api/Asignaciones/ListarProspectosA/' + this.$store.state.usuario.idusuario ,configuracion).then(function(response){
                prospectos = response.data
                prospectos.map(function(x){
                    me.prospectossn.push({text:x.nombrep,value:x.idprospecto})
                });
                }).catch(function(error){
                    console.log(error);
                }); 
            }
            
            axios.get('api/CostoporCotizaciones/Select',configuracion).then(function(response){
                preciocostoporArray = response.data
                preciocostoporArray.map(function(x){
                    me.preciocostopor.push({text:x.nombre,value:x.idconcepto})
                });
            }).catch(function(error){
                console.log(error);
            }); 
            axios.get('api/Monedas/select',configuracion).then(function(response){            
                monedasArray=response.data;
                monedasArray.map(function(x){
                    me.monedas.push({text:x.abreviatura,value:x.idmoneda});
                });            
            }).catch(function(error){
                console.log(error);
            }); 
             axios.get('api/Inlands/Select',configuracion).then(function(response){            
                inlandArray=response.data;
                inlandArray.map(function(x){
                    me.inlands.push({text:x.nombre,value:x.idinland});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Unidadmedidalongitudes/Select',configuracion).then(function(response){            
                longitudArray=response.data;
                longitudArray.map(function(x){
                    me.Longitud.push({text:x.nombre,value:x.idunidad,idclave:x.idclave});
                });
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Unidadmedidamasas/Select',configuracion).then(function(response){            
                masaArray=response.data;
                masaArray.map(function(x){
                    me.Masa.push({text:x.nombre,value:x.idunidadmasa,idclave:x.idclave});
                });
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Package/Select',configuracion).then(function(response){            
                packageArray=response.data;
                packageArray.map(function(x){
                    me.selectpackage.push({text:x.nombre,value:x.idpackage});
                });
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Basis/Select',configuracion).then(function(response){            
                basiss=response.data;
                basiss.map(function(x){
                    me.basis.push({text:x.nombre,value:x.idbasis,descripcion:x.descripcion});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Tipooperaciones/Select',configuracion).then(function(response){            
                tipoOp=response.data;
                tipoOp.map(function(x){
                    me.TipoOperacion.push({text:x.nombre,value:x.idtipoOp});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Modalidades/Select',configuracion).then(function(response){            
                modalidadArray=response.data;
                modalidadArray.map(function(x){
                    me.modalidad.push({text:x.nombre,value:x.idmodalidad});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Datos/SelectCliente',configuracion).then(function(response){            
                customerArray=response.data;
                customerArray.map(function(x){
                    me.customer.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Tipocontenedores/select',configuracion).then(function(response){            
                tipocArray=response.data;
                tipocArray.map(function(x){
                    me.tipoc.push({text:x.tipocontenedor,value:x.idcontenedor});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/tamanocontenedores/select',configuracion).then(function(response){            
                tamanocArray=response.data;
                tamanocArray.map(function(x){
                    me.tamanoc.push({text:x.tamanocontenedor,value:x.idtamano});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Puertos/select',configuracion).then(function(response){            
                portArray=response.data;
                portArray.map(function(x){
                    me.ports.push({text:x.nombre,value:x.idpuerto});
                });            
            }).catch(function(error){
                console.log(error);
            });   
            axios.get('api/Puertos/SelectPuertosBase',configuracion).then(function(response){            
                portArrayB=response.data;
                portArrayB.map(function(x){
                    me.portsbase.push({text:x.nombre,value:x.idpuerto});
                });            
            }).catch(function(error){
                console.log(error);
            });         
        },
        clonarsolicitud(){
            this.editedIndexScot = -1;
            this.editBS.ncotizacion = "";
            this.harz = false;
            this.editBS.btnhazardous = [];
            this.containerFile = [];
        },
        editItemBS(item) {
            this.limpiar();
            this.limpiarcotizacion();
            /*console.log('item')
            console.log(item)*/
            this.select();
            //console.log(this.prospectossn)
            this.editedIndexScot = this.BuySellLista.indexOf(item)               
            this.editBS = Object.assign({}, item)
            this.nuevast = true;
            if(this.editBS.creditDays != 0){
                this.editBS.btcredit ='credit';
                this.credit=true;
            }else{
                this.credit=false;
            }
            if(this.editBS.hazardous != 0){
                this.editBS.btnhazardous ='hazardous';
                this.harz=true;
            }else{
                this.harz=false;
            }
            if(this.editBS.custom == true){
                this.optionsbutton[0] = 'customs';
            }
            if(this.editBS.vgm == true){
                this.optionsbutton[1] = 'vgm';
            }
            if(this.editBS.insurance == true){
                this.optionsbutton[2] = 'insurance';
            }
            if(this.editBS.custody == true){
                this.optionsbutton[3] = 'custody';
            }
            if(this.editBS.maneuvers == true){
                this.optionsbutton[4] = 'maneuvers';
            }
  
            if(this.editBS.agente == true){
                this.impaal = true;
                this.optionsbuttonagent[0] = 'agent';
            }
            if(this.editBS.local == true){
                this.impaal = true;
                this.optionsbuttonagent[1] = 'local';
            }
            this.addressreceipt = this.editBS.direccionreceipcompleta;
            this.addressdelivery = this.editBS.direcciondeliverypcompleta;
            this.numidscotizacion = this.editBS.idscotizacion;

            if(this.editBS.idbasis == 2 || this.editBS.idbasis == 4 || this.editBS.idbasis == 5){
                this.ListarPackage(this.editBS.idscotizacion);
            }else{
                this.cargarContainer(this.editBS.idscotizacion);
            }
            this.ListarFile(this.editBS.idscotizacion);
            this.activar();
        },
        cargarContainer(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var containerarray = [];
            me.containers = [];
            axios.get('api/DatosContainerUnits/ListarContainers/'+ id,configuracion).then(function(response){
                containerarray=response.data;
                var totalw = 0;
                var nweight
                var weight = 0;;
                containerarray.map(function(x){
                    
                    nweight = parseFloat(x.nweight).toFixed(2);

                    var indexmasa = 0;
                    var peso = 0;

                    indexmasa = me.Masa.findIndex(y=>y.value == x.idunidadmasa);
                    peso = me.editcontainer.peso;
                
                    var idmasa = me.Masa[indexmasa].idclave;

                    if(idmasa == 'KL1'){//Toneladas a Kilogramos
                        weight = parseFloat(x.weight).toFixed(2); 
                    }
                    if(idmasa == 'TN1'){//Toneladas a Kilogramos
                        weight = parseFloat(x.weight * 1000).toFixed(2); 
                    }
                    if(idmasa == 'GR1'){//Gramos a Kilogramos
                        weight = parseFloat(x.weight / 1000).toFixed(2); 
                    }
                    if(idmasa == 'LI1'){//Libras a Kilogramos
                        weight = parseFloat(x.weight * 0.453592).toFixed(2); 
                    }

                    totalw = totalw + weight;
                    me.containers.push({
                        idcontainer:x.idcontainer,
                        quantity:x.quantity,
                        size:x.size,
                        idsize:x.idsize,
                        type:x.type,
                        idtype:x.idtype,
                        weight:x.weight,
                        nweight:me.addCommas(parseFloat(weight).toFixed(2)) +' Kg.',
                        totalweight:me.addCommas(parseFloat(totalw).toFixed(2)) + ' Kg.',
                        remarks:'',
                        idunidadmasa:x.idunidadmasa,
                        activo:x.activo
                    })
                });
            }).catch(function(error){
                console.log(error);
            });
        },
        ListarPackage(idbs){
            var datospackage = [];
            this.addpackages = [];
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;
            axios.get('api/Packages/ListarPackage/' + idbs,configuracion).then(function(response){                            
                datospackage=response.data;
                datospackage.map(function(x){
                    var pwidth = 0;
                    var plarge = 0;
                    var phigh = 0;
                    var weight = 0;
                    var pesovolumetrico = 0;
                    var pesovolcompleto = 0;
                    if(x.idlongitud== 4 ){ //Centimetros a Metros
                        plarge = parseFloat(x.large / 100).toFixed(2);
                        pwidth = parseFloat(x.width/ 100).toFixed(2);
                        phigh = parseFloat(x.high / 100).toFixed(2);
                    }

                    if(x.idlongitud == 2){ //Pies a Metros
                        plarge = parseFloat(x.large / 3.28084).toFixed(2);
                        pwidth = parseFloat(x.width / 3.28084).toFixed(2);
                        phigh = parseFloat(x.high / 3.28084).toFixed(2);
                    }
                    if(x.idlongitud == 3){ //Pies a Metros
                        plarge = parseFloat(x.large / 39.3701).toFixed(2);
                        pwidth = parseFloat(x.width / 39.3701).toFixed(2);
                        phigh = parseFloat(x.high / 39.3701).toFixed(2);
                    }
                    if(x.idlongitud == 1){
                        plarge = x.large;
                        pwidth = x.width;
                        phigh = x.high;
                    }
                     if(x.idpeso == 1){//Toneladas a Kilogramos
                        weight = x.weight; 
                    }
                    if(x.idpeso == 2){//Toneladas a Kilogramos
                        weight = parseFloat(x.weight * 1000).toFixed(2); 
                    }
                    if(x.idpeso == 4){//Libras a Kilogramos
                        weight = parseFloat(x.weight * 0.453592).toFixed(2); 
                    }
                    if(x.idpeso == 5){//Libras a Kilogramos
                        weight = parseFloat(x.weight / 1000).toFixed(2); 
                    }
                    
                    if(me.editBS.idbasis == 5){
                        pwidth = pwidth * 100;
                        plarge = plarge* 100;
                        phigh = phigh * 100;
                        pesovolumetrico = parseFloat(((pwidth * plarge) * phigh) / 6000).toFixed(2);
                        pesovolumetrico =parseFloat(pesovolumetrico * x.quantity).toFixed(2);
                        me.volumenwn = parseFloat(Number(me.volumenwn) + Number(pesovolumetrico)).toFixed(2);
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Kg.';
                    }else{
                        pesovolumetrico = parseFloat(((pwidth * plarge) * phigh)).toFixed(2);
                        pesovolumetrico = pesovolumetrico * x.quantity;
                        me.volumenwn = parseFloat(Number(me.volumenwn) + Number(pesovolumetrico)).toFixed(2);
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Ton.';
                    }
                    
                    var nstackable;
                    var actualweight = x.quantity * weight;
                    me.totalwn = parseFloat(Number(me.totalwn) + Number(actualweight)).toFixed(2);
                    if(x.stackable == true){
                        nstackable = 'yes'
                    }else{
                        nstackable = 'no'
                    }
                    me.addpackages.push({
                        idspackage:x.idspackage,
                        idpackage:x.idpackage,
                        longitud:'',
                        idlongitud:x.idlongitud,
                        idpeso:x.idpeso,
                        stackable:x.stackable,
                        nstackable:nstackable,
                        weight:x.weight,
                        nweight:parseFloat(weight).toFixed(2) + ' Kg.',
                        high:x.high,
                        width:x.width,
                        large:x.large,
                        nhigh:phigh + ' Mts.',
                        nwidth:pwidth + ' Mts.',
                        nlarge:plarge + ' Mts.',
                        volumetricweight:pesovolcompleto,
                        actualweight:parseFloat(actualweight).toFixed(2) + ' Kg.',
                        nactualweight:actualweight,
                        quantity:x.quantity,
                        package:x.tnpackage,
                        Notes:x.notes,
                        otropackage:x.otropackage,
                        pesovolumetrico:pesovolumetrico,
                        activo:x.activo,
                    })
                })
            }).catch(function(error){
            console.log(error);
            });
        },
        CargosTotales(item){
            console.log( ":" + item + "<br>");
        },
        cargarInformacion(item){
            this.tarifasseleccionadas = [];
            this.principalselect = [];
            this.pickupselect = [];
            this.deliveryselect = [];
            this.selectedItem = [];
            this.limpiar();
            this.limpiarcotizacion();
            this.dialodload = true;
            this.delivery = false;
            this.recoleccion = false;
            this.selectedItemdelivery = [];
            this.selectedItempickup= [];
            this.deliveryview = false;
            this.principalview = false;
            this.recoleccionview = false;
            this.editedIndexbuys = this.BuySellLista.indexOf(item);
            this.editBS = Object.assign({}, item);


               // var modalidad;
                if(this.editBS.basis == 'FTL' || this.editBS.basis == 'LTL'){
                    if(this.$store.state.usuario.rol == 'PricingAgente' || this.$store.state.usuario.rol === 'ComercialAgente'){
                        this.modalidadtex = 'INLAND';
                    }else{
                        this.modalidadtex = 'TERRESTRE';
                    }
                    
                }
                if(this.editBS.basis == 'FCL' || this.editBS.basis == 'LCL'){
                    if(this.$store.state.usuario.rol == 'PricingAgente' || this.$store.state.usuario.rol === 'ComercialAgente'){
                        this.modalidadtex = 'MARITIME';
                    }else{
                        this.modalidadtex = 'MARITIMO';
                    }
                }
                if(this.editBS.basis == 'AEREO'){
                    if(this.$store.state.usuario.rol == 'PricingAgente' || this.$store.state.usuario.rol === 'ComercialAgente'){
                        this.modalidadtex = 'AIR';
                    }else{
                        this.modalidadtex = 'AEREA';
                    }
                    //this.editBS.basis = '';
                    this.modalidadtext2 = this.modalidadtex;
                }else
                {
                    this.modalidadtext2 = this.modalidadtex + ' ' + this.editBS.basis;
                }
                
                this.Movimientotext = this.editBS.tipoOp;
                this.origentext = this.editBS.npuertoloading;
                this.destinotext = this.editBS.npuertodischarge;
                this.productotext = this.editBS.comodity;


            if(this.editBS.basis == 'LTL' || this.editBS.basis == 'LCL' || this.editBS.basis == 'AEREO'){
                this.ListarPackage(this.editBS.idscotizacion);
            }else{
                this.cargarContainer(this.editBS.idscotizacion);
            }
            this.listartarifag(this.editBS.idscotizacion)
            this.listarContacto(this.editBS.idcustumer);
            this.numidscotizacion = this.editBS.idscotizacion;
            this.e1 = 1;
            this.principal = true;
        },
        limpiarcotizacion(){
            this.tttext = '';
            this.viatext = '';
            this.serviciotext = '';
            this.destinotext = '';
            this.origentext = '';
            this.productotext = '';
            this.Movimientotext = '';
            this.modalidadtext2 = '';
            this.transbordo = '';
            this.remarklist = 0;
            this.remarksc = '';
            this.Costos = [];
            this.contactoscot = '';
            this.nsubtotalusd = '';
            this.nivausd = '';
            this.ntotalusd = '';
            this.nsubtotalmxn = '';
            this.nivamxn = '';
            this.ntotalmxn = '';
            this.activomxn = false;
            this.activousd = false;
            this.dateval ='';
            this.contactoscp = '';
            this.cpasunto = '';
            this.editorcp = '';
            this.bodyCot = '';
            this.cargarremarks();
        },
        GenerrarPDF(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
                 if(model.lclviewremarks == false){
                        if(model.editBS.idbasis == 2){
                            if(model.contizacioningles == 'INGLES'){
                                model.remarkstextc.push({
                                    text: "In case of any extraordinary costs at POL/POD due storages, terminal handling costs, additional expenses caused by roll overs, delay of vessel’ departure (ETD), ommision on behalf of steamship line and/or any other expenses not previously considered,  shall be fully paid by shipper and/or consignee.",
                                    idremarktext:100,
                                    observacion: "this.remarksc",
                                    idremark:100,
                                    activo:true
                                });
                            }else{
                                model.remarkstextc.push({
                                    text: "En caso de existir costos extraordinarios ya sea en puerto de carga y/o descarga, por concepto de almacenajes, costos de terminal portuaria, gastos adicionales derivados de un roll over, atraso en el zarpe del buque, omisión de puerto por parte de la línea naviera o cualquier otro no contemplado, éstos deberán ser cubiertos en su totalidad por el embarcador y/o consignatario.",
                                    idremarktext:100,
                                    observacion: "this.remarksc",
                                    idremark:100,
                                    activo:true
                                });
                            }
                            model.lclviewremarks= true;
                        }
                    }
                //}
                var incseguro
                if(model.incseguromercancia == 'SI'){
                    incseguro= true;
                }else{
                    incseguro= false;
                }
                var ingles = false;
                if(model.contizacioningles == 'INGLES'){
                    ingles= true;
                }else{
                    ingles= false;
                }

            axios.post('api/Scotizaciones/Cotizacion',{
                'basis':model.editBS.idbasis,
                'idcustumer':model.editBS.idcustumer,
                'ncotizacion':model.editBS.ncotizacion,
                'folio':model.folio,
                'prospecto':model.editBS.ncustumer,
                'nusuario': model.$store.state.usuario.nombre + " " + model.$store.state.usuario.apellido,
                'body':model.bodyCot,
                'modalidad':model.modalidadtext2,
                'movimiento':model.Movimientotext,
                'producto':model.productotext,
                'origen':model.origentext,
                'destino':model.destinotext,
                'servicio':model.serviciotext,
                'tt':model.tttext,
                'comentarios':model.remarkstextc,
                'tarifa':model.Costos,
                'mostrartotal':model.MostrarTotal,
                'ncontacto':model.contactoscot,
                'valid':model.dateval,
                'vigencia':model.dateval,
                'transbordo':model.transbordo,
                'via':model.viatext,
                'nsubtotalusd':model.nsubtotalusd,
                'nivausd':model.nivausd,
                'ntotalusd':model.ntotalusd,
                'activousd':model.activousd,
                'nsubtotalmxn':model.nsubtotalmxn,
                'nivamxn':model.nivamxn,
                'ntotalmxn':model.ntotalmxn,
                'activomxn':model.activomxn,
                'rol':model.$store.state.usuario.rol,
                'incseguro':incseguro,
                'ingles':ingles
            },configuracion).then(function(response){
                
                model.namecot =  model.editBS.idcustumer + "/" + model.editBS.ncotizacion + "/" + response.data;
                model.nombrec = response.data;
                model.dialogcot= false;
                model.e1 = 3;
            }).catch(function(error){
                model.snackbar = true
                model.mensaje = error;
            });
        },
        crearCotizacion(){
            if(this.Costos.length >= 1 && this.contactoscot.length >= 1){
                this.dialogcot= true;
                if(this.cotguardada == true){
                    this.GenerrarPDF();
                }else{
                    this.generarcot = true;
                    this.GuardarCotizacion();
                }
            }else{
                window.alert('Agrega un contacto o costo a tu cotizacion');
            }
        },
        GuardarCotizacion(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
            if(model.cotguardada == false){
                axios.post('api/Cotizaciones/Crear',{
                    'idcustumer':model.editBS.idcustumer,
                    'idscotizacion':model.numidscotizacion,
                    'idusuario': this.$store.state.usuario.idusuario,
                    'body':model.bodyCot,
                    'modalidad':model.modalidadtext2,
                    'movimiento':model.Movimientotext,
                    'producto':model.productotext,
                    'origen':model.origentext,
                    'destino':model.destinotext,
                    'servicio':model.serviciotext,
                    'tt':model.tttext,
                    'vigencia':model.dateval,//model.dateval,
                    'transbordo':model.transbordo,
                    'via':model.viatext,
                    'idprincipalrate':1,
                    'idpickuprate':1,
                    'iddeliveryrate':1,
                    'ccotizaciones':model.Costos,
                    'observaciones':model.remarkstextc,
                    'tarifasSeleccionadas':model.tarifasseleccionadas
                },configuracion).then(function(response){
                    model.snackbar = true
                    var arreglo = response.data.split("/");
                    
                    model.mensaje = 'Cotizacion Guardada Correctamente Ref# ' + arreglo[0];
                    model.folio = arreglo[0];
                    model.idcotizacion = arreglo[1];
                    model.cotguardada = true;
                    if(model.generarcot == true){
                        model.GenerrarPDF();
                    }
                }).catch(function(error){
                    model.snackbar = true
                    model.mensaje = error;
                });
            }else{
                model.dialogcot = true;
                model.dialogcot= false;
                model.snackbar = true
                model.mensaje = 'Cotizacion Guardada Correctamente Ref# ' + model.folio;
            }
        },
        verificarinformacion(){
            if(this.validar()){
                return;
            }

            if(this.editBS.idportreceipt == 0){
                this.editBS.idportreceipt = 26;
            }
            if(this.editBS.idportdischarge == 0)
            {
                this.editBS.idportdischarge = 26;
            }
            if(this.editBS.idportloading == 0){
                this.editBS.idportloading = 26;
            }
            if(this.editBS.idportdelivery == 0){
                this.editBS.idportdelivery = 26;
            }

            var index = this.TipoOperacion.findIndex(x=>x.value == this.editBS.idtipoOp);
            var indexbasis = this.basis.findIndex(x=>x.value == this.editBS.idbasis);
            var indexpol = this.ports.findIndex(x=>x.value == this.editBS.idportloading);
            var indexpod = this.ports.findIndex(x=>x.value == this.editBS.idportdischarge);
            var indexnpickup = this.ports.findIndex(x=>x.value == this.editBS.idportreceipt);
            var indexdelivery = this.ports.findIndex(x=>x.value == this.editBS.idportdelivery);

            if(this.indl == true){
                var indexinland = this.inlands.findIndex(x=>x.value == this.editBS.idinland);
                var indexbl = this.bl.findIndex(x=>x.value == this.editBS.dentrofbl);
                this.ninland = this.inlands[indexinland].text + ' / ' + this.bl[indexbl].text  
            }
            
            this.noperacion = this.TipoOperacion[index].text;
            this.nmodalidad = this.basis[indexbasis].descripcion;
            this.ntipoembarque = this.basis[indexbasis].text;
            this.nrecoleccion = this.addressreceipt;
            this.npol = this.ports[indexpol].text;
            this.npod = this.ports[indexpod].text;
            this.npickup = this.ports[indexnpickup].text;
            this.ndelivery = this.ports[indexdelivery].text;
            this.nentrega = this.addressdelivery;
            this.nmercancia = this.editBS.comodity;
            this.nobservaciones = this.editBS.remarks;
            this.nfoodgrade = this.editBS.foodgrade;
            var i;
            var j;
            this.nmaneuvers = 'NO';
            this.ncustody = 'NO';
            this.ninsurance = 'NO';
            this.nvgm = 'NO';
            this.ncustoms = 'NO';
            this.nlocal = '';
            this.nagente = '';
            for (i = 0; i < this.optionsbutton.length; i++) {
                if(this.optionsbutton[i] == 'customs'){
                    this.ncustoms = 'SI';
                }
                if(this.optionsbutton[i] == 'vgm'){
                    this.nvgm = 'SI';
                }
                if(this.optionsbutton[i] == 'insurance'){
                    this.ninsurance = 'SI';
                }
                if(this.optionsbutton[i] == 'custody'){
                    this.ncustody = 'SI';
                }
                if(this.optionsbutton[i] == 'maneuvers'){
                    this.nmaneuvers = 'SI';
                }
            }
            for (j = 0; j < this.optionsbuttonagent.length; j++) {
                if(this.optionsbuttonagent[j] == 'agent'){
                    this.nagente = 'AGENTE';
                }
                if(this.optionsbuttonagent[j] == 'local'){
                    this.nlocal = 'LOCAL';
                }   
            }
            this.confirmacionsolicitud = true;
        },
        guardar() {
            this.dialodload = true;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
            var i;
            var customs = 0;
            var vgm = 0;
            var insurance = 0;
            var custody = 0;
            var hazar = 0;
            var agent = 0;
            var local = 0;
            var maneuvers =0;
            
            for (i = 0; i < model.optionsbuttonagent.length; i++) {
                if(model.optionsbuttonagent[i] == 'agent'){
                    agent = 1;
                }
                if(model.optionsbuttonagent[i] == 'local'){
                    local = 1;
                }   
            }
            i=0;
            for (i = 0; i < this.optionsbutton.length; i++) {
                if(this.optionsbutton[i] == 'customs'){
                    customs = 1;
                }
                if(this.optionsbutton[i] == 'vgm'){
                    vgm = 1;
                }
                if(this.optionsbutton[i] == 'insurance'){
                    insurance = 1;
                }
                if(this.optionsbutton[i] == 'custody'){
                    custody = 1;
                }
                if(this.optionsbutton[i] == 'maneuvers'){
                    maneuvers = 1;
                }
            }
            if(this.editBS.btnhazardous == 'hazardous'){
                    hazar = 1;
            }
            if(model.editBS.freedaysorigin == ''){
                model.editBS.freedaysorigin = 0;
            }
            if(model.editBS.freedaysdest == ''){
                model.editBS.freedaysdest = 0;
            }
            
            if( model.editBS.idbasis == 3 || model.editBS.idbasis == 4){
                agent = 1;
                local = 1;
            }

            if(agent == 0 && local == 0 ){
                alert("Selecciona aquien quieres enviar la tarifa Agente o Local")
                model.dialodload = false;
            }else{
                if (model.editedIndexScot > -1) {//codigo para editar      
                    axios.put('api/Scotizaciones/ActualizarSc',{
                        'idscotizacion':model.numidscotizacion,
                        'idusuario': this.$store.state.usuario.idusuario,
                        'idbasis': model.editBS.idbasis,
                        'idtipoOp': model.editBS.idtipoOp,
                        'idinland': model.editBS.idinland,
                        'dentrofbl':model.editBS.dentrofbl,
                        'custom': customs,
                        'custody':custody,
                        'vgm': vgm,
                        'insurance': insurance,
                        'maneuvers':maneuvers,
                        'agente':agent,
                        'local':local,
                        'idcustumer': model.editBS.idcustumer,
                        'comodity': model.editBS.comodity,
                        'foodgrade':model.editBS.foodgrade,
                        'hazardous': hazar,
                        'clas':model.editcontainerFile.class1,
                        'un': model.editcontainerFile.un,
                        'filehazardous':'file',
                        'idportreceipt': model.editBS.idportreceipt,
                        'idportloading': model.editBS.idportloading,
                        'idportdischarge': model.editBS.idportdischarge,
                        'idportdelivery': model.editBS.idportdelivery,
                        'freedaysorigin':model.editBS.freedaysorigin,
                        'freedaysdatination':model.editBS.freedaysdest,
                        'direccionreceipcompleta':model.addressreceipt,
                        'direcciondeliverypcompleta':model.addressdelivery,
                        'remarks': model.editBS.remarks,
                        'status':'Pendiente',
                        'spackages':model.addpackages,
                        'Container':model.containers,
                        'HazardousFiles':model.containerFile,
                        'noperacion':model.noperacion,
                        'nmodalidad':model.nmodalidad,
                        'ntipoembarque':model.ntipoembarque,
                        'ninland':model.ninland,
                        'nrecoleccion':model.nrecoleccion,
                        'npickup':model.npickup,
                        'npol':model.npol,
                        'npod':model.npod,
                        'ndelivery':model.ndelivery,
                        'nentrega':model.nentrega,
                        'nmercancia':model.nmercancia,
                        'ncustoms':model.ncustoms,
                        'ninsurance':model.ninsurance,
                        'nvgm':model.nvgm,
                        'nmaneuvers':model.nmaneuvers,
                        'ncustody':model.ncustody,
                        'nobservaciones':model.nobservaciones,
                    },configuracion).then(function(response){
                        model.dialodload = false;
                        model.confirmacionsolicitud = false;
                        model.snackbar = true               
                        model.mensaje = 'Solicitud '+ model.editBS.ncotizacion + ' actualizada correctamente'
                        model.limpiar();
                        model.listar();
                        model.nuevast = false;
                    }).catch(function(error){
                        model.snackbar = true               
                        model.mensaje = 'Error al actualizar la solicitud. '+ error;
                        model.nuevast = false;
                        console.log(error);
                    });  
                } 
                else { 
                    if(model.containers.length <= 0 && model.addpackages.length <= 0){
                        alert("Ingresa una unidad o Paquete")
                    }
                    else{
                        axios.post('api/Scotizaciones/Crear',{
                            'Ncotizacion':'TRA20200402',
                            'idusuario': this.$store.state.usuario.idusuario,
                            'idbasis': model.editBS.idbasis,
                            'idtipoOp': model.editBS.idtipoOp,
                            'idinland': model.editBS.idinland,
                            'dentrofbl':model.editBS.dentrofbl,
                            'custom': customs,
                            'custody':custody,
                            'vgm': vgm,
                            'insurance': insurance,
                            'maneuvers':maneuvers,
                            'agente':agent,
                            'local':local,
                            'idcustumer': model.editBS.idcustumer,
                            'comodity': model.editBS.comodity,
                            'foodgrade':model.editBS.foodgrade,
                            'hazardous': hazar,
                            'clas':model.editcontainerFile.class1,
                            'un': model.editcontainerFile.un,
                            'filehazardous':'file',
                            'idportreceipt': model.editBS.idportreceipt,
                            'idportloading': model.editBS.idportloading,
                            'idportdischarge': model.editBS.idportdischarge,
                            'idportdelivery': model.editBS.idportdelivery,
                            'freedaysorigin':model.editBS.freedaysorigin,
                            'freedaysdatination':model.editBS.freedaysdest,
                            'direccionreceipcompleta':model.addressreceipt,
                            'direcciondeliverypcompleta':model.addressdelivery,
                            'remarks': model.editBS.remarks,
                            'status':'Pendiente',
                            'spackages':model.addpackages,
                            'Container':model.containers,
                            'HazardousFiles':model.containerFile,
                            'noperacion':model.noperacion,
                            'nmodalidad':model.nmodalidad,
                            'ntipoembarque':model.ntipoembarque,
                            'ninland':model.ninland,
                            'nrecoleccion':model.nrecoleccion,
                            'npickup':model.npickup,
                            'npol':model.npol,
                            'npod':model.npod,
                            'ndelivery':model.ndelivery,
                            'nentrega':model.nentrega,
                            'nmercancia':model.nmercancia,
                            'ncustoms':model.ncustoms,
                            'ninsurance':model.ninsurance,
                            'nvgm':model.nvgm,
                            'nmaneuvers':model.nmaneuvers,
                            'ncustody':model.ncustody,
                            'nobservaciones':model.nobservaciones,
                        },configuracion).then(function(response){
                            model.dialodload = false;
                            model.confirmacionsolicitud = false;
                            model.snackbar = true
                            model.mensaje ="Tarifa Solicitada Correctamente N°" + response.data;
                            model.limpiar();
                            model.listar();
                            model.nuevast = false;
                        }).catch(function(error){
                            model.snackbar = true               
                            model.mensaje = 'Error al guardar la solicitud. '+ error;
                            model.nuevast = false;
                        });
                    }
                } 
            }
        },
        validar(){
            this.valida=0;
            this.validaMensaje=[];
            var selecciona = 'Please select';
            var entra = false;
            if(!this.editBS.idbasis){
                selecciona = "Basis,";
                entra = true;
            }
            if(!this.editBS.idtipoOp){
                selecciona = selecciona + ' Operation Type,';
                entra = true;
            } 
            if(this.indl == true){
                if(!this.editBS.idinland){
                    selecciona = selecciona + ' Inland,';
                    entra = true;
                }
                if(!this.editBS.dentrofbl ){
                    selecciona = selecciona + ' Dentro o fuera de B/L,';
                    entra = true;
                }
            }
            if(!this.editBS.idcustumer){
                selecciona = selecciona + ' Customer,';
                entra = true;
            }
            if(this.indl == true){
                if(!this.editBS.idportreceipt && !this.editBS.idportdelivery){
                    selecciona = selecciona + ' Port Receipt or Delivery,';
                    entra = true;
                }
            }
            if(this.editBS.idportreceipt != 0 && this.editBS.idportreceipt != 26){
                if(this.addressreceipt == '' ){
                    selecciona = selecciona + ' Addres receipt,';
                    entra = true;
                }
            }

            if(this.editBS.idportdelivery != 0 && this.editBS.idportdelivery != 26){
                if(this.addressdelivery == ''){
                    selecciona = selecciona + ' Addres delivery,';
                    entra = true;
                }
            }
            if(entra == true){
                this.valida=1;
                window.alert(selecciona)
            }             
             return this.valida;

        },
        listartarifag(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.tarifas = [];
            me.tarifadeliver = [];
            me.tarifapickup = [];
            me.principalview = [];
            var arrayt = [];
            var consulta;
            var ni = 0;
            if(this.editBS.basis == 'LTL' || this.editBS.basis == 'LCL' || this.editBS.basis == 'AEREO'){
                consulta = 'api/tarifaContainers/ListarContainersUsersLCLuser/';
            }else{
                consulta = 'api/tarifaContainers/ListarContainersUsers/';
            }
            
                axios.get(consulta + id ,configuracion).then(function(response){                
                    arrayt= response.data;
                    setTimeout(function(){
                        arrayt.map(function(x){
                            ni = ni + 1;
                            if(x.descripcion == 'Delivery'){
                                me.deliveryview = true;
                                me.tarifadeliver.push({
                                    vigencia:x.vigencia,
                                    tipe:x.tipe,
                                    tarifaAd:x.tarifaAd,
                                    rate:x.rate,
                                    observaciones:x.observaciones,
                                    nrate:x.nrate,
                                    nidprovider:x.nidprovider,
                                    idscotizacion:x.idscotizacion,
                                    idprovider:x.idprovider,
                                    idlistarifarate:x.idlistarifarate,
                                    idcontainer:x.idcontainer,
                                    idagent:x.idagent,
                                    idsize:x.idsize,
                                    size:x.size,
                                    idtype:x.idtype,
                                    type:x.type,
                                    general:x.general,
                                    freedaysorigin:x.freedaysorigin,
                                    freedasydestination:x.freedasydestination,
                                    fechavigencia:x.fechavigencia,
                                    exclusivo:x.exclusivo,
                                    ex:x.ex,
                                    descripcion:x.descripcion,
                                    rol:x.rol,
                                    quantity:x.quantity,
                                    activo:x.activo
                                });
                            }
                            if(x.descripcion == 'Inland Freight' || x.descripcion == 'Ocean Freight' || x.descripcion == 'Air Freight'){
                                me.principalview = true;
                                me.tarifas.push({
                                    vigencia:x.vigencia,
                                    tipe:x.tipe,
                                    tarifaAd:x.tarifaAd,
                                    rate:x.rate,
                                    observaciones:x.observaciones,
                                    nrate:x.nrate,
                                    nidprovider:x.nidprovider,
                                    idscotizacion:x.idscotizacion,
                                    idprovider:x.idprovider,
                                    idlistarifarate:x.idlistarifarate,
                                    idcontainer:x.idcontainer,
                                    idagent:x.idagent,
                                    idsize:x.idsize,
                                    size:x.size,
                                    idtype:x.idtype,
                                    type:x.type,
                                    general:x.general,
                                    freedaysorigin:x.freedaysorigin,
                                    freedasydestination:x.freedasydestination,
                                    fechavigencia:x.fechavigencia,
                                    exclusivo:x.exclusivo,
                                    ex:x.ex,
                                    descripcion:x.descripcion,
                                    rol:x.rol,
                                    quantity:x.quantity,
                                    activo:x.activo
                                });
                            }
                            if(x.descripcion == 'Pickup'){
                                me.recoleccionview = true;
                                me.tarifapickup.push({
                                    vigencia:x.vigencia,
                                    tipe:x.tipe,
                                    tarifaAd:x.tarifaAd,
                                    rate:x.rate,
                                    observaciones:x.observaciones,
                                    nrate:x.nrate,
                                    nidprovider:x.nidprovider,
                                    idscotizacion:x.idscotizacion,
                                    idprovider:x.idprovider,
                                    idlistarifarate:x.idlistarifarate,
                                    idcontainer:x.idcontainer,
                                    idagent:x.idagent,
                                    idsize:x.idsize,
                                    size:x.size,
                                    idtype:x.idtype,
                                    type:x.type,
                                    general:x.general,
                                    freedaysorigin:x.freedaysorigin,
                                    freedasydestination:x.freedasydestination,
                                    fechavigencia:x.fechavigencia,
                                    exclusivo:x.exclusivo,
                                    ex:x.ex,
                                    descripcion:x.descripcion,
                                    rol:x.rol,
                                    quantity:x.quantity,
                                    activo:x.activo
                                });
                            }
                            if(arrayt.length == ni){
                                me.dialodload = false;
                                me.dialog3 = true;
                            }
                        });
                    },0 | Math.random() * 2500);
                    if(arrayt.length == 0){
                        me.dialodload = false;
                        me.dialog3 = true;
                    }
                    me.listartarifasAdicionales(id)
                    
                }).catch(function(error){
                    console.log(error);
                });
        },
        listartarifasAdicionales(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var aditional = [];
            me.customs = [];
            me.adicionalfees = [];
            me.viewadicional = false;
            me.viewcustom = false;
            axios.get('api/Listarifarates/ListarTarifa/' + id ,configuracion).then(function(response){   
                aditional= response.data;
                aditional.map(function(x){
                    if(x.charge != 'Customs'){
                        me.viewadicional = true;
                        me.adicionalfees.push({
                            charge:x.charge,
                            concept:x.concept,
                            idlistarifarate:x.idlistarifarate,
                            idmoneda:x.idmoneda,
                            idprovider:x.idprovider,
                            idscotizacion:x.idscotizacion,
                            iva:x.iva,
                            moneda:x.moneda,
                            per:x.per,
                            provider:x.provider,
                            rate:x.rate,
                            remarks:x.remarks,
                            status:x.status,
                            activo:x.activo,
                        });
                    }else{
                        me.viewcustom = true;
                        me.customs.push({
                            charge:x.charge,
                            concept:x.concept,
                            idlistarifarate:x.idlistarifarate,
                            idmoneda:x.idmoneda,
                            idprovider:x.idprovider,
                            idscotizacion:x.idscotizacion,
                            iva:x.iva,
                            moneda:x.moneda,
                            per:x.per,
                            provider:x.provider,
                            rate:x.rate,
                            remarks:x.remarks,
                            status:x.status,
                            activo:x.activo,
                        });
                    }
                })
            }).catch(function(error){
                console.log(error);
            });
        },
        limpiar(){
                this.addressdelivery = '';
                this.addressreceipt = '';
                this.editBS.clas = '';
                this.editBS.un = '';
                this.editBS.freedaysorigin = '';
                this.optionsbuttonagent = [];
                this.editBS.freedaysdest = '';
                this.editBS.foodgrade = '';
                this.editBS.idmodalidad = 0;
                this.editBS.idbasis= 0;
                this.editBS.idtipoOp = 0;
                this.editBS.idinland = 0;
                this.optionsbutton = [];
                this.editBS.idcustumer = 0;
                this.editBS.btcredit = [];
                this.editBS.creditDays = 0;
                this.editBS.comodity = '';
                this.editBS.fahscode = '';
                this.editBS.btnhazardous = [];
                this.editBS.hazardous = '';
                this.editBS.idprovider = 0;
                this.editBS.qt = '';
                this.editBS.idportreceipt = 26;
                this.editBS.datereceipt = null;
                this.editBS.idportloading = 26;
                this.editBS.idportdischarge = 26;
                this.editBS.idportdelivery = 26;
                this.editBS.datedeliviry = null;
                this.editBS.freedaysoriginB = 0;
                this.editBS.freedaysoriginS = 0;
                this.editBS.idvessel = 0;
                this.editBS.voyage = '';
                this.editBS.freedaysdestB = 0;
                this.editBS.freedaysdestS = 0;
                this.editBS.fechaeta = null;
                this.editBS.fechaetd = null;
                this.editBS.remarks = '';
                this.editBS.idagent = 0;
                this.containers = [];
                this.addpackages = [];
                this.editBS.indland = '';
                this.indl = false;
                this.inland = false;
                this.editedIndexScot =-1;
                this.editBS.ncotizacion = '';
                this.containerFile = [];
                this.totalwn = 0;
                this.volumenwn = 0;
                this.generarcot = false;
                this.cotguardada = false;
                this.remarkstextc = [];
                this.nuevast = false;
                this.editBS.dentrofbl = 0;


                this.subtotalmxn = 0;
                this.ivamxn = 0;
                this.totalmxn = 0;
                this.nsubtotalmxn = 0;
                this.nivamxn = 0;
                this.ntotalmxn = 0;
                this.activomxn = false;


                this.subtotalusd = 0;
                this.ivausd = 0;
                this.totalusd = 0;
                this.nsubtotalusd = 0;
                this.nivausd = 0;
                this.ntotalusd = 0;
                this.activousd = false;
        },
        mostrarhazardous(){
            if(this.harz == true){
                this.harz=false;
            }
            else{
                this.harz=true;
            }
        },
        mostrarinland(){
            if(this.indl == true){
                this.indl = false;
                this.inland = false;
            }
            else{
                this.indl = true;
                this.inland = true;
            }
        },
        formatDate(date){
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        agreagarcontainer(){
            if(this.editcontainer.quantity  <= 0 || this.editcontainer.size <= 0 || this.editcontainer.type <= 0 || this.editcontainer.weight <= 0){
                console.log("llenar campos");
            }else{
                if (this.editedIndexcon > -1) {
                    Object.assign(this.containers[this.editedIndexcon], this.editcontainer)
                } else {
                    this.containers.push({
                        quantity:this.editcontainer.quantity,
                        size:`${this.editcontainer.size.text}`,
                        idsize:this.editcontainer.size.value,
                        type:`${this.editcontainer.type.text}`,
                        idtype:this.editcontainer.type.value,
                        weight:this.editcontainer.weight,
                    })
                }
            }
        },
        agregar(){     
            
           if(this.editcontainer.quantity  <= 0 || this.editcontainer.size.value <= 0 || this.editcontainer.type.value   <= 0 || this.editcontainer.weight <= 0 ){
                alert("Favor de llenar todos los campos");
            }else{
                    var weight;
                    var indexmasa = 0;
                    var peso = 0;

                    if(this.editcontainer.peso.value == undefined){
                        indexmasa = this.Masa.findIndex(x=>x.value == this.editcontainer.peso );
                        peso = this.editcontainer.peso;
                    }else{
                        indexmasa = this.Masa.findIndex(x=>x.value == this.editcontainer.peso.value );
                        peso = this.editcontainer.peso.value;
                    }
                    var idmasa = this.Masa[indexmasa].idclave;

                    if(idmasa == 'KL1'){//Toneladas a Kilogramos
                        weight = parseFloat(this.editcontainer.weight).toFixed(2); 
                    }
                    if(idmasa == 'TN1'){//Toneladas a Kilogramos
                        weight = parseFloat(this.editcontainer.weight * 1000).toFixed(2); 
                    }
                    if(idmasa == 'GR1'){//Gramos a Kilogramos
                        weight = parseFloat(this.editcontainer.weight / 1000).toFixed(2); 
                    }
                    if(idmasa == 'LI1'){//Libras a Kilogramos
                        weight = parseFloat(this.editcontainer.weight * 0.453592).toFixed(2); 
                    }

                    var totalw ;
                    totalw = weight * this.editcontainer.quantity;
               if (this.editedIndexc > -1) {
                   var size = '';
                   var type = '';
                   var idsize = '';
                   var idtype = '';
                   if(this.editcontainer.idsize.text == undefined){
                       size = this.editcontainer.size;
                       idsize = this.editcontainer.idsize;
                   }else{
                       size = `${this.editcontainer.idsize.text}`;
                       idsize = this.editcontainer.idsize.value;
                   }
                   if(this.editcontainer.idtype.text == undefined){
                       type = this.editcontainer.type;
                       idtype = this.editcontainer.idtype;
                   }else{
                       type = `${this.editcontainer.idtype.text}`;
                       idtype = this.editcontainer.idtype.value;
                   }
                    Object.assign(this.containers[this.editedIndexc], {
                        idcontainer:this.editcontainer.idcontainer,
                        quantity:this.editcontainer.quantity,
                        size:size,
                        idsize:idsize,
                        type:type,
                        idtype:idtype,
                        weight:this.editcontainer.weight,
                        nweight:this.addCommas(weight) +' Kg.',
                        totalweight:this.addCommas(totalw) + ' Kg.',
                        remarks:'',
                        idunidadmasa:peso,
                        activo:true,
                    });
                    this.editedIndexc = -1;
                    this.limpiarContainer();
                } else {
                    this.containers.push({
                        idcontainer:0,
                        quantity:this.editcontainer.quantity,
                        size:`${this.editcontainer.idsize.text}`,
                        idsize:this.editcontainer.idsize.value,
                        type:`${this.editcontainer.idtype.text}`,
                        idtype:this.editcontainer.idtype.value,
                        weight:this.editcontainer.weight,
                        nweight:this.addCommas(weight) +' Kg.',
                        totalweight:this.addCommas(totalw) + ' Kg.',
                        remarks:'',
                        idunidadmasa:peso,
                        activo:true,
                    })  
                    this.limpiarContainer();
                }
           }
        },
        agregarpackage(){
            if(this.editpackage.quantity <= 0 || this.editpackage.idpackage == ''){
                console.log("Validado");
            }else{
                    var packagetext;
                    var stackable;
                    if(this.editpackage.idpackage.value == undefined){
                        if(this.editpackage.idpackage == 1002){
                            packagetext = this.editpackage.otropackage;
                        }else{
                            packagetext = this.editpackage.package;
                        }
                    }else{
                        if(this.editpackage.idpackage.value == 1002){
                            packagetext = this.editpackage.otro;
                        }else{
                            packagetext = `${this.editpackage.idpackage.text}`;
                        }
                    }
                    
                    if(this.editpackage.stackable == 'yes'){
                        stackable = 1;
                    }else{
                        stackable = 0;
                    }

                    var longitud;
                    var nlongitud;
                    var masa;
                    var nmasa;
                    var weight = 0;
                    var large;
                    var high;
                    var width;
                    var indexmasa;
                    var indexlongitud;
                    var peso;
                    var longitud;
                    if(this.editpackage.peso.value == undefined){
                        indexmasa = this.Masa.findIndex(x=>x.value == this.editpackage.peso);
                        peso = this.editpackage.peso;
                    }else{
                        indexmasa = this.Masa.findIndex(x=>x.value == this.editpackage.peso.value);
                        peso = this.editpackage.peso.value;
                    }
                    var idmasa = this.Masa[indexmasa].idclave;


                    if(this.editpackage.longitud.value == undefined){
                        indexlongitud = this.Longitud.findIndex(x=>x.value == this.editpackage.longitud);
                        longitud = this.editpackage.longitud;
                    }else{
                        indexlongitud = this.Longitud.findIndex(x=>x.value == this.editpackage.longitud.value);
                        longitud = this.editpackage.longitud.value;
                    }
                    var idlongitud = this.Longitud[indexlongitud].idclave;

                    //conversio longitud metros
                    if(idlongitud == 'MT1'){
                        large = this.editpackage.large;
                        width = this.editpackage.width;
                        high = this.editpackage.high;
                    }
                     if(idlongitud == 'CM1' ){ //Centimetros a Metros
                        large = parseFloat(this.editpackage.large / 100).toFixed(2);
                        width = parseFloat(this.editpackage.width / 100).toFixed(2);
                        high = parseFloat(this.editpackage.high / 100).toFixed(2);
                    }
                    if(idlongitud == 'PI1'){ //Pies a Metros
                        large = parseFloat(this.editpackage.large / 3.28084).toFixed(2);
                        width = parseFloat(this.editpackage.width / 3.28084).toFixed(2);
                        high = parseFloat(this.editpackage.high / 3.28084).toFixed(2);
                    }
                    if(idlongitud == 'PU1'){ //Pies a Metros
                        large = parseFloat(this.editpackage.large / 39.3701).toFixed(2);
                        width = parseFloat(this.editpackage.width / 39.3701).toFixed(2);
                        high = parseFloat(this.editpackage.high / 39.3701).toFixed(2);
                    }
                    //conversion peso a kilogramos.
                    if(idmasa == 'KL1'){//Toneladas a Kilogramos
                        weight = parseFloat(this.editpackage.weight).toFixed(2); 
                    }
                    if(idmasa == 'TN1'){//Toneladas a Kilogramos
                        weight = parseFloat(this.editpackage.weight * 1000).toFixed(2); 
                    }
                    if(idmasa == 'GR1'){//Gramos a Kilogramos
                        weight = parseFloat(this.editpackage.weight / 1000).toFixed(2); 
                    }
                    if(idmasa == 'LI1'){//Libras a Kilogramos
                        weight = parseFloat(this.editpackage.weight * 0.453592).toFixed(2); 
                    }
                 /*   if(this.editpackage.longitud.value == undefined){

                    }
                    if(this.editpackage.longitud.value == undefined){
                        if(this.editpackage.longitud == 1){
                            large = this.editpackage.large;
                            width = this.editpackage.width;
                            high = this.editpackage.high;
                        }
                    }else{
                        if(this.editpackage.longitud.value == 1){
                            large = this.editpackage.large;
                            width = this.editpackage.width;
                            high = this.editpackage.high;
                        }
                    }
                    if(this.editpackage.peso.value == undefined){
                        if(this.editpackage.peso == 1){
                            weight = this.editpackage.weight
                        }
                    }else{
                        if(this.editpackage.peso.value == 1){
                            weight = this.editpackage.weight
                        }
                    }*/
                    
                   /* if(this.editpackage.longitud.value == undefined){
                        if(this.editpackage.longitud == 4 ){ //Centimetros a Metros
                            large = parseFloat(this.editpackage.large / 100).toFixed(2);
                            width = parseFloat(this.editpackage.width / 100).toFixed(2);
                            high = parseFloat(this.editpackage.high / 100).toFixed(2);
                        }
                    }else{
                        if(this.editpackage.longitud.value == 4 ){ //Centimetros a Metros
                            large = parseFloat(this.editpackage.large / 100).toFixed(2);
                            width = parseFloat(this.editpackage.width / 100).toFixed(2);
                            high = parseFloat(this.editpackage.high / 100).toFixed(2);
                        }   
                    }
                    
                    if(this.editpackage.longitud.value == undefined){
                        if(this.editpackage.longitud == 2){ //Pies a Metros
                            large = parseFloat(this.editpackage.large / 3.28084).toFixed(2);
                            width = parseFloat(this.editpackage.width / 3.28084).toFixed(2);
                            high = parseFloat(this.editpackage.high / 3.28084).toFixed(2);
                        }
                    }else{
                        if(this.editpackage.longitud.value == 2){ //Pies a Metros
                            large = parseFloat(this.editpackage.large / 3.28084).toFixed(2);
                            width = parseFloat(this.editpackage.width / 3.28084).toFixed(2);
                            high = parseFloat(this.editpackage.high / 3.28084).toFixed(2);
                        }
                    }

                    if(this.editpackage.longitud.value == undefined){
                        if(this.editpackage.longitud == 3){ //Pies a Metros
                            large = parseFloat(this.editpackage.large / 39.3701).toFixed(2);
                            width = parseFloat(this.editpackage.width / 39.3701).toFixed(2);
                            high = parseFloat(this.editpackage.high / 39.3701).toFixed(2);
                        }
                    }else{
                        if(this.editpackage.longitud.value == 3){ //Pies a Metros
                            large = parseFloat(this.editpackage.large / 39.3701).toFixed(2);
                            width = parseFloat(this.editpackage.width / 39.3701).toFixed(2);
                            high = parseFloat(this.editpackage.high / 39.3701).toFixed(2);
                        }
                    }
                    
                    if(this.editpackage.peso.value == undefined){
                        if(this.editpackage.peso == 2){//Toneladas a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 1000).toFixed(2); 
                        }
                        if(this.editpackage.peso == 4){//Libras a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 0.453592).toFixed(2); 
                        }
                        if(this.editpackage.peso == 5){//Centimetros a Kilogramos
                            weight = parseFloat(this.editpackage.weight / 1000).toFixed(2); 
                        }
                    }else{
                        if(this.editpackage.peso.value == 2){//Toneladas a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 1000).toFixed(2); 
                        }
                        if(this.editpackage.peso.value == 4){//Libras a Kilogramos
                            weight = parseFloat(this.editpackage.weight * 0.453592).toFixed(2); 
                        }
                        if(this.editpackage.peso.value == 5){//Libras a Kilogramos
                            weight = parseFloat(this.editpackage.weight / 1000).toFixed(2); 
                        }
                    }*/
                    
                    var pwidth = width;
                    var plarge = large;
                    var phigh = high;
                    var pesovolumetrico;
                    var pesovolcompleto;

                    if(this.editBS.idbasis == 5){
                        pwidth = Number(width) * 100;
                        plarge = Number(large) * 100;
                        phigh = Number(high) * 100;

                        pesovolumetrico = ((Number(pwidth) * Number(plarge)) * Number(phigh)) / 6000;
                        pesovolumetrico = Number(pesovolumetrico) * Number(this.editpackage.quantity);
                        this.volumenwn = parseFloat(Number(this.volumenwn) + Number(pesovolumetrico)).toFixed(2);
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Kg.';

                    }else{
                        pwidth = width;
                        plarge = large;
                        phigh = high;

                        pesovolumetrico = ((Number(pwidth) * Number(plarge)) * Number(phigh));
                        pesovolumetrico = Number(pesovolumetrico) * Number(this.editpackage.quantity);
                        this.volumenwn = parseFloat(Number(this.volumenwn) + Number(pesovolumetrico)).toFixed(2);
                        pesovolcompleto = parseFloat(pesovolumetrico).toFixed(2) + ' Ton.';
                    }
                    var actualweight = Number(this.editpackage.quantity) * Number(weight);
                    this.totalwn = parseFloat(Number(this.totalwn) + Number(actualweight)).toFixed(2);
                if (this.editedIndexpack > -1) {
                    //var idlongitud;
                    //var peso;
                    var idpackage;
                   /* if(this.editpackage.longitud.value == undefined){
                        idlongitud =this.editpackage.longitud;
                    }else{
                        idlongitud =this.editpackage.longitud.value;
                    }
                    if(this.editpackage.peso.value == undefined){
                        peso = this.editpackage.peso;
                    }else{
                        peso = this.editpackage.peso.value;
                    }*/
                    if(this.editpackage.idpackage.value == undefined){
                        idpackage = this.editpackage.idpackage;
                    }else{
                        idpackage = this.editpackage.idpackage.value;
                    }
                    var idspackage = 0;
                    if(this.addpackages[this.editedIndexpack].idspackage != 0){
                        idspackage = this.addpackages[this.editedIndexpack].idspackage;
                    }

                    Object.assign(this.addpackages[this.editedIndexpack],{
                        idspackage:idspackage,
                        longitud: longitud,
                        idlongitud:longitud,
                        idpeso:peso,
                        stackable:stackable,
                        nstackable:this.editpackage.stackable,
                        weight:this.editpackage.weight,
                        nweight:this.addCommas(parseFloat(weight).toFixed(2)) + ' Kg.',
                        high:this.editpackage.high,
                        width:this.editpackage.width,
                        large:this.editpackage.large,
                        nhigh:high + ' Mts.',
                        nwidth:width + ' Mts.',
                        nlarge:large + ' Mts.',
                        volumetricweight:pesovolcompleto,
                        actualweight:this.addCommas(parseFloat(actualweight).toFixed(2)) + ' Kg.',
                        nactualweight:actualweight,
                        idpackage:idpackage,
                        quantity:this.editpackage.quantity,
                        package:packagetext,
                        Notes:this.editpackage.Notes,
                        otropackage:this.editpackage.otropackage,
                        pesovolumetrico:pesovolumetrico,
                        activo:true,
                    })
                } else {
                    this.addpackages.push({
                            longitud: `${this.editpackage.longitud.text}`,
                            idspackage:0,
                            idlongitud:this.editpackage.longitud.value,
                            idpeso:this.editpackage.peso.value,
                            stackable:stackable,
                            nstackable:this.editpackage.stackable,
                            weight:this.editpackage.weight,
                            nweight:this.addCommas(parseFloat(weight).toFixed(2)) + ' Kg.',
                            high:this.editpackage.high,
                            width:this.editpackage.width,
                            large:this.editpackage.large,
                            nhigh:high + ' Mts.',
                            nwidth:width + ' Mts.',
                            nlarge:large + ' Mts.',
                            volumetricweight:pesovolcompleto,
                            actualweight:this.addCommas(parseFloat(actualweight).toFixed(2)) + ' Kg.',
                            nactualweight:actualweight,
                            idpackage:this.editpackage.idpackage.value,
                            quantity:this.editpackage.quantity,
                            package:packagetext,
                            Notes:this.editpackage.Notes,
                            otropackage:this.editpackage.otropackage,
                            pesovolumetrico:pesovolumetrico,
                            activo:true,
                        })
                    }
                this.limpiarpackage();
            }
        },
        pesovoluen(){
            this.volumenwn = parseFloat(this.volumenwn + pesovolumetrico).toFixed(3);
            this.totalwn = this.totalwn + actualweight;

            //this.volumenwn = parseFloat(this.volumenwn).toFixed(3);
            this.totalwn = parseFloat(this.totalwn).toFixed(3);
        },
        limpiarpackage(){
            this.editpackage.longitud = {text:'Metro',value:1};
            this.editpackage.peso = {text:'Kilogramo',value:1};
            this.editpackage.stackable = '';
            this.editpackage.large = '';
            this.editpackage.width = '';
            this.editpackage.high = '';
            this.editpackage.weight  = '';
            this.editpackage.idpackage = '';
            this.editpackage.quantity = '';
            this.editpackage.Notes = '';
            this.editedIndexpack = -1;
            
        },
        limpiarContainer(){
            this.editcontainer.size = '';
            this.editcontainer.type = '';
            this.editcontainer.quantity = '';
            this.editcontainer.idsize = '';
            this.editcontainer.idtype = '';
            this.editcontainer.weight = '';
            this.editcontainer.remarks = '';
            this.editcontainer.peso.value = 1;
        },
        agregarbs(){    
            let model=this;  

           if (this.editedIndexbs > -1) {
                Object.assign(this.buysells[this.editedIndexbs],this.editedbuysell);
                this.limpiarcharge();
            } else {                                        

                var tipocambio = parseFloat(this.editedbuysell.rate).toFixed(2);                
                
                if(this.editedbuysell.idmoneda.text != 'USD'){
                    tipocambio = parseFloat(tipocambio / this.editedbuysell.idtipocambio).toFixed(2);
                }
                if(this.editedbuysell.idper == 'Prepaid'){
                    this.prepaid = tipocambio;
                }else{
                    this.collect = tipocambio;
                }

                if(`${this.editedbuysell.idiva.value}`== 'undefined'){
                    this.iva = 0;
                }else{
                    this.iva = parseFloat((parseFloat(`${this.editedbuysell.idiva.text}`)/100) * tipocambio);
                }
                
                var total = parseFloat(tipocambio) +  this.iva;                
                var ivag;
                var tamc;
                var tipoc;
                
                if(`${model.editedbuysell.idiva.value}`=='undefined'){
                    ivag = '2';    
                }else
                {
                    ivag = `${model.editedbuysell.idiva.value}`;
                }
                if(`${model.editedbuysell.idcontenedor.value}`=='undefined'){
                    tipoc = '15';    
                }else
                {
                    tipoc = `${model.editedbuysell.idcontenedor.value}`;
                }
                if(`${model.editedbuysell.idtamano.value}`=='undefined'){
                    tamc = '1002';    
                }else
                {
                    tamc = `${model.editedbuysell.idtamano.value}`;
                }
                if(model.editedbuysell.quantity == ''){
                    model.editedbuysell.quantity = 0;
                }

                if(this.editedbuysell.idinstance.text == 'Buy'){
                    this.buysellB.push({
                        buysell:`${this.editedbuysell.idinstance.text}`,
                        idinstance:`${this.editedbuysell.idinstance.value}`,
                        charge:`${this.editedbuysell.idcharge.text}`,
                        idcharge:`${this.editedbuysell.idcharge.value}`,
                        idprovider:`${this.editedbuysell.idprovider.value}`,
                        provider:`${this.editedbuysell.idprovider.text}`,
                        per:this.editedbuysell.payment,
                        idper:this.editedbuysell.idper,
                        payment:this.editedbuysell.payment,
                        idmoneda:`${this.editedbuysell.idmoneda.value}`,
                        moneda:`${this.editedbuysell.idmoneda.text}`,
                        prepaid:this.prepaid,
                        collect:this.collect,
                        notas:this.editedbuysell.notas,
                        idtamano:tamc,
                        tamanoc:`${this.editedbuysell.idtamano.text}`,
                        idcontenedor:tipoc,
                        tipoc:`${this.editedbuysell.idcontenedor.text}`,
                        idtipocambio:'2',
                        rate:this.editedbuysell.idtipocambio,
                        iva:parseFloat(this.iva).toFixed(2),
                        idiva:ivag,
                        quantity:this.editedbuysell.quantity,
                        total:parseFloat(total).toFixed(2), 
                    })
                    this.totalBuy= this.totalBuy + total;
                    this.idtotalbuy = this.totalBuy;
                }else{                    
                    this.buysells.push({
                        buysell:`${this.editedbuysell.idinstance.text}`,
                        idinstance:`${this.editedbuysell.idinstance.value}`,
                        charge:`${this.editedbuysell.idcharge.text}`,
                        idcharge:`${this.editedbuysell.idcharge.value}`,
                        idprovider:`${this.editedbuysell.idprovider.value}`,
                        provider:`${this.editedbuysell.idprovider.text}`,
                        per:this.editedbuysell.payment,
                        idper:this.editedbuysell.idper,
                        payment:this.editedbuysell.payment,
                        idmoneda:`${this.editedbuysell.idmoneda.value}`,
                        moneda:`${this.editedbuysell.idmoneda.text}`,
                        prepaid:this.prepaid,
                        collect:this.collect,
                        notas:this.editedbuysell.notas,
                        idtamano:tamc,
                        tamanoc:`${this.editedbuysell.idtamano.text}`,
                        idcontenedor:tipoc,
                        tipoc:`${this.editedbuysell.idcontenedor.text}`,
                        idtipocambio:'2',
                        rate:this.editedbuysell.idtipocambio,
                        iva:parseFloat(this.iva).toFixed(2),
                        idiva:ivag,
                        quantity:this.editedbuysell.quantity,
                        total:parseFloat(total).toFixed(2),      
                    })
                    this.totalSell = this.totalSell + total;
                    this.idtotalsell = this.totalSell;
                }
                this.idtotal = parseFloat(this.idtotalsell).toFixed(2) - parseFloat(this.idtotalbuy).toFixed(2);
                this.idtotal = parseFloat(this.idtotal).toFixed(2);
                this.limpiarcharge();
            }            
        },
        GuardarCharges(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                let model = this;       
                var ivag;
                var tamc;
                var tipoc;
                
                if(`${model.editedbuysell.idiva.value}`=='undefined'){
                    ivag = '2';    
                }else
                {
                    ivag = `${model.editedbuysell.idiva.value}`;
                }
                if(`${model.editedbuysell.idcontenedor.value}`=='undefined'){
                    tipoc = '15';    
                }else
                {
                    tipoc = `${model.editedbuysell.idcontenedor.value}`;
                }
                if(`${model.editedbuysell.idtamano.value}`=='undefined'){
                    tamc = '1002';    
                }else
                {
                    tamc = `${model.editedbuysell.idtamano.value}`;
                }
                if(model.editedbuysell.quantity == ''){
                    model.editedbuysell.quantity=0;
                }

            axios.post('api/ChargesBS/Crear',{                
                    'consecutivo':model.bsnum,    
                    'idinstance':  `${model.editedbuysell.idinstance.value}`,
                    'idcustomer':  model.editBS.idcustumer,
                    'idcharge': parseInt(`${model.editedbuysell.idcharge.value}`),
                    'idprovider': parseInt(`${model.editedbuysell.idprovider.value}`),
                    'idtipocambio': '1',
                    'idmoneda': `${model.editedbuysell.idmoneda.value}`,
                    'idiva': ivag,
                    'iva':parseFloat(model.iva).toFixed(2),
                    'total':model.idtotalbuy,
                    'prepaid': model.prepaid,
                    'collect': model.collect,
                    'payment': model.editedbuysell.payment,
                    'quantity': model.editedbuysell.quantity,
                    'idcontenedor': tipoc,
                    'idtamano': tamc,
                    'notas': model.editedbuysell.notas,
                },configuracion).then(function(response){
                    console.log('Guardado')
                }).catch(function(error){                                                
                    console.log(error); 
                });
        },
        editItem(item) {
            //console.log(item)
            this.editedIndexc = this.containers.indexOf(item)
            this.editcontainer.quantity = item.quantity;
            this.editcontainer.idsize = item.idsize;
            this.editcontainer.idtype =  item.idtype;
            this.editcontainer.weight = item.weight;
            this.editcontainer.size = item.size;
            this.editcontainer.type = item.type;
            this.editcontainer.idcontainer = item.idcontainer;
            this.editcontainer.peso.value = item.idunidadmasa;
        },
        deleteItemc(item){
           const index = this.containers.indexOf(item)
           var resp = confirm('Are you sure you want to delete this item?');
           if(resp == true){
                this.containers[index].activo = false;
           } 
        },
        limpiarcharge(){
            this.optionsbutton = [];
            this.editedbuysell.idinstance = 0;
            this.editedbuysell.idcharge = 0;
            this.editedbuysell.idprovider = 0;
            this.editedbuysell.idmoneda = 0;
            this.editedbuysell.rateex = 1;
            this.editedbuysell.rate = '';
            this.editedbuysell.idiva = 'NA';
            this.editedbuysell.idper = 'Prepaid';
            this.editedbuysell.payment = 'shipment';
            this.editedbuysell.quantity = '';
            this.editedbuysell.idtamanoc = 0;
            this.editedbuysell.idtipoc = 0;
            this.editedbuysell.notes = '';
            this.editedbuysell.prepaid = 0;
            this.editedbuysell.collect = 0;
            this.editedbuysell.total = 0;
            this.editedIndexbs = -1;
            this.prepaid = 0;
            this.collect = 0;
            
        },       
        NumCons(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let me=this;          
            var consecutivoArray = [];            
            axios.get('api/Consecutivos/Select',configuracion).then(function(response){            
                consecutivoArray=response.data;
                consecutivoArray.map(function(x){
                    me.consecutivo.push({text:x.consecutivo,value:x.idconsecutivo});                    
                });                      
            }).catch(function(error){
            console.log(error);
            });
        },
        consecutivos(){
            let me=this;
            var fecha = new Date();
            var year = fecha.getFullYear();
            me.cons = me.Numconsecutivo + 1;
            var ceros;
            if (me.cons <= 9) {
                ceros = "0000";
            }
            if (me.cons >= 99){
                ceros = "000";
            }
            if (me.cons >= 999) {
                ceros = "00";
            }
            if (me.cons >= 9999)
            {
                ceros = "0";                
            }
            if (me.cons >= 99999)
            {
                ceros = "";
            }
            me.bsnum = 'BS' + year + ceros + me.cons;
        },
        activaaereo(){
            this.aereo = false;
            if(this.editBS.idmodalidad == 2){
                this.aereo = true;
            }
        },
        activapa(){
            this.lclview = true;
            this.impaal = false;
        },
        activar(){
                this.PACKAGES = false;
                this.UNITS = false;
                this.CONTAINER = false;
                this.ftl = false;    
                this.activevgm = false;
                this.activecust = false;
                this.ftldate = true;
                this.inland = false;
                this.lclview = false;                
                this.impaal = false;
                this.custody = false;
                this.maneuvers = false;
                this.Nportdelivery='DELIVERY';
                this.Nportreceipt='Place of receipt / Pick Up '; 
                this.viewfood = false;
                this.daysview = false;

                if (this.editBS.idinland != 0) {
                    this.editBS.indland = 'inland'
                    this.indl = true;
                    this.inland = true;
                } 

            if(this.editBS.idbasis  == 5){
                this.PACKAGES = true;
                this.lclview = true; 
                this.daysview = true;
                this.Nportloading ='AOL';
                this.Nportdischarge = 'AOD';
                this.impaal = true;
            }
            if(this.editBS.idbasis  == 1){                
                this.CONTAINER = true;
                this.titlec ='CONTAINER';
                this.titleprov = 'Shipping Line';   
                this.Nportloading ='POL';
                this.Nportdischarge = 'POD';                  
                this.impaal = true;
            }            
            if(this.editBS.idbasis  == 2){
                this.PACKAGES = true;
                this.titleprov = 'Shipping Line';
                this.Nportloading ='POL';
                this.Nportdischarge = 'POD';                  
                this.daysview = true;
                this.impaal = true;
            }
            if(this.editBS.idbasis == 4 ){
                this.PACKAGES = true;
                this.viewfood = true;
                this.daysview = true;
                this.titleprov = 'Provider';
                this.maneuvers = true;
                this.ftl = true;
                this.daysview = true;
                this.inland = true;
                this.activevgm = true;
                this.ftldate = true;
            }
            if(this.editBS.idbasis  == 3){
                this.daysview = true;
                this.viewfood = true;
                this.maneuvers = true;
                this.CONTAINER = true;
                this.titlec ='UNITS';
                this.ftl = true;
                this.activevgm = true;
                this.titleprov = 'Shipping Line';
                this.ftldate = true;
                this.inland = true;
                this.custody = true;
            }            
        },
        mostrarotro(){
            if(this.editpackage.idpackage.value == 1002){
                this.packageotro = true;
            }else{
                this.packageotro = false;
            }
        },
        completar(){
            if(this.cop[this.CodigoPostal.value].adminName1 == 'Distrito Federal'){
                this.cop[this.CodigoPostal.value].adminName1 ='CDMX';
            }
            this.municipio= this.cop[this.CodigoPostal.value].adminName2 + ", " + this.cop[this.CodigoPostal.value].adminName1;
            this.estado = this.cop[this.CodigoPostal.value].adminName1;
        },
        completard(){    
            if(this.copr[this.CodigoPostalr.value].adminName1 == 'Distrito Federal'){
                this.copr[this.CodigoPostalr.value].adminName1 ='CDMX';
            }
            this.municipior = this.copr[this.CodigoPostalr.value].adminName2 + ", " + this.copr[this.CodigoPostalr.value].adminName1;
            this.estador = this.copr[this.CodigoPostalr.value].adminName1;
        },
        cargar(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            me.cop = [];
            me.copr = [];
            me.estado='';
            me.CodigoPostal = '';
            me.estador ='';
            me.CodigoPostalr = '';
            me.Codigos = [];
            me.Codigosr = [];
            var cp;
            var pais;

            if(this.dialogd == true){
                cp = me.cp;
                pais = me.pais.value;
            }
            if(this.dialogr == true){
                cp = me.cpr;
                pais = me.paisr.value;
            }
            axios.get('http://api.geonames.org/postalCodeLookupJSON?postalcode=' + cp + '&country=' + pais +'&username=isc.alejandro')
            .then(function(response){
                var i=0;
                if(me.dialogd == true){
                    me.cop = response.data.postalcodes;
                    me.cop.map(function(x){
                    me.Codigos.push({text:x.placeName,value:i}) 
                        i++;
                    });
                }
                if(me.dialogr == true){
                    me.copr = response.data.postalcodes;
                    me.copr.map(function(x){
                    me.Codigosr.push({text:x.placeName,value:i}) 
                        i++;
                    });
                }
                cosole.log(me.Codigos)
            }).catch(function(error){
                console.log(error);              
            });
        },
        completardireccion(){
            if(this.CodigoPostal !='' && this.pais != '' && this.municipio != ''){
                this.dialogd = false;
                this.addressreceipt = this.direccion + ", " + this.CodigoPostal.text + ", " + this.municipio + ", C.P. " + this.cp + ", " + this.pais.text;    
            }else{
                alert('Favor de llenar los campos obligatorios');
            }
            
        },
        completardireccionr(){
            if(this.CodigoPostalr !='' && this.paisr != '' && this.municipior != ''){
                this.dialogr = false;
                this.addressdelivery = this.direccionr + ", " + this.CodigoPostalr.text + ", " + this.municipior + ", C.P. " + this.cpr + ", " + this.paisr.text;
            }else{
                alert('Favor de llenar los campos obligatorios');
            }
        },
        addCommas(nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        nextStep (n) {
            if (n === this.steps) {
            this.e1 = 1
            } else {
            this.e1 = n + 1
            }
        },
        name(){
            return this.$store.state.usuario.nombre + ' ' + this.$store.state.usuario.apellido;
        },
        fechahoy(){
            const date = new Date()
            const dateTimeFormat = new Intl.DateTimeFormat('Mx', { year: 'numeric', month: 'long', day: '2-digit' }) 
            const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(date ) 
            this.fechaHoy = `${month} de ${day} del ${year }`;

            var d = new Date();
            this.fechav = d;
        },
        cargarremarks(){
            this.RemarksCotizacion = [];
            var remarkfcl = [];
            if(this.contizacioningles == 'INGLES'){
                this.disabledIva = true;
                this.remarkenabled = 6;
                this.bodyCot = 'Our quotation for the services requested is as follows';
                
                remarkfcl.push(
                    {text:'No maneuvers on Airport/Port included, these must be paid by the customs agent.',value:1},
                    {text:'All inlands are quoted in tandem (2 containers per truck)',value:2},
                    {text:'No customs maneuvers included.',value:3},
                    {text:'No customs storage included.',value:4},
                    {text:'No inspections included.',value:5},
                    //{text:'',value:6},
                    {text:'No custody included.',value:7},
                    {text:'No unloading/loading maneuvers included',value:8},
                    {text:'Free unloading time',value:9},
                    {text:'Rate based on the information provided.',value:10},
                    //{text:'Otro.',value:16}
                );
            }else{
                this.remarkenabled = 15;
                this.disabledIva = false;
                this.bodyCot = 'Me permito enviarle nuestra cotización';
                remarkfcl.push(
                    {text:'Los costos no incluyen maniobras.',value:1},
                    {text:'horas libres de carga.',value:2},
                    {text:'horas libres de descarga.',value:3},
                    {text:'días de crédito.',value:4},
                    {text:'Sujeto a disponibilidad de espacio y equipo.',value:5},
                    {text:'Incluye Carta Garantía.',value:6},
                    {text:'Los tiempos de tránsito son estimados. ',value:7},
                    {text:'Terrestre dentro de BL en servicio Full.',value:8},
                    {text:'Terrestre dentro de BL en servicio Sencillo.',value:9},
                    {text:'días libres de demoras en origen.',value:10},
                    {text:'días libres de demoras en destino.',value:11},
                    {text:'Costos para carga peligrosa.',value:12},
                    {text:'Costos para carga No peligrosa.',value:13},
                    {text:'Incluye gastos locales en origen.',value:14},
                    //{text:'',value:15},
                    //{text:'Otro.',value:16}
                );
            }
            this.RemarksCotizacion = remarkfcl;
        },
        mostrarfree(){
            if(this.remarklist.value == 10){
                this.remarksc = this.tarifas[this.selectedItem].freedaysorigin;
            }else if(this.remarklist.value == 11){
                this.remarksc = this.tarifas[this.selectedItem].freedasydestination;
            }  
        },
        mayusculas(e){
             e.value = e.value.toUpperCase();
        },
        enviarcorreocp(){
            let loader = Vue.$loading.show({color: '#189bec',loader: 'spinner'});
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;
            axios.post('api/Scotizaciones/EnviarMailCotizacion',{
              asunto:model.cpasunto,
              idusuario:model.$store.state.usuario.idusuario, 
              contenido:model.editorcp,
              nconsecutivo:model.folio,
              idcustumer:model.editBS.idcustumer,
              url:model.namecot,
              idscotizacion:model.idcotizacion,
              contactoscc:model.contactoscp,
            },configuracion).then(function(response){
                loader.hide()
                model.snackbar = true 
                model.mensaje = 'Correo enviado correctamente'
                model.dialog3=false;
            }).catch(function(error){
                loader.hide()                                                
                console.log(error); 
                model.snackbar = true
                model.mensaje = error
            });
        },
        activarcantidad(){
            if(this.chargecostopor.value == 1 || this.chargecostopor.value == 3 || this.chargecostopor.value == 4){
                this.activarc= false;
                this.chargecantidad = '';
            }else{
                this.activarc= true;
                this.chargecantidad = 1;
            }
        },
        editItempackage(item){
            this.editedIndexpack = this.addpackages.indexOf(item)
            if(item.stackable == true){
                this.editpackage.stackable = 'yes';
            }

            var large;
            var width;
            var high;

            var indexlongitud = this.Longitud.findIndex(x=>x.value == item.idlongitud);
            var idlongitud = this.Longitud[indexlongitud].idclave;
            
            if(idlongitud == 'MT1'){
                large = parseFloat(item.large).toFixed(2);
                width = parseFloat(item.width).toFixed(2);
                high = parseFloat(item.high).toFixed(2); 
            }           
            if(idlongitud == 'PI1'){ //Pies a Metros
                large = parseFloat(item.large * 3.28084).toFixed(2);
                width = parseFloat(item.width * 3.28084).toFixed(2);
                high = parseFloat(item.high * 3.28084).toFixed(2);
            }
            if(idlongitud == 'PU1'){ //Pies a Metros
                large = parseFloat(item.large * 39.3701).toFixed(2);
                width = parseFloat(item.width * 39.3701).toFixed(2);
                high = parseFloat(item.high * 39.3701).toFixed(2);
            }
            if(idlongitud == 'CM1' ){ //Centimetros a Metros
                large = parseFloat(item.large * 100).toFixed(2);
                width = parseFloat(item.width * 100).toFixed(2);
                high = parseFloat(item.high * 100).toFixed(2);
            }
            
            var indexmasa = this.Masa.findIndex(x=>x.value == item.idpeso);
            var idmasa = this.Masa[indexmasa].idclave;
            var weight = 0;

            weight = item.weight;
             Object.assign(this.editpackage,{
               Notes: item.Notes,
                activo: item.activo,
                actualweight: item.actualweight,
                high: item.high,
                idlongitud: item.idlongitud,
                idpackage: item.idpackage,
                idpeso:  item.idpeso,
                peso:item.idpeso,
                large:  item.large,
                longitud:  item.idlongitud,
                nhigh:  item.nhigh,
                nlarge:  item.nlarge,
                nstackable:  item.nstackable,
                nweight:  weight,
                nwidth:  item.nwidth,
                otropackage:  item.otropackage,
                package:  item.package,
                quantity:  item.quantity,
                stackable:  this.editpackage.stackable,
                volumetricweight:  item.volumetricweight,
                weight:  weight,
                width: item.width,
            });
            this.volumenwn = parseFloat(this.volumenwn - item.pesovolumetrico).toFixed(2);
            this.totalwn = parseFloat(Number(this.totalwn) - Number(item.nactualweight)).toFixed(2);
            if(this.volumenwn === NaN){
                this.volumenwn = 0;
            }
            if(this.totalwn == NaN){
                this.totalwn = 0;
            }
        },
        deleteItempackage(item) {
           const index = this.addpackages.indexOf(item)
           var eliminar=[];
           var resp = confirm('Are you sure you want to delete this package?');
           if(resp == true){
                this.addpackages[index].activo = false;
                this.volumenwn = parseFloat(Number(this.volumenwn) - Number(item.pesovolumetrico)).toFixed(2);
                this.totalwn = parseFloat(Number(this.totalwn) - Number(item.nactualweight)).toFixed(2);
                if(this.volumenwn == NaN){
                    this.volumenwn = 0;
                }
                if(this.totalwn == NaN){
                    this.totalwn = 0;
                }
           }
        },
        viewContacto(){
            this.dialog6 = true;
        },        
        editItemc(item) {
            this.editedIndex = this.contactos.indexOf(item)
            this.editcontact = Object.assign({}, item)
        },
        agregarcontacto(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;

            if(model.editcontact.nombre === '' || model.editcontact.correo === ''){        
                model.adModalcontact = true;
            }else
            {
                if (model.editedIndex > -1) {
                    Object.assign(model.contactos[model.editedIndex], model.editcontact)    
                    axios.put('api/Contactos/Actualizar',{
                        'idcontacto': model.editcontact.idcontacto,                            
                        'nombre': model.editcontact.nombre,
                        'puesto' : model.editcontact.puesto,                    
                        'telefono' : model.editcontact.telefono,
                        'celular' : model.editcontact.celular,
                        'correo' : model.editcontact.correo,
                        'idpropietario' : model.iddatos
                    },configuracion).then(function(response){                                                                       
                        model.editedIndex = -1;                            
                        model.limpiarC();
                        model.snackbar = true;
                        model.dialog6 = false; 
                        model.mensaje = 'Contacto Actualizado';
                        model.listarContacto(model.editBS.idcustumer);                                                    
                    }).catch(function(error){
                        console.log(error);
                    });  

                } else {  
                    model.contactos.push({
                        nombre:model.editcontact.nombre,
                        puesto:model.editcontact.puesto,
                        telefono:model.editcontact.telefono,
                        celular:model.editcontact.celular,
                        correo:model.editcontact.correo,
                        activo:1
                    })                      
                        axios.post('api/Contactos/Crear',{
                        'nombre': model.editcontact.nombre,
                        'puesto' : model.editcontact.puesto,                    
                        'telefono' : model.editcontact.telefono,
                        'celular' : model.editcontact.celular,
                        'correo' : model.editcontact.correo,
                        'propietario' : 'Pros',
                        'idpropietario' : model.editBS.idcustumer
                    },configuracion).then(function(response){                                  
                        model.limpiarC();
                        model.snackbar = true;
                        model.dialog6 = false; 
                        model.mensaje = 'Contacto guardado  ' 
                        model.listarContacto(model.editBS.idcustumer);
                    }).catch(function(error){                                                
                        console.log(error); 
                    });          
                }
                model.limpiarC();
            }
        },
        limpiarC(){
            this.editcontact.nombre = "";
            this.editcontact.puesto = "";
            this.editcontact.telefono= "";
            this.editcontact.celular = "";
            this.editcontact.correo = "";        
            this.editedIndex = -1;
        },
        notificationpuertosbase(){
            var indexpol = this.ports.findIndex(x=>x.value == this.editBS.idportloading);
            if(this.ports[indexpol].text == 'PUERTOS BASE'){
                //window.alert('entra')
                this.alertpuertosbase = true;
            }
        },
        /**-----------------------------------------**/
        ListarInformacionCot(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            if(me.editBS.idbasis == 2){
                var indexremark = me.remarkstextc.findIndex(x=>x.idremark == 100 & x.activo == true);
                me.remarkstextc[indexremark].activo = false;
                me.lclviewremarks= false;
            }
            
            axios.get('api/Cotizaciones/ListarEditCot/'+ me.idcotizacion,configuracion).then(function(response){                
                me.CotizacionesDatos=response.data;
                //console.log('Informacion de cotizacion')
                //console.log(me.CotizacionesDatos)
                //me.editItemCotizacion(me.CotizacionesDatos)
            }).catch(function(error){
                console.log(error);
            });
        },
        editItemCotizacion(item){
            this.nsubtotalusd = 0;
            this.nivausd = 0;
            this.ntotalusd = 0;
            this.nsubtotalmxn = 0;
            this.nivamxn = 0;
            this.ntotalmxn = 0;
            this.limpiarcotizacion();
            this.limpiarcostos();
            this.productotext = item.producto;
            this.origentext = item.origen;
            this.cuerpo = item.body;
            this.destinotext = item.destino;
            this.serviciotext = item.servicio;
            this.viatext = item.via;
            this.tttext = item.tt;
            this.Movimientotext = item.movimiento;
            this.modalidadtext2 = item.modalidad;
            this.dateval = item.vigencia;
            this.idcustumer = item.idcustumer;
            this.ncotizacion = item.ncotizacion;
            this.ncustumre = item.ncustumer;
            this.folio = item.folio;
            this.basis = item.basis;
            this.idcotizacion = item.idcotizacion;
            this.transbordo = item.transbordo;
            this.listarContacto(item.idcustumer);
            this.listarconceptos(item.idcotizacion);
            this.tarifasenviadas(item.idcotizacion);
            this.listartarifag(item.idcotizacion);
            this.InfoCot = true;     
        },
        Cancelar(){
            var resp = confirm('Está seguro de que desea Cancelar la solicitud '+ this.editBS.ncotizacion + '?');
            if(resp == true){
                let me=this;
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                console.log('this.idcotizacion')
                console.log(this.editBS.idscotizacion)
                axios.put('api/Scotizaciones/Desactivar/' + this.editBS.idscotizacion,{},configuracion).then(function(response){
                    axios.post('api/Scotizaciones/NotificarCancelacion',{
                        idusuario:me.$store.state.usuario.idusuario, 
                        Nnotificacion:me.editBS.ncotizacion,
                        notificaAgente:me.editBS.notificaAgente,
                        notificaPricing:me.editBS.notificaPricing,
                        notificaLocal:me.editBS.notificaLocal
                    },configuracion).then(function(response){
                        me.limpiar();
                        me.listar(); 
                        me.snackbar = true 
                        me.mensaje = 'Correo enviado correctamente'
                        me.dialog3=false;
                    }).catch(function(error){                                         
                        console.log(error); 
                        me.snackbar = true
                        me.mensaje = error
                    });
                }).catch(function(error){
                    console.log(error);
                });  
            }
        },
        reactivar(){
            var resp = confirm('Está seguro de que desea Reactivar la solicitud '+ this.editBS.ncotizacion + '?');
            if(resp == true){
                let me=this;
                let header={"Authorization" : "Bearer " + this.$store.state.token};
                let configuracion ={headers:header};
                axios.put('api/Scotizaciones/Reactivar/' + this.editBS.idscotizacion,{},configuracion).then(function(response){
                    me.limpiar();
                    me.listar();
                }).catch(function(error){
                    console.log(error);
                });  
            }
        },
        
    }
}
</script>
